import { jsx as P, jsxs as J, Fragment as Wt } from "react/jsx-runtime";
import { useMemo as xr } from "react";
function wr(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
function Sr(u) {
  if (Object.prototype.hasOwnProperty.call(u, "__esModule")) return u;
  var x = u.default;
  if (typeof x == "function") {
    var m = function f() {
      var l = !1;
      try {
        l = this instanceof f;
      } catch {
      }
      return l ? Reflect.construct(x, arguments, this.constructor) : x.apply(this, arguments);
    };
    m.prototype = x.prototype;
  } else m = {};
  return Object.defineProperty(m, "__esModule", { value: !0 }), Object.keys(u).forEach(function(f) {
    var l = Object.getOwnPropertyDescriptor(u, f);
    Object.defineProperty(m, f, l.get ? l : {
      enumerable: !0,
      get: function() {
        return u[f];
      }
    });
  }), m;
}
var ee = {}, te = {}, Qe = {}, ue = {}, Ce = {}, Zt;
function Er() {
  return Zt || (Zt = 1, Object.defineProperty(Ce, "__esModule", { value: !0 }), Ce.default = new Uint16Array(
    // prettier-ignore
    'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(u) {
      return u.charCodeAt(0);
    })
  )), Ce;
}
var Ie = {}, Xt;
function Tr() {
  return Xt || (Xt = 1, Object.defineProperty(Ie, "__esModule", { value: !0 }), Ie.default = new Uint16Array(
    // prettier-ignore
    "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(u) {
      return u.charCodeAt(0);
    })
  )), Ie;
}
var Ye = {}, Jt;
function Qt() {
  return Jt || (Jt = 1, (function(u) {
    var x;
    Object.defineProperty(u, "__esModule", { value: !0 }), u.replaceCodePoint = u.fromCodePoint = void 0;
    var m = /* @__PURE__ */ new Map([
      [0, 65533],
      // C1 Unicode control character reference replacements
      [128, 8364],
      [130, 8218],
      [131, 402],
      [132, 8222],
      [133, 8230],
      [134, 8224],
      [135, 8225],
      [136, 710],
      [137, 8240],
      [138, 352],
      [139, 8249],
      [140, 338],
      [142, 381],
      [145, 8216],
      [146, 8217],
      [147, 8220],
      [148, 8221],
      [149, 8226],
      [150, 8211],
      [151, 8212],
      [152, 732],
      [153, 8482],
      [154, 353],
      [155, 8250],
      [156, 339],
      [158, 382],
      [159, 376]
    ]);
    u.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
    (x = String.fromCodePoint) !== null && x !== void 0 ? x : function(p) {
      var a = "";
      return p > 65535 && (p -= 65536, a += String.fromCharCode(p >>> 10 & 1023 | 55296), p = 56320 | p & 1023), a += String.fromCharCode(p), a;
    };
    function f(p) {
      var a;
      return p >= 55296 && p <= 57343 || p > 1114111 ? 65533 : (a = m.get(p)) !== null && a !== void 0 ? a : p;
    }
    u.replaceCodePoint = f;
    function l(p) {
      return (0, u.fromCodePoint)(f(p));
    }
    u.default = l;
  })(Ye)), Ye;
}
var Yt;
function Ue() {
  return Yt || (Yt = 1, (function(u) {
    var x = ue && ue.__createBinding || (Object.create ? (function(T, q, I, R) {
      R === void 0 && (R = I);
      var N = Object.getOwnPropertyDescriptor(q, I);
      (!N || ("get" in N ? !q.__esModule : N.writable || N.configurable)) && (N = { enumerable: !0, get: function() {
        return q[I];
      } }), Object.defineProperty(T, R, N);
    }) : (function(T, q, I, R) {
      R === void 0 && (R = I), T[R] = q[I];
    })), m = ue && ue.__setModuleDefault || (Object.create ? (function(T, q) {
      Object.defineProperty(T, "default", { enumerable: !0, value: q });
    }) : function(T, q) {
      T.default = q;
    }), f = ue && ue.__importStar || function(T) {
      if (T && T.__esModule) return T;
      var q = {};
      if (T != null) for (var I in T) I !== "default" && Object.prototype.hasOwnProperty.call(T, I) && x(q, T, I);
      return m(q, T), q;
    }, l = ue && ue.__importDefault || function(T) {
      return T && T.__esModule ? T : { default: T };
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.decodeXML = u.decodeHTMLStrict = u.decodeHTMLAttribute = u.decodeHTML = u.determineBranch = u.EntityDecoder = u.DecodingMode = u.BinTrieFlags = u.fromCodePoint = u.replaceCodePoint = u.decodeCodePoint = u.xmlDecodeTree = u.htmlDecodeTree = void 0;
    var p = l(/* @__PURE__ */ Er());
    u.htmlDecodeTree = p.default;
    var a = l(/* @__PURE__ */ Tr());
    u.xmlDecodeTree = a.default;
    var d = f(/* @__PURE__ */ Qt());
    u.decodeCodePoint = d.default;
    var b = /* @__PURE__ */ Qt();
    Object.defineProperty(u, "replaceCodePoint", { enumerable: !0, get: function() {
      return b.replaceCodePoint;
    } }), Object.defineProperty(u, "fromCodePoint", { enumerable: !0, get: function() {
      return b.fromCodePoint;
    } });
    var i;
    (function(T) {
      T[T.NUM = 35] = "NUM", T[T.SEMI = 59] = "SEMI", T[T.EQUALS = 61] = "EQUALS", T[T.ZERO = 48] = "ZERO", T[T.NINE = 57] = "NINE", T[T.LOWER_A = 97] = "LOWER_A", T[T.LOWER_F = 102] = "LOWER_F", T[T.LOWER_X = 120] = "LOWER_X", T[T.LOWER_Z = 122] = "LOWER_Z", T[T.UPPER_A = 65] = "UPPER_A", T[T.UPPER_F = 70] = "UPPER_F", T[T.UPPER_Z = 90] = "UPPER_Z";
    })(i || (i = {}));
    var r = 32, c;
    (function(T) {
      T[T.VALUE_LENGTH = 49152] = "VALUE_LENGTH", T[T.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", T[T.JUMP_TABLE = 127] = "JUMP_TABLE";
    })(c = u.BinTrieFlags || (u.BinTrieFlags = {}));
    function e(T) {
      return T >= i.ZERO && T <= i.NINE;
    }
    function t(T) {
      return T >= i.UPPER_A && T <= i.UPPER_F || T >= i.LOWER_A && T <= i.LOWER_F;
    }
    function o(T) {
      return T >= i.UPPER_A && T <= i.UPPER_Z || T >= i.LOWER_A && T <= i.LOWER_Z || e(T);
    }
    function y(T) {
      return T === i.EQUALS || o(T);
    }
    var g;
    (function(T) {
      T[T.EntityStart = 0] = "EntityStart", T[T.NumericStart = 1] = "NumericStart", T[T.NumericDecimal = 2] = "NumericDecimal", T[T.NumericHex = 3] = "NumericHex", T[T.NamedEntity = 4] = "NamedEntity";
    })(g || (g = {}));
    var n;
    (function(T) {
      T[T.Legacy = 0] = "Legacy", T[T.Strict = 1] = "Strict", T[T.Attribute = 2] = "Attribute";
    })(n = u.DecodingMode || (u.DecodingMode = {}));
    var h = (
      /** @class */
      (function() {
        function T(q, I, R) {
          this.decodeTree = q, this.emitCodePoint = I, this.errors = R, this.state = g.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = n.Strict;
        }
        return T.prototype.startEntity = function(q) {
          this.decodeMode = q, this.state = g.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
        }, T.prototype.write = function(q, I) {
          switch (this.state) {
            case g.EntityStart:
              return q.charCodeAt(I) === i.NUM ? (this.state = g.NumericStart, this.consumed += 1, this.stateNumericStart(q, I + 1)) : (this.state = g.NamedEntity, this.stateNamedEntity(q, I));
            case g.NumericStart:
              return this.stateNumericStart(q, I);
            case g.NumericDecimal:
              return this.stateNumericDecimal(q, I);
            case g.NumericHex:
              return this.stateNumericHex(q, I);
            case g.NamedEntity:
              return this.stateNamedEntity(q, I);
          }
        }, T.prototype.stateNumericStart = function(q, I) {
          return I >= q.length ? -1 : (q.charCodeAt(I) | r) === i.LOWER_X ? (this.state = g.NumericHex, this.consumed += 1, this.stateNumericHex(q, I + 1)) : (this.state = g.NumericDecimal, this.stateNumericDecimal(q, I));
        }, T.prototype.addToNumericResult = function(q, I, R, N) {
          if (I !== R) {
            var U = R - I;
            this.result = this.result * Math.pow(N, U) + parseInt(q.substr(I, U), N), this.consumed += U;
          }
        }, T.prototype.stateNumericHex = function(q, I) {
          for (var R = I; I < q.length; ) {
            var N = q.charCodeAt(I);
            if (e(N) || t(N))
              I += 1;
            else
              return this.addToNumericResult(q, R, I, 16), this.emitNumericEntity(N, 3);
          }
          return this.addToNumericResult(q, R, I, 16), -1;
        }, T.prototype.stateNumericDecimal = function(q, I) {
          for (var R = I; I < q.length; ) {
            var N = q.charCodeAt(I);
            if (e(N))
              I += 1;
            else
              return this.addToNumericResult(q, R, I, 10), this.emitNumericEntity(N, 2);
          }
          return this.addToNumericResult(q, R, I, 10), -1;
        }, T.prototype.emitNumericEntity = function(q, I) {
          var R;
          if (this.consumed <= I)
            return (R = this.errors) === null || R === void 0 || R.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          if (q === i.SEMI)
            this.consumed += 1;
          else if (this.decodeMode === n.Strict)
            return 0;
          return this.emitCodePoint((0, d.replaceCodePoint)(this.result), this.consumed), this.errors && (q !== i.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
        }, T.prototype.stateNamedEntity = function(q, I) {
          for (var R = this.decodeTree, N = R[this.treeIndex], U = (N & c.VALUE_LENGTH) >> 14; I < q.length; I++, this.excess++) {
            var j = q.charCodeAt(I);
            if (this.treeIndex = S(R, N, this.treeIndex + Math.max(1, U), j), this.treeIndex < 0)
              return this.result === 0 || // If we are parsing an attribute
              this.decodeMode === n.Attribute && // We shouldn't have consumed any characters after the entity,
              (U === 0 || // And there should be no invalid characters.
              y(j)) ? 0 : this.emitNotTerminatedNamedEntity();
            if (N = R[this.treeIndex], U = (N & c.VALUE_LENGTH) >> 14, U !== 0) {
              if (j === i.SEMI)
                return this.emitNamedEntityData(this.treeIndex, U, this.consumed + this.excess);
              this.decodeMode !== n.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
            }
          }
          return -1;
        }, T.prototype.emitNotTerminatedNamedEntity = function() {
          var q, I = this, R = I.result, N = I.decodeTree, U = (N[R] & c.VALUE_LENGTH) >> 14;
          return this.emitNamedEntityData(R, U, this.consumed), (q = this.errors) === null || q === void 0 || q.missingSemicolonAfterCharacterReference(), this.consumed;
        }, T.prototype.emitNamedEntityData = function(q, I, R) {
          var N = this.decodeTree;
          return this.emitCodePoint(I === 1 ? N[q] & ~c.VALUE_LENGTH : N[q + 1], R), I === 3 && this.emitCodePoint(N[q + 2], R), R;
        }, T.prototype.end = function() {
          var q;
          switch (this.state) {
            case g.NamedEntity:
              return this.result !== 0 && (this.decodeMode !== n.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case g.NumericDecimal:
              return this.emitNumericEntity(0, 2);
            case g.NumericHex:
              return this.emitNumericEntity(0, 3);
            case g.NumericStart:
              return (q = this.errors) === null || q === void 0 || q.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            case g.EntityStart:
              return 0;
          }
        }, T;
      })()
    );
    u.EntityDecoder = h;
    function v(T) {
      var q = "", I = new h(T, function(R) {
        return q += (0, d.fromCodePoint)(R);
      });
      return function(N, U) {
        for (var j = 0, z = 0; (z = N.indexOf("&", z)) >= 0; ) {
          q += N.slice(j, z), I.startEntity(U);
          var W = I.write(
            N,
            // Skip the "&"
            z + 1
          );
          if (W < 0) {
            j = z + I.end();
            break;
          }
          j = z + W, z = W === 0 ? j + 1 : j;
        }
        var Z = q + N.slice(j);
        return q = "", Z;
      };
    }
    function S(T, q, I, R) {
      var N = (q & c.BRANCH_LENGTH) >> 7, U = q & c.JUMP_TABLE;
      if (N === 0)
        return U !== 0 && R === U ? I : -1;
      if (U) {
        var j = R - U;
        return j < 0 || j >= N ? -1 : T[I + j] - 1;
      }
      for (var z = I, W = z + N - 1; z <= W; ) {
        var Z = z + W >>> 1, ne = T[Z];
        if (ne < R)
          z = Z + 1;
        else if (ne > R)
          W = Z - 1;
        else
          return T[Z + N];
      }
      return -1;
    }
    u.determineBranch = S;
    var s = v(p.default), w = v(a.default);
    function E(T, q) {
      return q === void 0 && (q = n.Legacy), s(T, q);
    }
    u.decodeHTML = E;
    function A(T) {
      return s(T, n.Attribute);
    }
    u.decodeHTMLAttribute = A;
    function L(T) {
      return s(T, n.Strict);
    }
    u.decodeHTMLStrict = L;
    function D(T) {
      return w(T, n.Strict);
    }
    u.decodeXML = D;
  })(ue)), ue;
}
var Kt;
function ur() {
  return Kt || (Kt = 1, (function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.QuoteType = void 0;
    var x = /* @__PURE__ */ Ue(), m;
    (function(e) {
      e[e.Tab = 9] = "Tab", e[e.NewLine = 10] = "NewLine", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationMark = 33] = "ExclamationMark", e[e.Number = 35] = "Number", e[e.Amp = 38] = "Amp", e[e.SingleQuote = 39] = "SingleQuote", e[e.DoubleQuote = 34] = "DoubleQuote", e[e.Dash = 45] = "Dash", e[e.Slash = 47] = "Slash", e[e.Zero = 48] = "Zero", e[e.Nine = 57] = "Nine", e[e.Semi = 59] = "Semi", e[e.Lt = 60] = "Lt", e[e.Eq = 61] = "Eq", e[e.Gt = 62] = "Gt", e[e.Questionmark = 63] = "Questionmark", e[e.UpperA = 65] = "UpperA", e[e.LowerA = 97] = "LowerA", e[e.UpperF = 70] = "UpperF", e[e.LowerF = 102] = "LowerF", e[e.UpperZ = 90] = "UpperZ", e[e.LowerZ = 122] = "LowerZ", e[e.LowerX = 120] = "LowerX", e[e.OpeningSquareBracket = 91] = "OpeningSquareBracket";
    })(m || (m = {}));
    var f;
    (function(e) {
      e[e.Text = 1] = "Text", e[e.BeforeTagName = 2] = "BeforeTagName", e[e.InTagName = 3] = "InTagName", e[e.InSelfClosingTag = 4] = "InSelfClosingTag", e[e.BeforeClosingTagName = 5] = "BeforeClosingTagName", e[e.InClosingTagName = 6] = "InClosingTagName", e[e.AfterClosingTagName = 7] = "AfterClosingTagName", e[e.BeforeAttributeName = 8] = "BeforeAttributeName", e[e.InAttributeName = 9] = "InAttributeName", e[e.AfterAttributeName = 10] = "AfterAttributeName", e[e.BeforeAttributeValue = 11] = "BeforeAttributeValue", e[e.InAttributeValueDq = 12] = "InAttributeValueDq", e[e.InAttributeValueSq = 13] = "InAttributeValueSq", e[e.InAttributeValueNq = 14] = "InAttributeValueNq", e[e.BeforeDeclaration = 15] = "BeforeDeclaration", e[e.InDeclaration = 16] = "InDeclaration", e[e.InProcessingInstruction = 17] = "InProcessingInstruction", e[e.BeforeComment = 18] = "BeforeComment", e[e.CDATASequence = 19] = "CDATASequence", e[e.InSpecialComment = 20] = "InSpecialComment", e[e.InCommentLike = 21] = "InCommentLike", e[e.BeforeSpecialS = 22] = "BeforeSpecialS", e[e.SpecialStartSequence = 23] = "SpecialStartSequence", e[e.InSpecialTag = 24] = "InSpecialTag", e[e.BeforeEntity = 25] = "BeforeEntity", e[e.BeforeNumericEntity = 26] = "BeforeNumericEntity", e[e.InNamedEntity = 27] = "InNamedEntity", e[e.InNumericEntity = 28] = "InNumericEntity", e[e.InHexEntity = 29] = "InHexEntity";
    })(f || (f = {}));
    function l(e) {
      return e === m.Space || e === m.NewLine || e === m.Tab || e === m.FormFeed || e === m.CarriageReturn;
    }
    function p(e) {
      return e === m.Slash || e === m.Gt || l(e);
    }
    function a(e) {
      return e >= m.Zero && e <= m.Nine;
    }
    function d(e) {
      return e >= m.LowerA && e <= m.LowerZ || e >= m.UpperA && e <= m.UpperZ;
    }
    function b(e) {
      return e >= m.UpperA && e <= m.UpperF || e >= m.LowerA && e <= m.LowerF;
    }
    var i;
    (function(e) {
      e[e.NoValue = 0] = "NoValue", e[e.Unquoted = 1] = "Unquoted", e[e.Single = 2] = "Single", e[e.Double = 3] = "Double";
    })(i = u.QuoteType || (u.QuoteType = {}));
    var r = {
      Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
      CdataEnd: new Uint8Array([93, 93, 62]),
      CommentEnd: new Uint8Array([45, 45, 62]),
      ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
      StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
      TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
      // `</title`
    }, c = (
      /** @class */
      (function() {
        function e(t, o) {
          var y = t.xmlMode, g = y === void 0 ? !1 : y, n = t.decodeEntities, h = n === void 0 ? !0 : n;
          this.cbs = o, this.state = f.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = f.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = g, this.decodeEntities = h, this.entityTrie = g ? x.xmlDecodeTree : x.htmlDecodeTree;
        }
        return e.prototype.reset = function() {
          this.state = f.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = f.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
        }, e.prototype.write = function(t) {
          this.offset += this.buffer.length, this.buffer = t, this.parse();
        }, e.prototype.end = function() {
          this.running && this.finish();
        }, e.prototype.pause = function() {
          this.running = !1;
        }, e.prototype.resume = function() {
          this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
        }, e.prototype.getIndex = function() {
          return this.index;
        }, e.prototype.getSectionStart = function() {
          return this.sectionStart;
        }, e.prototype.stateText = function(t) {
          t === m.Lt || !this.decodeEntities && this.fastForwardTo(m.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = f.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && t === m.Amp && (this.state = f.BeforeEntity);
        }, e.prototype.stateSpecialStartSequence = function(t) {
          var o = this.sequenceIndex === this.currentSequence.length, y = o ? (
            // If we are at the end of the sequence, make sure the tag name has ended
            p(t)
          ) : (
            // Otherwise, do a case-insensitive comparison
            (t | 32) === this.currentSequence[this.sequenceIndex]
          );
          if (!y)
            this.isSpecial = !1;
          else if (!o) {
            this.sequenceIndex++;
            return;
          }
          this.sequenceIndex = 0, this.state = f.InTagName, this.stateInTagName(t);
        }, e.prototype.stateInSpecialTag = function(t) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (t === m.Gt || l(t)) {
              var o = this.index - this.currentSequence.length;
              if (this.sectionStart < o) {
                var y = this.index;
                this.index = o, this.cbs.ontext(this.sectionStart, o), this.index = y;
              }
              this.isSpecial = !1, this.sectionStart = o + 2, this.stateInClosingTagName(t);
              return;
            }
            this.sequenceIndex = 0;
          }
          (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === r.TitleEnd ? this.decodeEntities && t === m.Amp && (this.state = f.BeforeEntity) : this.fastForwardTo(m.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(t === m.Lt);
        }, e.prototype.stateCDATASequence = function(t) {
          t === r.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === r.Cdata.length && (this.state = f.InCommentLike, this.currentSequence = r.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = f.InDeclaration, this.stateInDeclaration(t));
        }, e.prototype.fastForwardTo = function(t) {
          for (; ++this.index < this.buffer.length + this.offset; )
            if (this.buffer.charCodeAt(this.index - this.offset) === t)
              return !0;
          return this.index = this.buffer.length + this.offset - 1, !1;
        }, e.prototype.stateInCommentLike = function(t) {
          t === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === r.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = f.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : t !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
        }, e.prototype.isTagStartChar = function(t) {
          return this.xmlMode ? !p(t) : d(t);
        }, e.prototype.startSpecial = function(t, o) {
          this.isSpecial = !0, this.currentSequence = t, this.sequenceIndex = o, this.state = f.SpecialStartSequence;
        }, e.prototype.stateBeforeTagName = function(t) {
          if (t === m.ExclamationMark)
            this.state = f.BeforeDeclaration, this.sectionStart = this.index + 1;
          else if (t === m.Questionmark)
            this.state = f.InProcessingInstruction, this.sectionStart = this.index + 1;
          else if (this.isTagStartChar(t)) {
            var o = t | 32;
            this.sectionStart = this.index, !this.xmlMode && o === r.TitleEnd[2] ? this.startSpecial(r.TitleEnd, 3) : this.state = !this.xmlMode && o === r.ScriptEnd[2] ? f.BeforeSpecialS : f.InTagName;
          } else t === m.Slash ? this.state = f.BeforeClosingTagName : (this.state = f.Text, this.stateText(t));
        }, e.prototype.stateInTagName = function(t) {
          p(t) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = f.BeforeAttributeName, this.stateBeforeAttributeName(t));
        }, e.prototype.stateBeforeClosingTagName = function(t) {
          l(t) || (t === m.Gt ? this.state = f.Text : (this.state = this.isTagStartChar(t) ? f.InClosingTagName : f.InSpecialComment, this.sectionStart = this.index));
        }, e.prototype.stateInClosingTagName = function(t) {
          (t === m.Gt || l(t)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = f.AfterClosingTagName, this.stateAfterClosingTagName(t));
        }, e.prototype.stateAfterClosingTagName = function(t) {
          (t === m.Gt || this.fastForwardTo(m.Gt)) && (this.state = f.Text, this.baseState = f.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateBeforeAttributeName = function(t) {
          t === m.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = f.InSpecialTag, this.sequenceIndex = 0) : this.state = f.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : t === m.Slash ? this.state = f.InSelfClosingTag : l(t) || (this.state = f.InAttributeName, this.sectionStart = this.index);
        }, e.prototype.stateInSelfClosingTag = function(t) {
          t === m.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = f.Text, this.baseState = f.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : l(t) || (this.state = f.BeforeAttributeName, this.stateBeforeAttributeName(t));
        }, e.prototype.stateInAttributeName = function(t) {
          (t === m.Eq || p(t)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = f.AfterAttributeName, this.stateAfterAttributeName(t));
        }, e.prototype.stateAfterAttributeName = function(t) {
          t === m.Eq ? this.state = f.BeforeAttributeValue : t === m.Slash || t === m.Gt ? (this.cbs.onattribend(i.NoValue, this.index), this.state = f.BeforeAttributeName, this.stateBeforeAttributeName(t)) : l(t) || (this.cbs.onattribend(i.NoValue, this.index), this.state = f.InAttributeName, this.sectionStart = this.index);
        }, e.prototype.stateBeforeAttributeValue = function(t) {
          t === m.DoubleQuote ? (this.state = f.InAttributeValueDq, this.sectionStart = this.index + 1) : t === m.SingleQuote ? (this.state = f.InAttributeValueSq, this.sectionStart = this.index + 1) : l(t) || (this.sectionStart = this.index, this.state = f.InAttributeValueNq, this.stateInAttributeValueNoQuotes(t));
        }, e.prototype.handleInAttributeValue = function(t, o) {
          t === o || !this.decodeEntities && this.fastForwardTo(o) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(o === m.DoubleQuote ? i.Double : i.Single, this.index), this.state = f.BeforeAttributeName) : this.decodeEntities && t === m.Amp && (this.baseState = this.state, this.state = f.BeforeEntity);
        }, e.prototype.stateInAttributeValueDoubleQuotes = function(t) {
          this.handleInAttributeValue(t, m.DoubleQuote);
        }, e.prototype.stateInAttributeValueSingleQuotes = function(t) {
          this.handleInAttributeValue(t, m.SingleQuote);
        }, e.prototype.stateInAttributeValueNoQuotes = function(t) {
          l(t) || t === m.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(i.Unquoted, this.index), this.state = f.BeforeAttributeName, this.stateBeforeAttributeName(t)) : this.decodeEntities && t === m.Amp && (this.baseState = this.state, this.state = f.BeforeEntity);
        }, e.prototype.stateBeforeDeclaration = function(t) {
          t === m.OpeningSquareBracket ? (this.state = f.CDATASequence, this.sequenceIndex = 0) : this.state = t === m.Dash ? f.BeforeComment : f.InDeclaration;
        }, e.prototype.stateInDeclaration = function(t) {
          (t === m.Gt || this.fastForwardTo(m.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = f.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateInProcessingInstruction = function(t) {
          (t === m.Gt || this.fastForwardTo(m.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = f.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateBeforeComment = function(t) {
          t === m.Dash ? (this.state = f.InCommentLike, this.currentSequence = r.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = f.InDeclaration;
        }, e.prototype.stateInSpecialComment = function(t) {
          (t === m.Gt || this.fastForwardTo(m.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = f.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateBeforeSpecialS = function(t) {
          var o = t | 32;
          o === r.ScriptEnd[3] ? this.startSpecial(r.ScriptEnd, 4) : o === r.StyleEnd[3] ? this.startSpecial(r.StyleEnd, 4) : (this.state = f.InTagName, this.stateInTagName(t));
        }, e.prototype.stateBeforeEntity = function(t) {
          this.entityExcess = 1, this.entityResult = 0, t === m.Number ? this.state = f.BeforeNumericEntity : t === m.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = f.InNamedEntity, this.stateInNamedEntity(t));
        }, e.prototype.stateInNamedEntity = function(t) {
          if (this.entityExcess += 1, this.trieIndex = (0, x.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, t), this.trieIndex < 0) {
            this.emitNamedEntity(), this.index--;
            return;
          }
          this.trieCurrent = this.entityTrie[this.trieIndex];
          var o = this.trieCurrent & x.BinTrieFlags.VALUE_LENGTH;
          if (o) {
            var y = (o >> 14) - 1;
            if (!this.allowLegacyEntity() && t !== m.Semi)
              this.trieIndex += y;
            else {
              var g = this.index - this.entityExcess + 1;
              g > this.sectionStart && this.emitPartial(this.sectionStart, g), this.entityResult = this.trieIndex, this.trieIndex += y, this.entityExcess = 0, this.sectionStart = this.index + 1, y === 0 && this.emitNamedEntity();
            }
          }
        }, e.prototype.emitNamedEntity = function() {
          if (this.state = this.baseState, this.entityResult !== 0) {
            var t = (this.entityTrie[this.entityResult] & x.BinTrieFlags.VALUE_LENGTH) >> 14;
            switch (t) {
              case 1: {
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~x.BinTrieFlags.VALUE_LENGTH);
                break;
              }
              case 2: {
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
              }
              case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
            }
          }
        }, e.prototype.stateBeforeNumericEntity = function(t) {
          (t | 32) === m.LowerX ? (this.entityExcess++, this.state = f.InHexEntity) : (this.state = f.InNumericEntity, this.stateInNumericEntity(t));
        }, e.prototype.emitNumericEntity = function(t) {
          var o = this.index - this.entityExcess - 1, y = o + 2 + +(this.state === f.InHexEntity);
          y !== this.index && (o > this.sectionStart && this.emitPartial(this.sectionStart, o), this.sectionStart = this.index + Number(t), this.emitCodePoint((0, x.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
        }, e.prototype.stateInNumericEntity = function(t) {
          t === m.Semi ? this.emitNumericEntity(!0) : a(t) ? (this.entityResult = this.entityResult * 10 + (t - m.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, e.prototype.stateInHexEntity = function(t) {
          t === m.Semi ? this.emitNumericEntity(!0) : a(t) ? (this.entityResult = this.entityResult * 16 + (t - m.Zero), this.entityExcess++) : b(t) ? (this.entityResult = this.entityResult * 16 + ((t | 32) - m.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, e.prototype.allowLegacyEntity = function() {
          return !this.xmlMode && (this.baseState === f.Text || this.baseState === f.InSpecialTag);
        }, e.prototype.cleanup = function() {
          this.running && this.sectionStart !== this.index && (this.state === f.Text || this.state === f.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === f.InAttributeValueDq || this.state === f.InAttributeValueSq || this.state === f.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
        }, e.prototype.shouldContinue = function() {
          return this.index < this.buffer.length + this.offset && this.running;
        }, e.prototype.parse = function() {
          for (; this.shouldContinue(); ) {
            var t = this.buffer.charCodeAt(this.index - this.offset);
            switch (this.state) {
              case f.Text: {
                this.stateText(t);
                break;
              }
              case f.SpecialStartSequence: {
                this.stateSpecialStartSequence(t);
                break;
              }
              case f.InSpecialTag: {
                this.stateInSpecialTag(t);
                break;
              }
              case f.CDATASequence: {
                this.stateCDATASequence(t);
                break;
              }
              case f.InAttributeValueDq: {
                this.stateInAttributeValueDoubleQuotes(t);
                break;
              }
              case f.InAttributeName: {
                this.stateInAttributeName(t);
                break;
              }
              case f.InCommentLike: {
                this.stateInCommentLike(t);
                break;
              }
              case f.InSpecialComment: {
                this.stateInSpecialComment(t);
                break;
              }
              case f.BeforeAttributeName: {
                this.stateBeforeAttributeName(t);
                break;
              }
              case f.InTagName: {
                this.stateInTagName(t);
                break;
              }
              case f.InClosingTagName: {
                this.stateInClosingTagName(t);
                break;
              }
              case f.BeforeTagName: {
                this.stateBeforeTagName(t);
                break;
              }
              case f.AfterAttributeName: {
                this.stateAfterAttributeName(t);
                break;
              }
              case f.InAttributeValueSq: {
                this.stateInAttributeValueSingleQuotes(t);
                break;
              }
              case f.BeforeAttributeValue: {
                this.stateBeforeAttributeValue(t);
                break;
              }
              case f.BeforeClosingTagName: {
                this.stateBeforeClosingTagName(t);
                break;
              }
              case f.AfterClosingTagName: {
                this.stateAfterClosingTagName(t);
                break;
              }
              case f.BeforeSpecialS: {
                this.stateBeforeSpecialS(t);
                break;
              }
              case f.InAttributeValueNq: {
                this.stateInAttributeValueNoQuotes(t);
                break;
              }
              case f.InSelfClosingTag: {
                this.stateInSelfClosingTag(t);
                break;
              }
              case f.InDeclaration: {
                this.stateInDeclaration(t);
                break;
              }
              case f.BeforeDeclaration: {
                this.stateBeforeDeclaration(t);
                break;
              }
              case f.BeforeComment: {
                this.stateBeforeComment(t);
                break;
              }
              case f.InProcessingInstruction: {
                this.stateInProcessingInstruction(t);
                break;
              }
              case f.InNamedEntity: {
                this.stateInNamedEntity(t);
                break;
              }
              case f.BeforeEntity: {
                this.stateBeforeEntity(t);
                break;
              }
              case f.InHexEntity: {
                this.stateInHexEntity(t);
                break;
              }
              case f.InNumericEntity: {
                this.stateInNumericEntity(t);
                break;
              }
              default:
                this.stateBeforeNumericEntity(t);
            }
            this.index++;
          }
          this.cleanup();
        }, e.prototype.finish = function() {
          this.state === f.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
        }, e.prototype.handleTrailingData = function() {
          var t = this.buffer.length + this.offset;
          this.state === f.InCommentLike ? this.currentSequence === r.CdataEnd ? this.cbs.oncdata(this.sectionStart, t, 0) : this.cbs.oncomment(this.sectionStart, t, 0) : this.state === f.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === f.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === f.InTagName || this.state === f.BeforeAttributeName || this.state === f.BeforeAttributeValue || this.state === f.AfterAttributeName || this.state === f.InAttributeName || this.state === f.InAttributeValueSq || this.state === f.InAttributeValueDq || this.state === f.InAttributeValueNq || this.state === f.InClosingTagName || this.cbs.ontext(this.sectionStart, t);
        }, e.prototype.emitPartial = function(t, o) {
          this.baseState !== f.Text && this.baseState !== f.InSpecialTag ? this.cbs.onattribdata(t, o) : this.cbs.ontext(t, o);
        }, e.prototype.emitCodePoint = function(t) {
          this.baseState !== f.Text && this.baseState !== f.InSpecialTag ? this.cbs.onattribentity(t) : this.cbs.ontextentity(t);
        }, e;
      })()
    );
    u.default = c;
  })(Qe)), Qe;
}
var $t;
function eu() {
  if ($t) return te;
  $t = 1;
  var u = te && te.__createBinding || (Object.create ? (function(g, n, h, v) {
    v === void 0 && (v = h);
    var S = Object.getOwnPropertyDescriptor(n, h);
    (!S || ("get" in S ? !n.__esModule : S.writable || S.configurable)) && (S = { enumerable: !0, get: function() {
      return n[h];
    } }), Object.defineProperty(g, v, S);
  }) : (function(g, n, h, v) {
    v === void 0 && (v = h), g[v] = n[h];
  })), x = te && te.__setModuleDefault || (Object.create ? (function(g, n) {
    Object.defineProperty(g, "default", { enumerable: !0, value: n });
  }) : function(g, n) {
    g.default = n;
  }), m = te && te.__importStar || function(g) {
    if (g && g.__esModule) return g;
    var n = {};
    if (g != null) for (var h in g) h !== "default" && Object.prototype.hasOwnProperty.call(g, h) && u(n, g, h);
    return x(n, g), n;
  };
  Object.defineProperty(te, "__esModule", { value: !0 }), te.Parser = void 0;
  var f = m(/* @__PURE__ */ ur()), l = /* @__PURE__ */ Ue(), p = /* @__PURE__ */ new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
  ]), a = /* @__PURE__ */ new Set(["p"]), d = /* @__PURE__ */ new Set(["thead", "tbody"]), b = /* @__PURE__ */ new Set(["dd", "dt"]), i = /* @__PURE__ */ new Set(["rt", "rp"]), r = /* @__PURE__ */ new Map([
    ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
    ["th", /* @__PURE__ */ new Set(["th"])],
    ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
    ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
    ["li", /* @__PURE__ */ new Set(["li"])],
    ["p", a],
    ["h1", a],
    ["h2", a],
    ["h3", a],
    ["h4", a],
    ["h5", a],
    ["h6", a],
    ["select", p],
    ["input", p],
    ["output", p],
    ["button", p],
    ["datalist", p],
    ["textarea", p],
    ["option", /* @__PURE__ */ new Set(["option"])],
    ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
    ["dd", b],
    ["dt", b],
    ["address", a],
    ["article", a],
    ["aside", a],
    ["blockquote", a],
    ["details", a],
    ["div", a],
    ["dl", a],
    ["fieldset", a],
    ["figcaption", a],
    ["figure", a],
    ["footer", a],
    ["form", a],
    ["header", a],
    ["hr", a],
    ["main", a],
    ["nav", a],
    ["ol", a],
    ["pre", a],
    ["section", a],
    ["table", a],
    ["ul", a],
    ["rt", i],
    ["rp", i],
    ["tbody", d],
    ["tfoot", d]
  ]), c = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]), e = /* @__PURE__ */ new Set(["math", "svg"]), t = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
  ]), o = /\s|\//, y = (
    /** @class */
    (function() {
      function g(n, h) {
        h === void 0 && (h = {});
        var v, S, s, w, E;
        this.options = h, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = n ?? {}, this.lowerCaseTagNames = (v = h.lowerCaseTags) !== null && v !== void 0 ? v : !h.xmlMode, this.lowerCaseAttributeNames = (S = h.lowerCaseAttributeNames) !== null && S !== void 0 ? S : !h.xmlMode, this.tokenizer = new ((s = h.Tokenizer) !== null && s !== void 0 ? s : f.default)(this.options, this), (E = (w = this.cbs).onparserinit) === null || E === void 0 || E.call(w, this);
      }
      return g.prototype.ontext = function(n, h) {
        var v, S, s = this.getSlice(n, h);
        this.endIndex = h - 1, (S = (v = this.cbs).ontext) === null || S === void 0 || S.call(v, s), this.startIndex = h;
      }, g.prototype.ontextentity = function(n) {
        var h, v, S = this.tokenizer.getSectionStart();
        this.endIndex = S - 1, (v = (h = this.cbs).ontext) === null || v === void 0 || v.call(h, (0, l.fromCodePoint)(n)), this.startIndex = S;
      }, g.prototype.isVoidElement = function(n) {
        return !this.options.xmlMode && c.has(n);
      }, g.prototype.onopentagname = function(n, h) {
        this.endIndex = h;
        var v = this.getSlice(n, h);
        this.lowerCaseTagNames && (v = v.toLowerCase()), this.emitOpenTag(v);
      }, g.prototype.emitOpenTag = function(n) {
        var h, v, S, s;
        this.openTagStart = this.startIndex, this.tagname = n;
        var w = !this.options.xmlMode && r.get(n);
        if (w)
          for (; this.stack.length > 0 && w.has(this.stack[this.stack.length - 1]); ) {
            var E = this.stack.pop();
            (v = (h = this.cbs).onclosetag) === null || v === void 0 || v.call(h, E, !0);
          }
        this.isVoidElement(n) || (this.stack.push(n), e.has(n) ? this.foreignContext.push(!0) : t.has(n) && this.foreignContext.push(!1)), (s = (S = this.cbs).onopentagname) === null || s === void 0 || s.call(S, n), this.cbs.onopentag && (this.attribs = {});
      }, g.prototype.endOpenTag = function(n) {
        var h, v;
        this.startIndex = this.openTagStart, this.attribs && ((v = (h = this.cbs).onopentag) === null || v === void 0 || v.call(h, this.tagname, this.attribs, n), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
      }, g.prototype.onopentagend = function(n) {
        this.endIndex = n, this.endOpenTag(!1), this.startIndex = n + 1;
      }, g.prototype.onclosetag = function(n, h) {
        var v, S, s, w, E, A;
        this.endIndex = h;
        var L = this.getSlice(n, h);
        if (this.lowerCaseTagNames && (L = L.toLowerCase()), (e.has(L) || t.has(L)) && this.foreignContext.pop(), this.isVoidElement(L))
          !this.options.xmlMode && L === "br" && ((S = (v = this.cbs).onopentagname) === null || S === void 0 || S.call(v, "br"), (w = (s = this.cbs).onopentag) === null || w === void 0 || w.call(s, "br", {}, !0), (A = (E = this.cbs).onclosetag) === null || A === void 0 || A.call(E, "br", !1));
        else {
          var D = this.stack.lastIndexOf(L);
          if (D !== -1)
            if (this.cbs.onclosetag)
              for (var T = this.stack.length - D; T--; )
                this.cbs.onclosetag(this.stack.pop(), T !== 0);
            else
              this.stack.length = D;
          else !this.options.xmlMode && L === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
        }
        this.startIndex = h + 1;
      }, g.prototype.onselfclosingtag = function(n) {
        this.endIndex = n, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = n + 1) : this.onopentagend(n);
      }, g.prototype.closeCurrentTag = function(n) {
        var h, v, S = this.tagname;
        this.endOpenTag(n), this.stack[this.stack.length - 1] === S && ((v = (h = this.cbs).onclosetag) === null || v === void 0 || v.call(h, S, !n), this.stack.pop());
      }, g.prototype.onattribname = function(n, h) {
        this.startIndex = n;
        var v = this.getSlice(n, h);
        this.attribname = this.lowerCaseAttributeNames ? v.toLowerCase() : v;
      }, g.prototype.onattribdata = function(n, h) {
        this.attribvalue += this.getSlice(n, h);
      }, g.prototype.onattribentity = function(n) {
        this.attribvalue += (0, l.fromCodePoint)(n);
      }, g.prototype.onattribend = function(n, h) {
        var v, S;
        this.endIndex = h, (S = (v = this.cbs).onattribute) === null || S === void 0 || S.call(v, this.attribname, this.attribvalue, n === f.QuoteType.Double ? '"' : n === f.QuoteType.Single ? "'" : n === f.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
      }, g.prototype.getInstructionName = function(n) {
        var h = n.search(o), v = h < 0 ? n : n.substr(0, h);
        return this.lowerCaseTagNames && (v = v.toLowerCase()), v;
      }, g.prototype.ondeclaration = function(n, h) {
        this.endIndex = h;
        var v = this.getSlice(n, h);
        if (this.cbs.onprocessinginstruction) {
          var S = this.getInstructionName(v);
          this.cbs.onprocessinginstruction("!".concat(S), "!".concat(v));
        }
        this.startIndex = h + 1;
      }, g.prototype.onprocessinginstruction = function(n, h) {
        this.endIndex = h;
        var v = this.getSlice(n, h);
        if (this.cbs.onprocessinginstruction) {
          var S = this.getInstructionName(v);
          this.cbs.onprocessinginstruction("?".concat(S), "?".concat(v));
        }
        this.startIndex = h + 1;
      }, g.prototype.oncomment = function(n, h, v) {
        var S, s, w, E;
        this.endIndex = h, (s = (S = this.cbs).oncomment) === null || s === void 0 || s.call(S, this.getSlice(n, h - v)), (E = (w = this.cbs).oncommentend) === null || E === void 0 || E.call(w), this.startIndex = h + 1;
      }, g.prototype.oncdata = function(n, h, v) {
        var S, s, w, E, A, L, D, T, q, I;
        this.endIndex = h;
        var R = this.getSlice(n, h - v);
        this.options.xmlMode || this.options.recognizeCDATA ? ((s = (S = this.cbs).oncdatastart) === null || s === void 0 || s.call(S), (E = (w = this.cbs).ontext) === null || E === void 0 || E.call(w, R), (L = (A = this.cbs).oncdataend) === null || L === void 0 || L.call(A)) : ((T = (D = this.cbs).oncomment) === null || T === void 0 || T.call(D, "[CDATA[".concat(R, "]]")), (I = (q = this.cbs).oncommentend) === null || I === void 0 || I.call(q)), this.startIndex = h + 1;
      }, g.prototype.onend = function() {
        var n, h;
        if (this.cbs.onclosetag) {
          this.endIndex = this.startIndex;
          for (var v = this.stack.length; v > 0; this.cbs.onclosetag(this.stack[--v], !0))
            ;
        }
        (h = (n = this.cbs).onend) === null || h === void 0 || h.call(n);
      }, g.prototype.reset = function() {
        var n, h, v, S;
        (h = (n = this.cbs).onreset) === null || h === void 0 || h.call(n), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (S = (v = this.cbs).onparserinit) === null || S === void 0 || S.call(v, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
      }, g.prototype.parseComplete = function(n) {
        this.reset(), this.end(n);
      }, g.prototype.getSlice = function(n, h) {
        for (; n - this.bufferOffset >= this.buffers[0].length; )
          this.shiftBuffer();
        for (var v = this.buffers[0].slice(n - this.bufferOffset, h - this.bufferOffset); h - this.bufferOffset > this.buffers[0].length; )
          this.shiftBuffer(), v += this.buffers[0].slice(0, h - this.bufferOffset);
        return v;
      }, g.prototype.shiftBuffer = function() {
        this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
      }, g.prototype.write = function(n) {
        var h, v;
        if (this.ended) {
          (v = (h = this.cbs).onerror) === null || v === void 0 || v.call(h, new Error(".write() after done!"));
          return;
        }
        this.buffers.push(n), this.tokenizer.running && (this.tokenizer.write(n), this.writeIndex++);
      }, g.prototype.end = function(n) {
        var h, v;
        if (this.ended) {
          (v = (h = this.cbs).onerror) === null || v === void 0 || v.call(h, new Error(".end() after done!"));
          return;
        }
        n && this.write(n), this.ended = !0, this.tokenizer.end();
      }, g.prototype.pause = function() {
        this.tokenizer.pause();
      }, g.prototype.resume = function() {
        for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
          this.tokenizer.write(this.buffers[this.writeIndex++]);
        this.ended && this.tokenizer.end();
      }, g.prototype.parseChunk = function(n) {
        this.write(n);
      }, g.prototype.done = function(n) {
        this.end(n);
      }, g;
    })()
  );
  return te.Parser = y, te;
}
var me = {}, Ke = {}, tu;
function qe() {
  return tu || (tu = 1, (function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.Doctype = u.CDATA = u.Tag = u.Style = u.Script = u.Comment = u.Directive = u.Text = u.Root = u.isTag = u.ElementType = void 0;
    var x;
    (function(f) {
      f.Root = "root", f.Text = "text", f.Directive = "directive", f.Comment = "comment", f.Script = "script", f.Style = "style", f.Tag = "tag", f.CDATA = "cdata", f.Doctype = "doctype";
    })(x = u.ElementType || (u.ElementType = {}));
    function m(f) {
      return f.type === x.Tag || f.type === x.Script || f.type === x.Style;
    }
    u.isTag = m, u.Root = x.Root, u.Text = x.Text, u.Directive = x.Directive, u.Comment = x.Comment, u.Script = x.Script, u.Style = x.Style, u.Tag = x.Tag, u.CDATA = x.CDATA, u.Doctype = x.Doctype;
  })(Ke)), Ke;
}
var B = {}, uu;
function ru() {
  if (uu) return B;
  uu = 1;
  var u = B && B.__extends || /* @__PURE__ */ (function() {
    var s = function(w, E) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, L) {
        A.__proto__ = L;
      } || function(A, L) {
        for (var D in L) Object.prototype.hasOwnProperty.call(L, D) && (A[D] = L[D]);
      }, s(w, E);
    };
    return function(w, E) {
      if (typeof E != "function" && E !== null)
        throw new TypeError("Class extends value " + String(E) + " is not a constructor or null");
      s(w, E);
      function A() {
        this.constructor = w;
      }
      w.prototype = E === null ? Object.create(E) : (A.prototype = E.prototype, new A());
    };
  })(), x = B && B.__assign || function() {
    return x = Object.assign || function(s) {
      for (var w, E = 1, A = arguments.length; E < A; E++) {
        w = arguments[E];
        for (var L in w) Object.prototype.hasOwnProperty.call(w, L) && (s[L] = w[L]);
      }
      return s;
    }, x.apply(this, arguments);
  };
  Object.defineProperty(B, "__esModule", { value: !0 }), B.cloneNode = B.hasChildren = B.isDocument = B.isDirective = B.isComment = B.isText = B.isCDATA = B.isTag = B.Element = B.Document = B.CDATA = B.NodeWithChildren = B.ProcessingInstruction = B.Comment = B.Text = B.DataNode = B.Node = void 0;
  var m = /* @__PURE__ */ qe(), f = (
    /** @class */
    (function() {
      function s() {
        this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
      }
      return Object.defineProperty(s.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(w) {
          this.parent = w;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(w) {
          this.prev = w;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(w) {
          this.next = w;
        },
        enumerable: !1,
        configurable: !0
      }), s.prototype.cloneNode = function(w) {
        return w === void 0 && (w = !1), v(this, w);
      }, s;
    })()
  );
  B.Node = f;
  var l = (
    /** @class */
    (function(s) {
      u(w, s);
      function w(E) {
        var A = s.call(this) || this;
        return A.data = E, A;
      }
      return Object.defineProperty(w.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function(E) {
          this.data = E;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    })(f)
  );
  B.DataNode = l;
  var p = (
    /** @class */
    (function(s) {
      u(w, s);
      function w() {
        var E = s !== null && s.apply(this, arguments) || this;
        return E.type = m.ElementType.Text, E;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 3;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    })(l)
  );
  B.Text = p;
  var a = (
    /** @class */
    (function(s) {
      u(w, s);
      function w() {
        var E = s !== null && s.apply(this, arguments) || this;
        return E.type = m.ElementType.Comment, E;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 8;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    })(l)
  );
  B.Comment = a;
  var d = (
    /** @class */
    (function(s) {
      u(w, s);
      function w(E, A) {
        var L = s.call(this, A) || this;
        return L.name = E, L.type = m.ElementType.Directive, L;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    })(l)
  );
  B.ProcessingInstruction = d;
  var b = (
    /** @class */
    (function(s) {
      u(w, s);
      function w(E) {
        var A = s.call(this) || this;
        return A.children = E, A;
      }
      return Object.defineProperty(w.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var E;
          return (E = this.children[0]) !== null && E !== void 0 ? E : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function(E) {
          this.children = E;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    })(f)
  );
  B.NodeWithChildren = b;
  var i = (
    /** @class */
    (function(s) {
      u(w, s);
      function w() {
        var E = s !== null && s.apply(this, arguments) || this;
        return E.type = m.ElementType.CDATA, E;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 4;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    })(b)
  );
  B.CDATA = i;
  var r = (
    /** @class */
    (function(s) {
      u(w, s);
      function w() {
        var E = s !== null && s.apply(this, arguments) || this;
        return E.type = m.ElementType.Root, E;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 9;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    })(b)
  );
  B.Document = r;
  var c = (
    /** @class */
    (function(s) {
      u(w, s);
      function w(E, A, L, D) {
        L === void 0 && (L = []), D === void 0 && (D = E === "script" ? m.ElementType.Script : E === "style" ? m.ElementType.Style : m.ElementType.Tag);
        var T = s.call(this, L) || this;
        return T.name = E, T.attribs = A, T.type = D, T;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function(E) {
          this.name = E;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "attributes", {
        get: function() {
          var E = this;
          return Object.keys(this.attribs).map(function(A) {
            var L, D;
            return {
              name: A,
              value: E.attribs[A],
              namespace: (L = E["x-attribsNamespace"]) === null || L === void 0 ? void 0 : L[A],
              prefix: (D = E["x-attribsPrefix"]) === null || D === void 0 ? void 0 : D[A]
            };
          });
        },
        enumerable: !1,
        configurable: !0
      }), w;
    })(b)
  );
  B.Element = c;
  function e(s) {
    return (0, m.isTag)(s);
  }
  B.isTag = e;
  function t(s) {
    return s.type === m.ElementType.CDATA;
  }
  B.isCDATA = t;
  function o(s) {
    return s.type === m.ElementType.Text;
  }
  B.isText = o;
  function y(s) {
    return s.type === m.ElementType.Comment;
  }
  B.isComment = y;
  function g(s) {
    return s.type === m.ElementType.Directive;
  }
  B.isDirective = g;
  function n(s) {
    return s.type === m.ElementType.Root;
  }
  B.isDocument = n;
  function h(s) {
    return Object.prototype.hasOwnProperty.call(s, "children");
  }
  B.hasChildren = h;
  function v(s, w) {
    w === void 0 && (w = !1);
    var E;
    if (o(s))
      E = new p(s.data);
    else if (y(s))
      E = new a(s.data);
    else if (e(s)) {
      var A = w ? S(s.children) : [], L = new c(s.name, x({}, s.attribs), A);
      A.forEach(function(I) {
        return I.parent = L;
      }), s.namespace != null && (L.namespace = s.namespace), s["x-attribsNamespace"] && (L["x-attribsNamespace"] = x({}, s["x-attribsNamespace"])), s["x-attribsPrefix"] && (L["x-attribsPrefix"] = x({}, s["x-attribsPrefix"])), E = L;
    } else if (t(s)) {
      var A = w ? S(s.children) : [], D = new i(A);
      A.forEach(function(R) {
        return R.parent = D;
      }), E = D;
    } else if (n(s)) {
      var A = w ? S(s.children) : [], T = new r(A);
      A.forEach(function(R) {
        return R.parent = T;
      }), s["x-mode"] && (T["x-mode"] = s["x-mode"]), E = T;
    } else if (g(s)) {
      var q = new d(s.name, s.data);
      s["x-name"] != null && (q["x-name"] = s["x-name"], q["x-publicId"] = s["x-publicId"], q["x-systemId"] = s["x-systemId"]), E = q;
    } else
      throw new Error("Not implemented yet: ".concat(s.type));
    return E.startIndex = s.startIndex, E.endIndex = s.endIndex, s.sourceCodeLocation != null && (E.sourceCodeLocation = s.sourceCodeLocation), E;
  }
  B.cloneNode = v;
  function S(s) {
    for (var w = s.map(function(A) {
      return v(A, !0);
    }), E = 1; E < w.length; E++)
      w[E].prev = w[E - 1], w[E - 1].next = w[E];
    return w;
  }
  return B;
}
var iu;
function he() {
  return iu || (iu = 1, (function(u) {
    var x = me && me.__createBinding || (Object.create ? (function(d, b, i, r) {
      r === void 0 && (r = i);
      var c = Object.getOwnPropertyDescriptor(b, i);
      (!c || ("get" in c ? !b.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
        return b[i];
      } }), Object.defineProperty(d, r, c);
    }) : (function(d, b, i, r) {
      r === void 0 && (r = i), d[r] = b[i];
    })), m = me && me.__exportStar || function(d, b) {
      for (var i in d) i !== "default" && !Object.prototype.hasOwnProperty.call(b, i) && x(b, d, i);
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.DomHandler = void 0;
    var f = /* @__PURE__ */ qe(), l = /* @__PURE__ */ ru();
    m(/* @__PURE__ */ ru(), u);
    var p = {
      withStartIndices: !1,
      withEndIndices: !1,
      xmlMode: !1
    }, a = (
      /** @class */
      (function() {
        function d(b, i, r) {
          this.dom = [], this.root = new l.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof i == "function" && (r = i, i = p), typeof b == "object" && (i = b, b = void 0), this.callback = b ?? null, this.options = i ?? p, this.elementCB = r ?? null;
        }
        return d.prototype.onparserinit = function(b) {
          this.parser = b;
        }, d.prototype.onreset = function() {
          this.dom = [], this.root = new l.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
        }, d.prototype.onend = function() {
          this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
        }, d.prototype.onerror = function(b) {
          this.handleCallback(b);
        }, d.prototype.onclosetag = function() {
          this.lastNode = null;
          var b = this.tagStack.pop();
          this.options.withEndIndices && (b.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(b);
        }, d.prototype.onopentag = function(b, i) {
          var r = this.options.xmlMode ? f.ElementType.Tag : void 0, c = new l.Element(b, i, void 0, r);
          this.addNode(c), this.tagStack.push(c);
        }, d.prototype.ontext = function(b) {
          var i = this.lastNode;
          if (i && i.type === f.ElementType.Text)
            i.data += b, this.options.withEndIndices && (i.endIndex = this.parser.endIndex);
          else {
            var r = new l.Text(b);
            this.addNode(r), this.lastNode = r;
          }
        }, d.prototype.oncomment = function(b) {
          if (this.lastNode && this.lastNode.type === f.ElementType.Comment) {
            this.lastNode.data += b;
            return;
          }
          var i = new l.Comment(b);
          this.addNode(i), this.lastNode = i;
        }, d.prototype.oncommentend = function() {
          this.lastNode = null;
        }, d.prototype.oncdatastart = function() {
          var b = new l.Text(""), i = new l.CDATA([b]);
          this.addNode(i), b.parent = i, this.lastNode = b;
        }, d.prototype.oncdataend = function() {
          this.lastNode = null;
        }, d.prototype.onprocessinginstruction = function(b, i) {
          var r = new l.ProcessingInstruction(b, i);
          this.addNode(r);
        }, d.prototype.handleCallback = function(b) {
          if (typeof this.callback == "function")
            this.callback(b, this.dom);
          else if (b)
            throw b;
        }, d.prototype.addNode = function(b) {
          var i = this.tagStack[this.tagStack.length - 1], r = i.children[i.children.length - 1];
          this.options.withStartIndices && (b.startIndex = this.parser.startIndex), this.options.withEndIndices && (b.endIndex = this.parser.endIndex), i.children.push(b), r && (b.prev = r, r.next = b), b.parent = i, this.lastNode = null;
        }, d;
      })()
    );
    u.DomHandler = a, u.default = a;
  })(me)), me;
}
var ge = {}, ae = {}, Y = {}, $e = {}, oe = {}, _e = {}, nu;
function Ar() {
  if (nu) return _e;
  nu = 1, Object.defineProperty(_e, "__esModule", { value: !0 });
  function u(x) {
    for (var m = 1; m < x.length; m++)
      x[m][0] += x[m - 1][0] + 1;
    return x;
  }
  return _e.default = new Map(/* @__PURE__ */ u([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ u([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ u([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ u([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]])), _e;
}
var et = {}, au;
function Pt() {
  return au || (au = 1, (function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.escapeText = u.escapeAttribute = u.escapeUTF8 = u.escape = u.encodeXML = u.getCodePoint = u.xmlReplacer = void 0, u.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
    var x = /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [39, "&apos;"],
      [60, "&lt;"],
      [62, "&gt;"]
    ]);
    u.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? function(l, p) {
      return l.codePointAt(p);
    } : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(l, p) {
        return (l.charCodeAt(p) & 64512) === 55296 ? (l.charCodeAt(p) - 55296) * 1024 + l.charCodeAt(p + 1) - 56320 + 65536 : l.charCodeAt(p);
      }
    );
    function m(l) {
      for (var p = "", a = 0, d; (d = u.xmlReplacer.exec(l)) !== null; ) {
        var b = d.index, i = l.charCodeAt(b), r = x.get(i);
        r !== void 0 ? (p += l.substring(a, b) + r, a = b + 1) : (p += "".concat(l.substring(a, b), "&#x").concat((0, u.getCodePoint)(l, b).toString(16), ";"), a = u.xmlReplacer.lastIndex += +((i & 64512) === 55296));
      }
      return p + l.substr(a);
    }
    u.encodeXML = m, u.escape = m;
    function f(l, p) {
      return function(d) {
        for (var b, i = 0, r = ""; b = l.exec(d); )
          i !== b.index && (r += d.substring(i, b.index)), r += p.get(b[0].charCodeAt(0)), i = b.index + 1;
        return r + d.substring(i);
      };
    }
    u.escapeUTF8 = f(/[&<>'"]/g, x), u.escapeAttribute = f(/["&\u00A0]/g, /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [160, "&nbsp;"]
    ])), u.escapeText = f(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
      [38, "&amp;"],
      [60, "&lt;"],
      [62, "&gt;"],
      [160, "&nbsp;"]
    ]));
  })(et)), et;
}
var su;
function ou() {
  if (su) return oe;
  su = 1;
  var u = oe && oe.__importDefault || function(d) {
    return d && d.__esModule ? d : { default: d };
  };
  Object.defineProperty(oe, "__esModule", { value: !0 }), oe.encodeNonAsciiHTML = oe.encodeHTML = void 0;
  var x = u(/* @__PURE__ */ Ar()), m = /* @__PURE__ */ Pt(), f = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
  function l(d) {
    return a(f, d);
  }
  oe.encodeHTML = l;
  function p(d) {
    return a(m.xmlReplacer, d);
  }
  oe.encodeNonAsciiHTML = p;
  function a(d, b) {
    for (var i = "", r = 0, c; (c = d.exec(b)) !== null; ) {
      var e = c.index;
      i += b.substring(r, e);
      var t = b.charCodeAt(e), o = x.default.get(t);
      if (typeof o == "object") {
        if (e + 1 < b.length) {
          var y = b.charCodeAt(e + 1), g = typeof o.n == "number" ? o.n === y ? o.o : void 0 : o.n.get(y);
          if (g !== void 0) {
            i += g, r = d.lastIndex += 1;
            continue;
          }
        }
        o = o.v;
      }
      if (o !== void 0)
        i += o, r = e + 1;
      else {
        var n = (0, m.getCodePoint)(b, e);
        i += "&#x".concat(n.toString(16), ";"), r = d.lastIndex += +(n !== t);
      }
    }
    return i + b.substr(r);
  }
  return oe;
}
var cu;
function qr() {
  return cu || (cu = 1, (function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.decodeXMLStrict = u.decodeHTML5Strict = u.decodeHTML4Strict = u.decodeHTML5 = u.decodeHTML4 = u.decodeHTMLAttribute = u.decodeHTMLStrict = u.decodeHTML = u.decodeXML = u.DecodingMode = u.EntityDecoder = u.encodeHTML5 = u.encodeHTML4 = u.encodeNonAsciiHTML = u.encodeHTML = u.escapeText = u.escapeAttribute = u.escapeUTF8 = u.escape = u.encodeXML = u.encode = u.decodeStrict = u.decode = u.EncodingMode = u.EntityLevel = void 0;
    var x = /* @__PURE__ */ Ue(), m = /* @__PURE__ */ ou(), f = /* @__PURE__ */ Pt(), l;
    (function(e) {
      e[e.XML = 0] = "XML", e[e.HTML = 1] = "HTML";
    })(l = u.EntityLevel || (u.EntityLevel = {}));
    var p;
    (function(e) {
      e[e.UTF8 = 0] = "UTF8", e[e.ASCII = 1] = "ASCII", e[e.Extensive = 2] = "Extensive", e[e.Attribute = 3] = "Attribute", e[e.Text = 4] = "Text";
    })(p = u.EncodingMode || (u.EncodingMode = {}));
    function a(e, t) {
      t === void 0 && (t = l.XML);
      var o = typeof t == "number" ? t : t.level;
      if (o === l.HTML) {
        var y = typeof t == "object" ? t.mode : void 0;
        return (0, x.decodeHTML)(e, y);
      }
      return (0, x.decodeXML)(e);
    }
    u.decode = a;
    function d(e, t) {
      var o;
      t === void 0 && (t = l.XML);
      var y = typeof t == "number" ? { level: t } : t;
      return (o = y.mode) !== null && o !== void 0 || (y.mode = x.DecodingMode.Strict), a(e, y);
    }
    u.decodeStrict = d;
    function b(e, t) {
      t === void 0 && (t = l.XML);
      var o = typeof t == "number" ? { level: t } : t;
      return o.mode === p.UTF8 ? (0, f.escapeUTF8)(e) : o.mode === p.Attribute ? (0, f.escapeAttribute)(e) : o.mode === p.Text ? (0, f.escapeText)(e) : o.level === l.HTML ? o.mode === p.ASCII ? (0, m.encodeNonAsciiHTML)(e) : (0, m.encodeHTML)(e) : (0, f.encodeXML)(e);
    }
    u.encode = b;
    var i = /* @__PURE__ */ Pt();
    Object.defineProperty(u, "encodeXML", { enumerable: !0, get: function() {
      return i.encodeXML;
    } }), Object.defineProperty(u, "escape", { enumerable: !0, get: function() {
      return i.escape;
    } }), Object.defineProperty(u, "escapeUTF8", { enumerable: !0, get: function() {
      return i.escapeUTF8;
    } }), Object.defineProperty(u, "escapeAttribute", { enumerable: !0, get: function() {
      return i.escapeAttribute;
    } }), Object.defineProperty(u, "escapeText", { enumerable: !0, get: function() {
      return i.escapeText;
    } });
    var r = /* @__PURE__ */ ou();
    Object.defineProperty(u, "encodeHTML", { enumerable: !0, get: function() {
      return r.encodeHTML;
    } }), Object.defineProperty(u, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
      return r.encodeNonAsciiHTML;
    } }), Object.defineProperty(u, "encodeHTML4", { enumerable: !0, get: function() {
      return r.encodeHTML;
    } }), Object.defineProperty(u, "encodeHTML5", { enumerable: !0, get: function() {
      return r.encodeHTML;
    } });
    var c = /* @__PURE__ */ Ue();
    Object.defineProperty(u, "EntityDecoder", { enumerable: !0, get: function() {
      return c.EntityDecoder;
    } }), Object.defineProperty(u, "DecodingMode", { enumerable: !0, get: function() {
      return c.DecodingMode;
    } }), Object.defineProperty(u, "decodeXML", { enumerable: !0, get: function() {
      return c.decodeXML;
    } }), Object.defineProperty(u, "decodeHTML", { enumerable: !0, get: function() {
      return c.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTMLStrict", { enumerable: !0, get: function() {
      return c.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeHTMLAttribute", { enumerable: !0, get: function() {
      return c.decodeHTMLAttribute;
    } }), Object.defineProperty(u, "decodeHTML4", { enumerable: !0, get: function() {
      return c.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTML5", { enumerable: !0, get: function() {
      return c.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTML4Strict", { enumerable: !0, get: function() {
      return c.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeHTML5Strict", { enumerable: !0, get: function() {
      return c.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeXMLStrict", { enumerable: !0, get: function() {
      return c.decodeXML;
    } });
  })($e)), $e;
}
var ye = {}, lu;
function Nr() {
  return lu || (lu = 1, Object.defineProperty(ye, "__esModule", { value: !0 }), ye.attributeNames = ye.elementNames = void 0, ye.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
  ].map(function(u) {
    return [u.toLowerCase(), u];
  })), ye.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
  ].map(function(u) {
    return [u.toLowerCase(), u];
  }))), ye;
}
var fu;
function Or() {
  if (fu) return Y;
  fu = 1;
  var u = Y && Y.__assign || function() {
    return u = Object.assign || function(S) {
      for (var s, w = 1, E = arguments.length; w < E; w++) {
        s = arguments[w];
        for (var A in s) Object.prototype.hasOwnProperty.call(s, A) && (S[A] = s[A]);
      }
      return S;
    }, u.apply(this, arguments);
  }, x = Y && Y.__createBinding || (Object.create ? (function(S, s, w, E) {
    E === void 0 && (E = w);
    var A = Object.getOwnPropertyDescriptor(s, w);
    (!A || ("get" in A ? !s.__esModule : A.writable || A.configurable)) && (A = { enumerable: !0, get: function() {
      return s[w];
    } }), Object.defineProperty(S, E, A);
  }) : (function(S, s, w, E) {
    E === void 0 && (E = w), S[E] = s[w];
  })), m = Y && Y.__setModuleDefault || (Object.create ? (function(S, s) {
    Object.defineProperty(S, "default", { enumerable: !0, value: s });
  }) : function(S, s) {
    S.default = s;
  }), f = Y && Y.__importStar || function(S) {
    if (S && S.__esModule) return S;
    var s = {};
    if (S != null) for (var w in S) w !== "default" && Object.prototype.hasOwnProperty.call(S, w) && x(s, S, w);
    return m(s, S), s;
  };
  Object.defineProperty(Y, "__esModule", { value: !0 }), Y.render = void 0;
  var l = f(/* @__PURE__ */ qe()), p = /* @__PURE__ */ qr(), a = /* @__PURE__ */ Nr(), d = /* @__PURE__ */ new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
  ]);
  function b(S) {
    return S.replace(/"/g, "&quot;");
  }
  function i(S, s) {
    var w;
    if (S) {
      var E = ((w = s.encodeEntities) !== null && w !== void 0 ? w : s.decodeEntities) === !1 ? b : s.xmlMode || s.encodeEntities !== "utf8" ? p.encodeXML : p.escapeAttribute;
      return Object.keys(S).map(function(A) {
        var L, D, T = (L = S[A]) !== null && L !== void 0 ? L : "";
        return s.xmlMode === "foreign" && (A = (D = a.attributeNames.get(A)) !== null && D !== void 0 ? D : A), !s.emptyAttrs && !s.xmlMode && T === "" ? A : "".concat(A, '="').concat(E(T), '"');
      }).join(" ");
    }
  }
  var r = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]);
  function c(S, s) {
    s === void 0 && (s = {});
    for (var w = ("length" in S) ? S : [S], E = "", A = 0; A < w.length; A++)
      E += e(w[A], s);
    return E;
  }
  Y.render = c, Y.default = c;
  function e(S, s) {
    switch (S.type) {
      case l.Root:
        return c(S.children, s);
      // @ts-expect-error We don't use `Doctype` yet
      case l.Doctype:
      case l.Directive:
        return g(S);
      case l.Comment:
        return v(S);
      case l.CDATA:
        return h(S);
      case l.Script:
      case l.Style:
      case l.Tag:
        return y(S, s);
      case l.Text:
        return n(S, s);
    }
  }
  var t = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
  ]), o = /* @__PURE__ */ new Set(["svg", "math"]);
  function y(S, s) {
    var w;
    s.xmlMode === "foreign" && (S.name = (w = a.elementNames.get(S.name)) !== null && w !== void 0 ? w : S.name, S.parent && t.has(S.parent.name) && (s = u(u({}, s), { xmlMode: !1 }))), !s.xmlMode && o.has(S.name) && (s = u(u({}, s), { xmlMode: "foreign" }));
    var E = "<".concat(S.name), A = i(S.attribs, s);
    return A && (E += " ".concat(A)), S.children.length === 0 && (s.xmlMode ? (
      // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
      s.selfClosingTags !== !1
    ) : (
      // User explicitly asked for self-closing tags, even in HTML mode
      s.selfClosingTags && r.has(S.name)
    )) ? (s.xmlMode || (E += " "), E += "/>") : (E += ">", S.children.length > 0 && (E += c(S.children, s)), (s.xmlMode || !r.has(S.name)) && (E += "</".concat(S.name, ">"))), E;
  }
  function g(S) {
    return "<".concat(S.data, ">");
  }
  function n(S, s) {
    var w, E = S.data || "";
    return ((w = s.encodeEntities) !== null && w !== void 0 ? w : s.decodeEntities) !== !1 && !(!s.xmlMode && S.parent && d.has(S.parent.name)) && (E = s.xmlMode || s.encodeEntities !== "utf8" ? (0, p.encodeXML)(E) : (0, p.escapeText)(E)), E;
  }
  function h(S) {
    return "<![CDATA[".concat(S.children[0].data, "]]>");
  }
  function v(S) {
    return "<!--".concat(S.data, "-->");
  }
  return Y;
}
var du;
function rr() {
  if (du) return ae;
  du = 1;
  var u = ae && ae.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(ae, "__esModule", { value: !0 }), ae.getOuterHTML = l, ae.getInnerHTML = p, ae.getText = a, ae.textContent = d, ae.innerText = b;
  var x = /* @__PURE__ */ he(), m = u(/* @__PURE__ */ Or()), f = /* @__PURE__ */ qe();
  function l(i, r) {
    return (0, m.default)(i, r);
  }
  function p(i, r) {
    return (0, x.hasChildren)(i) ? i.children.map(function(c) {
      return l(c, r);
    }).join("") : "";
  }
  function a(i) {
    return Array.isArray(i) ? i.map(a).join("") : (0, x.isTag)(i) ? i.name === "br" ? `
` : a(i.children) : (0, x.isCDATA)(i) ? a(i.children) : (0, x.isText)(i) ? i.data : "";
  }
  function d(i) {
    return Array.isArray(i) ? i.map(d).join("") : (0, x.hasChildren)(i) && !(0, x.isComment)(i) ? d(i.children) : (0, x.isText)(i) ? i.data : "";
  }
  function b(i) {
    return Array.isArray(i) ? i.map(b).join("") : (0, x.hasChildren)(i) && (i.type === f.ElementType.Tag || (0, x.isCDATA)(i)) ? b(i.children) : (0, x.isText)(i) ? i.data : "";
  }
  return ae;
}
var re = {}, hu;
function Lr() {
  if (hu) return re;
  hu = 1, Object.defineProperty(re, "__esModule", { value: !0 }), re.getChildren = x, re.getParent = m, re.getSiblings = f, re.getAttributeValue = l, re.hasAttrib = p, re.getName = a, re.nextElementSibling = d, re.prevElementSibling = b;
  var u = /* @__PURE__ */ he();
  function x(i) {
    return (0, u.hasChildren)(i) ? i.children : [];
  }
  function m(i) {
    return i.parent || null;
  }
  function f(i) {
    var r, c, e = m(i);
    if (e != null)
      return x(e);
    for (var t = [i], o = i.prev, y = i.next; o != null; )
      t.unshift(o), r = o, o = r.prev;
    for (; y != null; )
      t.push(y), c = y, y = c.next;
    return t;
  }
  function l(i, r) {
    var c;
    return (c = i.attribs) === null || c === void 0 ? void 0 : c[r];
  }
  function p(i, r) {
    return i.attribs != null && Object.prototype.hasOwnProperty.call(i.attribs, r) && i.attribs[r] != null;
  }
  function a(i) {
    return i.name;
  }
  function d(i) {
    for (var r, c = i.next; c !== null && !(0, u.isTag)(c); )
      r = c, c = r.next;
    return c;
  }
  function b(i) {
    for (var r, c = i.prev; c !== null && !(0, u.isTag)(c); )
      r = c, c = r.prev;
    return c;
  }
  return re;
}
var ce = {}, pu;
function Dr() {
  if (pu) return ce;
  pu = 1, Object.defineProperty(ce, "__esModule", { value: !0 }), ce.removeElement = u, ce.replaceElement = x, ce.appendChild = m, ce.append = f, ce.prependChild = l, ce.prepend = p;
  function u(a) {
    if (a.prev && (a.prev.next = a.next), a.next && (a.next.prev = a.prev), a.parent) {
      var d = a.parent.children, b = d.lastIndexOf(a);
      b >= 0 && d.splice(b, 1);
    }
    a.next = null, a.prev = null, a.parent = null;
  }
  function x(a, d) {
    var b = d.prev = a.prev;
    b && (b.next = d);
    var i = d.next = a.next;
    i && (i.prev = d);
    var r = d.parent = a.parent;
    if (r) {
      var c = r.children;
      c[c.lastIndexOf(a)] = d, a.parent = null;
    }
  }
  function m(a, d) {
    if (u(d), d.next = null, d.parent = a, a.children.push(d) > 1) {
      var b = a.children[a.children.length - 2];
      b.next = d, d.prev = b;
    } else
      d.prev = null;
  }
  function f(a, d) {
    u(d);
    var b = a.parent, i = a.next;
    if (d.next = i, d.prev = a, a.next = d, d.parent = b, i) {
      if (i.prev = d, b) {
        var r = b.children;
        r.splice(r.lastIndexOf(i), 0, d);
      }
    } else b && b.children.push(d);
  }
  function l(a, d) {
    if (u(d), d.parent = a, d.prev = null, a.children.unshift(d) !== 1) {
      var b = a.children[1];
      b.prev = d, d.next = b;
    } else
      d.next = null;
  }
  function p(a, d) {
    u(d);
    var b = a.parent;
    if (b) {
      var i = b.children;
      i.splice(i.indexOf(a), 0, d);
    }
    a.prev && (a.prev.next = d), d.parent = b, d.prev = a.prev, d.next = a, a.prev = d;
  }
  return ce;
}
var le = {}, bu;
function ir() {
  if (bu) return le;
  bu = 1, Object.defineProperty(le, "__esModule", { value: !0 }), le.filter = x, le.find = m, le.findOneChild = f, le.findOne = l, le.existsOne = p, le.findAll = a;
  var u = /* @__PURE__ */ he();
  function x(d, b, i, r) {
    return i === void 0 && (i = !0), r === void 0 && (r = 1 / 0), m(d, Array.isArray(b) ? b : [b], i, r);
  }
  function m(d, b, i, r) {
    for (var c = [], e = [Array.isArray(b) ? b : [b]], t = [0]; ; ) {
      if (t[0] >= e[0].length) {
        if (t.length === 1)
          return c;
        e.shift(), t.shift();
        continue;
      }
      var o = e[0][t[0]++];
      if (d(o) && (c.push(o), --r <= 0))
        return c;
      i && (0, u.hasChildren)(o) && o.children.length > 0 && (t.unshift(0), e.unshift(o.children));
    }
  }
  function f(d, b) {
    return b.find(d);
  }
  function l(d, b, i) {
    i === void 0 && (i = !0);
    for (var r = Array.isArray(b) ? b : [b], c = 0; c < r.length; c++) {
      var e = r[c];
      if ((0, u.isTag)(e) && d(e))
        return e;
      if (i && (0, u.hasChildren)(e) && e.children.length > 0) {
        var t = l(d, e.children, !0);
        if (t)
          return t;
      }
    }
    return null;
  }
  function p(d, b) {
    return (Array.isArray(b) ? b : [b]).some(function(i) {
      return (0, u.isTag)(i) && d(i) || (0, u.hasChildren)(i) && p(d, i.children);
    });
  }
  function a(d, b) {
    for (var i = [], r = [Array.isArray(b) ? b : [b]], c = [0]; ; ) {
      if (c[0] >= r[0].length) {
        if (r.length === 1)
          return i;
        r.shift(), c.shift();
        continue;
      }
      var e = r[0][c[0]++];
      (0, u.isTag)(e) && d(e) && i.push(e), (0, u.hasChildren)(e) && e.children.length > 0 && (c.unshift(0), r.unshift(e.children));
    }
  }
  return le;
}
var fe = {}, mu;
function nr() {
  if (mu) return fe;
  mu = 1, Object.defineProperty(fe, "__esModule", { value: !0 }), fe.testElement = a, fe.getElements = d, fe.getElementById = b, fe.getElementsByTagName = i, fe.getElementsByClassName = r, fe.getElementsByTagType = c;
  var u = /* @__PURE__ */ he(), x = /* @__PURE__ */ ir(), m = {
    tag_name: function(e) {
      return typeof e == "function" ? function(t) {
        return (0, u.isTag)(t) && e(t.name);
      } : e === "*" ? u.isTag : function(t) {
        return (0, u.isTag)(t) && t.name === e;
      };
    },
    tag_type: function(e) {
      return typeof e == "function" ? function(t) {
        return e(t.type);
      } : function(t) {
        return t.type === e;
      };
    },
    tag_contains: function(e) {
      return typeof e == "function" ? function(t) {
        return (0, u.isText)(t) && e(t.data);
      } : function(t) {
        return (0, u.isText)(t) && t.data === e;
      };
    }
  };
  function f(e, t) {
    return typeof t == "function" ? function(o) {
      return (0, u.isTag)(o) && t(o.attribs[e]);
    } : function(o) {
      return (0, u.isTag)(o) && o.attribs[e] === t;
    };
  }
  function l(e, t) {
    return function(o) {
      return e(o) || t(o);
    };
  }
  function p(e) {
    var t = Object.keys(e).map(function(o) {
      var y = e[o];
      return Object.prototype.hasOwnProperty.call(m, o) ? m[o](y) : f(o, y);
    });
    return t.length === 0 ? null : t.reduce(l);
  }
  function a(e, t) {
    var o = p(e);
    return o ? o(t) : !0;
  }
  function d(e, t, o, y) {
    y === void 0 && (y = 1 / 0);
    var g = p(e);
    return g ? (0, x.filter)(g, t, o, y) : [];
  }
  function b(e, t, o) {
    return o === void 0 && (o = !0), Array.isArray(t) || (t = [t]), (0, x.findOne)(f("id", e), t, o);
  }
  function i(e, t, o, y) {
    return o === void 0 && (o = !0), y === void 0 && (y = 1 / 0), (0, x.filter)(m.tag_name(e), t, o, y);
  }
  function r(e, t, o, y) {
    return o === void 0 && (o = !0), y === void 0 && (y = 1 / 0), (0, x.filter)(f("class", e), t, o, y);
  }
  function c(e, t, o, y) {
    return o === void 0 && (o = !0), y === void 0 && (y = 1 / 0), (0, x.filter)(m.tag_type(e), t, o, y);
  }
  return fe;
}
var de = {}, gu;
function Cr() {
  if (gu) return de;
  gu = 1, Object.defineProperty(de, "__esModule", { value: !0 }), de.DocumentPosition = void 0, de.removeSubsets = x, de.compareDocumentPosition = f, de.uniqueSort = l;
  var u = /* @__PURE__ */ he();
  function x(p) {
    for (var a = p.length; --a >= 0; ) {
      var d = p[a];
      if (a > 0 && p.lastIndexOf(d, a - 1) >= 0) {
        p.splice(a, 1);
        continue;
      }
      for (var b = d.parent; b; b = b.parent)
        if (p.includes(b)) {
          p.splice(a, 1);
          break;
        }
    }
    return p;
  }
  var m;
  (function(p) {
    p[p.DISCONNECTED = 1] = "DISCONNECTED", p[p.PRECEDING = 2] = "PRECEDING", p[p.FOLLOWING = 4] = "FOLLOWING", p[p.CONTAINS = 8] = "CONTAINS", p[p.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(m || (de.DocumentPosition = m = {}));
  function f(p, a) {
    var d = [], b = [];
    if (p === a)
      return 0;
    for (var i = (0, u.hasChildren)(p) ? p : p.parent; i; )
      d.unshift(i), i = i.parent;
    for (i = (0, u.hasChildren)(a) ? a : a.parent; i; )
      b.unshift(i), i = i.parent;
    for (var r = Math.min(d.length, b.length), c = 0; c < r && d[c] === b[c]; )
      c++;
    if (c === 0)
      return m.DISCONNECTED;
    var e = d[c - 1], t = e.children, o = d[c], y = b[c];
    return t.indexOf(o) > t.indexOf(y) ? e === a ? m.FOLLOWING | m.CONTAINED_BY : m.FOLLOWING : e === p ? m.PRECEDING | m.CONTAINS : m.PRECEDING;
  }
  function l(p) {
    return p = p.filter(function(a, d, b) {
      return !b.includes(a, d + 1);
    }), p.sort(function(a, d) {
      var b = f(a, d);
      return b & m.PRECEDING ? -1 : b & m.FOLLOWING ? 1 : 0;
    }), p;
  }
  return de;
}
var Re = {}, yu;
function Ir() {
  if (yu) return Re;
  yu = 1, Object.defineProperty(Re, "__esModule", { value: !0 }), Re.getFeed = m;
  var u = /* @__PURE__ */ rr(), x = /* @__PURE__ */ nr();
  function m(e) {
    var t = b(c, e);
    return t ? t.name === "feed" ? f(t) : l(t) : null;
  }
  function f(e) {
    var t, o = e.children, y = {
      type: "atom",
      items: (0, x.getElementsByTagName)("entry", o).map(function(h) {
        var v, S = h.children, s = { media: d(S) };
        r(s, "id", "id", S), r(s, "title", "title", S);
        var w = (v = b("link", S)) === null || v === void 0 ? void 0 : v.attribs.href;
        w && (s.link = w);
        var E = i("summary", S) || i("content", S);
        E && (s.description = E);
        var A = i("updated", S);
        return A && (s.pubDate = new Date(A)), s;
      })
    };
    r(y, "id", "id", o), r(y, "title", "title", o);
    var g = (t = b("link", o)) === null || t === void 0 ? void 0 : t.attribs.href;
    g && (y.link = g), r(y, "description", "subtitle", o);
    var n = i("updated", o);
    return n && (y.updated = new Date(n)), r(y, "author", "email", o, !0), y;
  }
  function l(e) {
    var t, o, y = (o = (t = b("channel", e.children)) === null || t === void 0 ? void 0 : t.children) !== null && o !== void 0 ? o : [], g = {
      type: e.name.substr(0, 3),
      id: "",
      items: (0, x.getElementsByTagName)("item", e.children).map(function(h) {
        var v = h.children, S = { media: d(v) };
        r(S, "id", "guid", v), r(S, "title", "title", v), r(S, "link", "link", v), r(S, "description", "description", v);
        var s = i("pubDate", v) || i("dc:date", v);
        return s && (S.pubDate = new Date(s)), S;
      })
    };
    r(g, "title", "title", y), r(g, "link", "link", y), r(g, "description", "description", y);
    var n = i("lastBuildDate", y);
    return n && (g.updated = new Date(n)), r(g, "author", "managingEditor", y, !0), g;
  }
  var p = ["url", "type", "lang"], a = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
  ];
  function d(e) {
    return (0, x.getElementsByTagName)("media:content", e).map(function(t) {
      for (var o = t.attribs, y = {
        medium: o.medium,
        isDefault: !!o.isDefault
      }, g = 0, n = p; g < n.length; g++) {
        var h = n[g];
        o[h] && (y[h] = o[h]);
      }
      for (var v = 0, S = a; v < S.length; v++) {
        var h = S[v];
        o[h] && (y[h] = parseInt(o[h], 10));
      }
      return o.expression && (y.expression = o.expression), y;
    });
  }
  function b(e, t) {
    return (0, x.getElementsByTagName)(e, t, !0, 1)[0];
  }
  function i(e, t, o) {
    return o === void 0 && (o = !1), (0, u.textContent)((0, x.getElementsByTagName)(e, t, o, 1)).trim();
  }
  function r(e, t, o, y, g) {
    g === void 0 && (g = !1);
    var n = i(o, y, g);
    n && (e[t] = n);
  }
  function c(e) {
    return e === "rss" || e === "feed" || e === "rdf:RDF";
  }
  return Re;
}
var vu;
function tt() {
  return vu || (vu = 1, (function(u) {
    var x = ge && ge.__createBinding || (Object.create ? (function(l, p, a, d) {
      d === void 0 && (d = a);
      var b = Object.getOwnPropertyDescriptor(p, a);
      (!b || ("get" in b ? !p.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
        return p[a];
      } }), Object.defineProperty(l, d, b);
    }) : (function(l, p, a, d) {
      d === void 0 && (d = a), l[d] = p[a];
    })), m = ge && ge.__exportStar || function(l, p) {
      for (var a in l) a !== "default" && !Object.prototype.hasOwnProperty.call(p, a) && x(p, l, a);
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.hasChildren = u.isDocument = u.isComment = u.isText = u.isCDATA = u.isTag = void 0, m(/* @__PURE__ */ rr(), u), m(/* @__PURE__ */ Lr(), u), m(/* @__PURE__ */ Dr(), u), m(/* @__PURE__ */ ir(), u), m(/* @__PURE__ */ nr(), u), m(/* @__PURE__ */ Cr(), u), m(/* @__PURE__ */ Ir(), u);
    var f = /* @__PURE__ */ he();
    Object.defineProperty(u, "isTag", { enumerable: !0, get: function() {
      return f.isTag;
    } }), Object.defineProperty(u, "isCDATA", { enumerable: !0, get: function() {
      return f.isCDATA;
    } }), Object.defineProperty(u, "isText", { enumerable: !0, get: function() {
      return f.isText;
    } }), Object.defineProperty(u, "isComment", { enumerable: !0, get: function() {
      return f.isComment;
    } }), Object.defineProperty(u, "isDocument", { enumerable: !0, get: function() {
      return f.isDocument;
    } }), Object.defineProperty(u, "hasChildren", { enumerable: !0, get: function() {
      return f.hasChildren;
    } });
  })(ge)), ge;
}
var xu;
function _r() {
  return xu || (xu = 1, (function(u) {
    var x = ee && ee.__createBinding || (Object.create ? (function(n, h, v, S) {
      S === void 0 && (S = v);
      var s = Object.getOwnPropertyDescriptor(h, v);
      (!s || ("get" in s ? !h.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return h[v];
      } }), Object.defineProperty(n, S, s);
    }) : (function(n, h, v, S) {
      S === void 0 && (S = v), n[S] = h[v];
    })), m = ee && ee.__setModuleDefault || (Object.create ? (function(n, h) {
      Object.defineProperty(n, "default", { enumerable: !0, value: h });
    }) : function(n, h) {
      n.default = h;
    }), f = ee && ee.__importStar || function(n) {
      if (n && n.__esModule) return n;
      var h = {};
      if (n != null) for (var v in n) v !== "default" && Object.prototype.hasOwnProperty.call(n, v) && x(h, n, v);
      return m(h, n), h;
    }, l = ee && ee.__importDefault || function(n) {
      return n && n.__esModule ? n : { default: n };
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.DomUtils = u.parseFeed = u.getFeed = u.ElementType = u.Tokenizer = u.createDomStream = u.parseDOM = u.parseDocument = u.DefaultHandler = u.DomHandler = u.Parser = void 0;
    var p = /* @__PURE__ */ eu(), a = /* @__PURE__ */ eu();
    Object.defineProperty(u, "Parser", { enumerable: !0, get: function() {
      return a.Parser;
    } });
    var d = /* @__PURE__ */ he(), b = /* @__PURE__ */ he();
    Object.defineProperty(u, "DomHandler", { enumerable: !0, get: function() {
      return b.DomHandler;
    } }), Object.defineProperty(u, "DefaultHandler", { enumerable: !0, get: function() {
      return b.DomHandler;
    } });
    function i(n, h) {
      var v = new d.DomHandler(void 0, h);
      return new p.Parser(v, h).end(n), v.root;
    }
    u.parseDocument = i;
    function r(n, h) {
      return i(n, h).children;
    }
    u.parseDOM = r;
    function c(n, h, v) {
      var S = new d.DomHandler(n, h, v);
      return new p.Parser(S, h);
    }
    u.createDomStream = c;
    var e = /* @__PURE__ */ ur();
    Object.defineProperty(u, "Tokenizer", { enumerable: !0, get: function() {
      return l(e).default;
    } }), u.ElementType = f(/* @__PURE__ */ qe());
    var t = /* @__PURE__ */ tt(), o = /* @__PURE__ */ tt();
    Object.defineProperty(u, "getFeed", { enumerable: !0, get: function() {
      return o.getFeed;
    } });
    var y = { xmlMode: !0 };
    function g(n, h) {
      return h === void 0 && (h = y), (0, t.getFeed)(r(n, h));
    }
    u.parseFeed = g, u.DomUtils = f(/* @__PURE__ */ tt());
  })(ee)), ee;
}
var ut, wu;
function Rr() {
  return wu || (wu = 1, ut = (u) => {
    if (typeof u != "string")
      throw new TypeError("Expected a string");
    return u.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }), ut;
}
var Pe = {}, Su;
function Pr() {
  if (Su) return Pe;
  Su = 1, Object.defineProperty(Pe, "__esModule", { value: !0 });
  function u(m) {
    return Object.prototype.toString.call(m) === "[object Object]";
  }
  function x(m) {
    var f, l;
    return u(m) === !1 ? !1 : (f = m.constructor, f === void 0 ? !0 : (l = f.prototype, !(u(l) === !1 || l.hasOwnProperty("isPrototypeOf") === !1)));
  }
  return Pe.isPlainObject = x, Pe;
}
var rt, Eu;
function kr() {
  if (Eu) return rt;
  Eu = 1;
  var u = function(h) {
    return x(h) && !m(h);
  };
  function x(n) {
    return !!n && typeof n == "object";
  }
  function m(n) {
    var h = Object.prototype.toString.call(n);
    return h === "[object RegExp]" || h === "[object Date]" || p(n);
  }
  var f = typeof Symbol == "function" && Symbol.for, l = f ? /* @__PURE__ */ Symbol.for("react.element") : 60103;
  function p(n) {
    return n.$$typeof === l;
  }
  function a(n) {
    return Array.isArray(n) ? [] : {};
  }
  function d(n, h) {
    return h.clone !== !1 && h.isMergeableObject(n) ? y(a(n), n, h) : n;
  }
  function b(n, h, v) {
    return n.concat(h).map(function(S) {
      return d(S, v);
    });
  }
  function i(n, h) {
    if (!h.customMerge)
      return y;
    var v = h.customMerge(n);
    return typeof v == "function" ? v : y;
  }
  function r(n) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(n).filter(function(h) {
      return Object.propertyIsEnumerable.call(n, h);
    }) : [];
  }
  function c(n) {
    return Object.keys(n).concat(r(n));
  }
  function e(n, h) {
    try {
      return h in n;
    } catch {
      return !1;
    }
  }
  function t(n, h) {
    return e(n, h) && !(Object.hasOwnProperty.call(n, h) && Object.propertyIsEnumerable.call(n, h));
  }
  function o(n, h, v) {
    var S = {};
    return v.isMergeableObject(n) && c(n).forEach(function(s) {
      S[s] = d(n[s], v);
    }), c(h).forEach(function(s) {
      t(n, s) || (e(n, s) && v.isMergeableObject(h[s]) ? S[s] = i(s, v)(n[s], h[s], v) : S[s] = d(h[s], v));
    }), S;
  }
  function y(n, h, v) {
    v = v || {}, v.arrayMerge = v.arrayMerge || b, v.isMergeableObject = v.isMergeableObject || u, v.cloneUnlessOtherwiseSpecified = d;
    var S = Array.isArray(h), s = Array.isArray(n), w = S === s;
    return w ? S ? v.arrayMerge(n, h, v) : o(n, h, v) : d(h, v);
  }
  y.all = function(h, v) {
    if (!Array.isArray(h))
      throw new Error("first argument should be an array");
    return h.reduce(function(S, s) {
      return y(S, s, v);
    }, {});
  };
  var g = y;
  return rt = g, rt;
}
var Be = { exports: {} }, Mr = Be.exports, Tu;
function Br() {
  return Tu || (Tu = 1, (function(u) {
    (function(x, m) {
      u.exports ? u.exports = m() : x.parseSrcset = m();
    })(Mr, function() {
      return function(x) {
        function m(S) {
          return S === " " || // space
          S === "	" || // horizontal tab
          S === `
` || // new line
          S === "\f" || // form feed
          S === "\r";
        }
        function f(S) {
          var s, w = S.exec(x.substring(g));
          if (w)
            return s = w[0], g += s.length, s;
        }
        for (var l = x.length, p = /^[ \t\n\r\u000c]+/, a = /^[, \t\n\r\u000c]+/, d = /^[^ \t\n\r\u000c]+/, b = /[,]+$/, i = /^\d+$/, r = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, c, e, t, o, y, g = 0, n = []; ; ) {
          if (f(a), g >= l)
            return n;
          c = f(d), e = [], c.slice(-1) === "," ? (c = c.replace(b, ""), v()) : h();
        }
        function h() {
          for (f(p), t = "", o = "in descriptor"; ; ) {
            if (y = x.charAt(g), o === "in descriptor")
              if (m(y))
                t && (e.push(t), t = "", o = "after descriptor");
              else if (y === ",") {
                g += 1, t && e.push(t), v();
                return;
              } else if (y === "(")
                t = t + y, o = "in parens";
              else if (y === "") {
                t && e.push(t), v();
                return;
              } else
                t = t + y;
            else if (o === "in parens")
              if (y === ")")
                t = t + y, o = "in descriptor";
              else if (y === "") {
                e.push(t), v();
                return;
              } else
                t = t + y;
            else if (o === "after descriptor" && !m(y))
              if (y === "") {
                v();
                return;
              } else
                o = "in descriptor", g -= 1;
            g += 1;
          }
        }
        function v() {
          var S = !1, s, w, E, A, L = {}, D, T, q, I, R;
          for (A = 0; A < e.length; A++)
            D = e[A], T = D[D.length - 1], q = D.substring(0, D.length - 1), I = parseInt(q, 10), R = parseFloat(q), i.test(q) && T === "w" ? ((s || w) && (S = !0), I === 0 ? S = !0 : s = I) : r.test(q) && T === "x" ? ((s || w || E) && (S = !0), R < 0 ? S = !0 : w = R) : i.test(q) && T === "h" ? ((E || w) && (S = !0), I === 0 ? S = !0 : E = I) : S = !0;
          S ? console && console.log && console.log("Invalid srcset descriptor found in '" + x + "' at '" + D + "'.") : (L.url = c, s && (L.w = s), w && (L.d = w), E && (L.h = E), n.push(L));
        }
      };
    });
  })(Be)), Be.exports;
}
var ke = { exports: {} }, Au;
function Ur() {
  if (Au) return ke.exports;
  Au = 1;
  var u = String, x = function() {
    return { isColorSupported: !1, reset: u, bold: u, dim: u, italic: u, underline: u, inverse: u, hidden: u, strikethrough: u, black: u, red: u, green: u, yellow: u, blue: u, magenta: u, cyan: u, white: u, gray: u, bgBlack: u, bgRed: u, bgGreen: u, bgYellow: u, bgBlue: u, bgMagenta: u, bgCyan: u, bgWhite: u, blackBright: u, redBright: u, greenBright: u, yellowBright: u, blueBright: u, magentaBright: u, cyanBright: u, whiteBright: u, bgBlackBright: u, bgRedBright: u, bgGreenBright: u, bgYellowBright: u, bgBlueBright: u, bgMagentaBright: u, bgCyanBright: u, bgWhiteBright: u };
  };
  return ke.exports = x(), ke.exports.createColors = x, ke.exports;
}
const jr = {}, Hr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jr
}, Symbol.toStringTag, { value: "Module" })), ie = /* @__PURE__ */ Sr(Hr);
var it, qu;
function kt() {
  if (qu) return it;
  qu = 1;
  let u = /* @__PURE__ */ Ur(), x = ie;
  class m extends Error {
    constructor(l, p, a, d, b, i) {
      super(l), this.name = "CssSyntaxError", this.reason = l, b && (this.file = b), d && (this.source = d), i && (this.plugin = i), typeof p < "u" && typeof a < "u" && (typeof p == "number" ? (this.line = p, this.column = a) : (this.line = p.line, this.column = p.column, this.endLine = a.line, this.endColumn = a.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, m);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(l) {
      if (!this.source) return "";
      let p = this.source;
      l == null && (l = u.isColorSupported);
      let a = (t) => t, d = (t) => t, b = (t) => t;
      if (l) {
        let { bold: t, gray: o, red: y } = u.createColors(!0);
        d = (g) => t(y(g)), a = (g) => o(g), x && (b = (g) => x(g));
      }
      let i = p.split(/\r?\n/), r = Math.max(this.line - 3, 0), c = Math.min(this.line + 2, i.length), e = String(c).length;
      return i.slice(r, c).map((t, o) => {
        let y = r + 1 + o, g = " " + (" " + y).slice(-e) + " | ";
        if (y === this.line) {
          if (t.length > 160) {
            let h = 20, v = Math.max(0, this.column - h), S = Math.max(
              this.column + h,
              this.endColumn + h
            ), s = t.slice(v, S), w = a(g.replace(/\d/g, " ")) + t.slice(0, Math.min(this.column - 1, h - 1)).replace(/[^\t]/g, " ");
            return d(">") + a(g) + b(s) + `
 ` + w + d("^");
          }
          let n = a(g.replace(/\d/g, " ")) + t.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return d(">") + a(g) + b(t) + `
 ` + n + d("^");
        }
        return " " + a(g) + b(t);
      }).join(`
`);
    }
    toString() {
      let l = this.showSourceCode();
      return l && (l = `

` + l + `
`), this.name + ": " + this.message + l;
    }
  }
  return it = m, m.default = m, it;
}
var nt, Nu;
function ar() {
  if (Nu) return nt;
  Nu = 1;
  const u = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function x(f) {
    return f[0].toUpperCase() + f.slice(1);
  }
  class m {
    constructor(l) {
      this.builder = l;
    }
    atrule(l, p) {
      let a = "@" + l.name, d = l.params ? this.rawValue(l, "params") : "";
      if (typeof l.raws.afterName < "u" ? a += l.raws.afterName : d && (a += " "), l.nodes)
        this.block(l, a + d);
      else {
        let b = (l.raws.between || "") + (p ? ";" : "");
        this.builder(a + d + b, l);
      }
    }
    beforeAfter(l, p) {
      let a;
      l.type === "decl" ? a = this.raw(l, null, "beforeDecl") : l.type === "comment" ? a = this.raw(l, null, "beforeComment") : p === "before" ? a = this.raw(l, null, "beforeRule") : a = this.raw(l, null, "beforeClose");
      let d = l.parent, b = 0;
      for (; d && d.type !== "root"; )
        b += 1, d = d.parent;
      if (a.includes(`
`)) {
        let i = this.raw(l, null, "indent");
        if (i.length)
          for (let r = 0; r < b; r++) a += i;
      }
      return a;
    }
    block(l, p) {
      let a = this.raw(l, "between", "beforeOpen");
      this.builder(p + a + "{", l, "start");
      let d;
      l.nodes && l.nodes.length ? (this.body(l), d = this.raw(l, "after")) : d = this.raw(l, "after", "emptyBody"), d && this.builder(d), this.builder("}", l, "end");
    }
    body(l) {
      let p = l.nodes.length - 1;
      for (; p > 0 && l.nodes[p].type === "comment"; )
        p -= 1;
      let a = this.raw(l, "semicolon");
      for (let d = 0; d < l.nodes.length; d++) {
        let b = l.nodes[d], i = this.raw(b, "before");
        i && this.builder(i), this.stringify(b, p !== d || a);
      }
    }
    comment(l) {
      let p = this.raw(l, "left", "commentLeft"), a = this.raw(l, "right", "commentRight");
      this.builder("/*" + p + l.text + a + "*/", l);
    }
    decl(l, p) {
      let a = this.raw(l, "between", "colon"), d = l.prop + a + this.rawValue(l, "value");
      l.important && (d += l.raws.important || " !important"), p && (d += ";"), this.builder(d, l);
    }
    document(l) {
      this.body(l);
    }
    raw(l, p, a) {
      let d;
      if (a || (a = p), p && (d = l.raws[p], typeof d < "u"))
        return d;
      let b = l.parent;
      if (a === "before" && (!b || b.type === "root" && b.first === l || b && b.type === "document"))
        return "";
      if (!b) return u[a];
      let i = l.root();
      if (i.rawCache || (i.rawCache = {}), typeof i.rawCache[a] < "u")
        return i.rawCache[a];
      if (a === "before" || a === "after")
        return this.beforeAfter(l, a);
      {
        let r = "raw" + x(a);
        this[r] ? d = this[r](i, l) : i.walk((c) => {
          if (d = c.raws[p], typeof d < "u") return !1;
        });
      }
      return typeof d > "u" && (d = u[a]), i.rawCache[a] = d, d;
    }
    rawBeforeClose(l) {
      let p;
      return l.walk((a) => {
        if (a.nodes && a.nodes.length > 0 && typeof a.raws.after < "u")
          return p = a.raws.after, p.includes(`
`) && (p = p.replace(/[^\n]+$/, "")), !1;
      }), p && (p = p.replace(/\S/g, "")), p;
    }
    rawBeforeComment(l, p) {
      let a;
      return l.walkComments((d) => {
        if (typeof d.raws.before < "u")
          return a = d.raws.before, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), typeof a > "u" ? a = this.raw(p, null, "beforeDecl") : a && (a = a.replace(/\S/g, "")), a;
    }
    rawBeforeDecl(l, p) {
      let a;
      return l.walkDecls((d) => {
        if (typeof d.raws.before < "u")
          return a = d.raws.before, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), typeof a > "u" ? a = this.raw(p, null, "beforeRule") : a && (a = a.replace(/\S/g, "")), a;
    }
    rawBeforeOpen(l) {
      let p;
      return l.walk((a) => {
        if (a.type !== "decl" && (p = a.raws.between, typeof p < "u"))
          return !1;
      }), p;
    }
    rawBeforeRule(l) {
      let p;
      return l.walk((a) => {
        if (a.nodes && (a.parent !== l || l.first !== a) && typeof a.raws.before < "u")
          return p = a.raws.before, p.includes(`
`) && (p = p.replace(/[^\n]+$/, "")), !1;
      }), p && (p = p.replace(/\S/g, "")), p;
    }
    rawColon(l) {
      let p;
      return l.walkDecls((a) => {
        if (typeof a.raws.between < "u")
          return p = a.raws.between.replace(/[^\s:]/g, ""), !1;
      }), p;
    }
    rawEmptyBody(l) {
      let p;
      return l.walk((a) => {
        if (a.nodes && a.nodes.length === 0 && (p = a.raws.after, typeof p < "u"))
          return !1;
      }), p;
    }
    rawIndent(l) {
      if (l.raws.indent) return l.raws.indent;
      let p;
      return l.walk((a) => {
        let d = a.parent;
        if (d && d !== l && d.parent && d.parent === l && typeof a.raws.before < "u") {
          let b = a.raws.before.split(`
`);
          return p = b[b.length - 1], p = p.replace(/\S/g, ""), !1;
        }
      }), p;
    }
    rawSemicolon(l) {
      let p;
      return l.walk((a) => {
        if (a.nodes && a.nodes.length && a.last.type === "decl" && (p = a.raws.semicolon, typeof p < "u"))
          return !1;
      }), p;
    }
    rawValue(l, p) {
      let a = l[p], d = l.raws[p];
      return d && d.value === a ? d.raw : a;
    }
    root(l) {
      this.body(l), l.raws.after && this.builder(l.raws.after);
    }
    rule(l) {
      this.block(l, this.rawValue(l, "selector")), l.raws.ownSemicolon && this.builder(l.raws.ownSemicolon, l, "end");
    }
    stringify(l, p) {
      if (!this[l.type])
        throw new Error(
          "Unknown AST node type " + l.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[l.type](l, p);
    }
  }
  return nt = m, m.default = m, nt;
}
var at, Ou;
function Ve() {
  if (Ou) return at;
  Ou = 1;
  let u = ar();
  function x(m, f) {
    new u(f).stringify(m);
  }
  return at = x, x.default = x, at;
}
var Me = {}, Lu;
function Mt() {
  return Lu || (Lu = 1, Me.isClean = /* @__PURE__ */ Symbol("isClean"), Me.my = /* @__PURE__ */ Symbol("my")), Me;
}
var st, Du;
function Fe() {
  if (Du) return st;
  Du = 1;
  let u = kt(), x = ar(), m = Ve(), { isClean: f, my: l } = Mt();
  function p(b, i) {
    let r = new b.constructor();
    for (let c in b) {
      if (!Object.prototype.hasOwnProperty.call(b, c) || c === "proxyCache") continue;
      let e = b[c], t = typeof e;
      c === "parent" && t === "object" ? i && (r[c] = i) : c === "source" ? r[c] = e : Array.isArray(e) ? r[c] = e.map((o) => p(o, r)) : (t === "object" && e !== null && (e = p(e)), r[c] = e);
    }
    return r;
  }
  function a(b, i) {
    if (i && typeof i.offset < "u")
      return i.offset;
    let r = 1, c = 1, e = 0;
    for (let t = 0; t < b.length; t++) {
      if (c === i.line && r === i.column) {
        e = t;
        break;
      }
      b[t] === `
` ? (r = 1, c += 1) : r += 1;
    }
    return e;
  }
  class d {
    get proxyOf() {
      return this;
    }
    constructor(i = {}) {
      this.raws = {}, this[f] = !1, this[l] = !0;
      for (let r in i)
        if (r === "nodes") {
          this.nodes = [];
          for (let c of i[r])
            typeof c.clone == "function" ? this.append(c.clone()) : this.append(c);
        } else
          this[r] = i[r];
    }
    addToError(i) {
      if (i.postcssNode = this, i.stack && this.source && /\n\s{4}at /.test(i.stack)) {
        let r = this.source;
        i.stack = i.stack.replace(
          /\n\s{4}at /,
          `$&${r.input.from}:${r.start.line}:${r.start.column}$&`
        );
      }
      return i;
    }
    after(i) {
      return this.parent.insertAfter(this, i), this;
    }
    assign(i = {}) {
      for (let r in i)
        this[r] = i[r];
      return this;
    }
    before(i) {
      return this.parent.insertBefore(this, i), this;
    }
    cleanRaws(i) {
      delete this.raws.before, delete this.raws.after, i || delete this.raws.between;
    }
    clone(i = {}) {
      let r = p(this);
      for (let c in i)
        r[c] = i[c];
      return r;
    }
    cloneAfter(i = {}) {
      let r = this.clone(i);
      return this.parent.insertAfter(this, r), r;
    }
    cloneBefore(i = {}) {
      let r = this.clone(i);
      return this.parent.insertBefore(this, r), r;
    }
    error(i, r = {}) {
      if (this.source) {
        let { end: c, start: e } = this.rangeBy(r);
        return this.source.input.error(
          i,
          { column: e.column, line: e.line },
          { column: c.column, line: c.line },
          r
        );
      }
      return new u(i);
    }
    getProxyProcessor() {
      return {
        get(i, r) {
          return r === "proxyOf" ? i : r === "root" ? () => i.root().toProxy() : i[r];
        },
        set(i, r, c) {
          return i[r] === c || (i[r] = c, (r === "prop" || r === "value" || r === "name" || r === "params" || r === "important" || /* c8 ignore next */
          r === "text") && i.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[f] = !0;
    }
    markDirty() {
      if (this[f]) {
        this[f] = !1;
        let i = this;
        for (; i = i.parent; )
          i[f] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let i = this.parent.index(this);
      return this.parent.nodes[i + 1];
    }
    positionBy(i = {}) {
      let r = this.source.start;
      if (i.index)
        r = this.positionInside(i.index);
      else if (i.word) {
        let c = "document" in this.source.input ? this.source.input.document : this.source.input.css, t = c.slice(
          a(c, this.source.start),
          a(c, this.source.end)
        ).indexOf(i.word);
        t !== -1 && (r = this.positionInside(t));
      }
      return r;
    }
    positionInside(i) {
      let r = this.source.start.column, c = this.source.start.line, e = "document" in this.source.input ? this.source.input.document : this.source.input.css, t = a(e, this.source.start), o = t + i;
      for (let y = t; y < o; y++)
        e[y] === `
` ? (r = 1, c += 1) : r += 1;
      return { column: r, line: c, offset: o };
    }
    prev() {
      if (!this.parent) return;
      let i = this.parent.index(this);
      return this.parent.nodes[i - 1];
    }
    rangeBy(i = {}) {
      let r = "document" in this.source.input ? this.source.input.document : this.source.input.css, c = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: a(r, this.source.start)
      }, e = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line,
        offset: typeof this.source.end.offset == "number" ? (
          // `source.end.offset` is exclusive, so we don't need to add 1
          this.source.end.offset
        ) : (
          // Since line/column in this.source.end is inclusive,
          // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
          // So, we add 1 to convert it to exclusive.
          a(r, this.source.end) + 1
        )
      } : {
        column: c.column + 1,
        line: c.line,
        offset: c.offset + 1
      };
      if (i.word) {
        let o = r.slice(
          a(r, this.source.start),
          a(r, this.source.end)
        ).indexOf(i.word);
        o !== -1 && (c = this.positionInside(o), e = this.positionInside(o + i.word.length));
      } else
        i.start ? c = {
          column: i.start.column,
          line: i.start.line,
          offset: a(r, i.start)
        } : i.index && (c = this.positionInside(i.index)), i.end ? e = {
          column: i.end.column,
          line: i.end.line,
          offset: a(r, i.end)
        } : typeof i.endIndex == "number" ? e = this.positionInside(i.endIndex) : i.index && (e = this.positionInside(i.index + 1));
      return (e.line < c.line || e.line === c.line && e.column <= c.column) && (e = {
        column: c.column + 1,
        line: c.line,
        offset: c.offset + 1
      }), { end: e, start: c };
    }
    raw(i, r) {
      return new x().raw(this, i, r);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...i) {
      if (this.parent) {
        let r = this, c = !1;
        for (let e of i)
          e === this ? c = !0 : c ? (this.parent.insertAfter(r, e), r = e) : this.parent.insertBefore(r, e);
        c || this.remove();
      }
      return this;
    }
    root() {
      let i = this;
      for (; i.parent && i.parent.type !== "document"; )
        i = i.parent;
      return i;
    }
    toJSON(i, r) {
      let c = {}, e = r == null;
      r = r || /* @__PURE__ */ new Map();
      let t = 0;
      for (let o in this) {
        if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
        let y = this[o];
        if (Array.isArray(y))
          c[o] = y.map((g) => typeof g == "object" && g.toJSON ? g.toJSON(null, r) : g);
        else if (typeof y == "object" && y.toJSON)
          c[o] = y.toJSON(null, r);
        else if (o === "source") {
          if (y == null) continue;
          let g = r.get(y.input);
          g == null && (g = t, r.set(y.input, t), t++), c[o] = {
            end: y.end,
            inputId: g,
            start: y.start
          };
        } else
          c[o] = y;
      }
      return e && (c.inputs = [...r.keys()].map((o) => o.toJSON())), c;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(i = m) {
      i.stringify && (i = i.stringify);
      let r = "";
      return i(this, (c) => {
        r += c;
      }), r;
    }
    warn(i, r, c = {}) {
      let e = { node: this };
      for (let t in c) e[t] = c[t];
      return i.warn(r, e);
    }
  }
  return st = d, d.default = d, st;
}
var ot, Cu;
function ze() {
  if (Cu) return ot;
  Cu = 1;
  let u = Fe();
  class x extends u {
    constructor(f) {
      super(f), this.type = "comment";
    }
  }
  return ot = x, x.default = x, ot;
}
var ct, Iu;
function Ge() {
  if (Iu) return ct;
  Iu = 1;
  let u = Fe();
  class x extends u {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(f) {
      f && typeof f.value < "u" && typeof f.value != "string" && (f = { ...f, value: String(f.value) }), super(f), this.type = "decl";
    }
  }
  return ct = x, x.default = x, ct;
}
var lt, _u;
function ve() {
  if (_u) return lt;
  _u = 1;
  let u = ze(), x = Ge(), m = Fe(), { isClean: f, my: l } = Mt(), p, a, d, b;
  function i(e) {
    return e.map((t) => (t.nodes && (t.nodes = i(t.nodes)), delete t.source, t));
  }
  function r(e) {
    if (e[f] = !1, e.proxyOf.nodes)
      for (let t of e.proxyOf.nodes)
        r(t);
  }
  class c extends m {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...t) {
      for (let o of t) {
        let y = this.normalize(o, this.last);
        for (let g of y) this.proxyOf.nodes.push(g);
      }
      return this.markDirty(), this;
    }
    cleanRaws(t) {
      if (super.cleanRaws(t), this.nodes)
        for (let o of this.nodes) o.cleanRaws(t);
    }
    each(t) {
      if (!this.proxyOf.nodes) return;
      let o = this.getIterator(), y, g;
      for (; this.indexes[o] < this.proxyOf.nodes.length && (y = this.indexes[o], g = t(this.proxyOf.nodes[y], y), g !== !1); )
        this.indexes[o] += 1;
      return delete this.indexes[o], g;
    }
    every(t) {
      return this.nodes.every(t);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let t = this.lastEach;
      return this.indexes[t] = 0, t;
    }
    getProxyProcessor() {
      return {
        get(t, o) {
          return o === "proxyOf" ? t : t[o] ? o === "each" || typeof o == "string" && o.startsWith("walk") ? (...y) => t[o](
            ...y.map((g) => typeof g == "function" ? (n, h) => g(n.toProxy(), h) : g)
          ) : o === "every" || o === "some" ? (y) => t[o](
            (g, ...n) => y(g.toProxy(), ...n)
          ) : o === "root" ? () => t.root().toProxy() : o === "nodes" ? t.nodes.map((y) => y.toProxy()) : o === "first" || o === "last" ? t[o].toProxy() : t[o] : t[o];
        },
        set(t, o, y) {
          return t[o] === y || (t[o] = y, (o === "name" || o === "params" || o === "selector") && t.markDirty()), !0;
        }
      };
    }
    index(t) {
      return typeof t == "number" ? t : (t.proxyOf && (t = t.proxyOf), this.proxyOf.nodes.indexOf(t));
    }
    insertAfter(t, o) {
      let y = this.index(t), g = this.normalize(o, this.proxyOf.nodes[y]).reverse();
      y = this.index(t);
      for (let h of g) this.proxyOf.nodes.splice(y + 1, 0, h);
      let n;
      for (let h in this.indexes)
        n = this.indexes[h], y < n && (this.indexes[h] = n + g.length);
      return this.markDirty(), this;
    }
    insertBefore(t, o) {
      let y = this.index(t), g = y === 0 ? "prepend" : !1, n = this.normalize(
        o,
        this.proxyOf.nodes[y],
        g
      ).reverse();
      y = this.index(t);
      for (let v of n) this.proxyOf.nodes.splice(y, 0, v);
      let h;
      for (let v in this.indexes)
        h = this.indexes[v], y <= h && (this.indexes[v] = h + n.length);
      return this.markDirty(), this;
    }
    normalize(t, o) {
      if (typeof t == "string")
        t = i(a(t).nodes);
      else if (typeof t > "u")
        t = [];
      else if (Array.isArray(t)) {
        t = t.slice(0);
        for (let g of t)
          g.parent && g.parent.removeChild(g, "ignore");
      } else if (t.type === "root" && this.type !== "document") {
        t = t.nodes.slice(0);
        for (let g of t)
          g.parent && g.parent.removeChild(g, "ignore");
      } else if (t.type)
        t = [t];
      else if (t.prop) {
        if (typeof t.value > "u")
          throw new Error("Value field is missed in node creation");
        typeof t.value != "string" && (t.value = String(t.value)), t = [new x(t)];
      } else if (t.selector || t.selectors)
        t = [new b(t)];
      else if (t.name)
        t = [new p(t)];
      else if (t.text)
        t = [new u(t)];
      else
        throw new Error("Unknown node type in node creation");
      return t.map((g) => (g[l] || c.rebuild(g), g = g.proxyOf, g.parent && g.parent.removeChild(g), g[f] && r(g), g.raws || (g.raws = {}), typeof g.raws.before > "u" && o && typeof o.raws.before < "u" && (g.raws.before = o.raws.before.replace(/\S/g, "")), g.parent = this.proxyOf, g));
    }
    prepend(...t) {
      t = t.reverse();
      for (let o of t) {
        let y = this.normalize(o, this.first, "prepend").reverse();
        for (let g of y) this.proxyOf.nodes.unshift(g);
        for (let g in this.indexes)
          this.indexes[g] = this.indexes[g] + y.length;
      }
      return this.markDirty(), this;
    }
    push(t) {
      return t.parent = this, this.proxyOf.nodes.push(t), this;
    }
    removeAll() {
      for (let t of this.proxyOf.nodes) t.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(t) {
      t = this.index(t), this.proxyOf.nodes[t].parent = void 0, this.proxyOf.nodes.splice(t, 1);
      let o;
      for (let y in this.indexes)
        o = this.indexes[y], o >= t && (this.indexes[y] = o - 1);
      return this.markDirty(), this;
    }
    replaceValues(t, o, y) {
      return y || (y = o, o = {}), this.walkDecls((g) => {
        o.props && !o.props.includes(g.prop) || o.fast && !g.value.includes(o.fast) || (g.value = g.value.replace(t, y));
      }), this.markDirty(), this;
    }
    some(t) {
      return this.nodes.some(t);
    }
    walk(t) {
      return this.each((o, y) => {
        let g;
        try {
          g = t(o, y);
        } catch (n) {
          throw o.addToError(n);
        }
        return g !== !1 && o.walk && (g = o.walk(t)), g;
      });
    }
    walkAtRules(t, o) {
      return o ? t instanceof RegExp ? this.walk((y, g) => {
        if (y.type === "atrule" && t.test(y.name))
          return o(y, g);
      }) : this.walk((y, g) => {
        if (y.type === "atrule" && y.name === t)
          return o(y, g);
      }) : (o = t, this.walk((y, g) => {
        if (y.type === "atrule")
          return o(y, g);
      }));
    }
    walkComments(t) {
      return this.walk((o, y) => {
        if (o.type === "comment")
          return t(o, y);
      });
    }
    walkDecls(t, o) {
      return o ? t instanceof RegExp ? this.walk((y, g) => {
        if (y.type === "decl" && t.test(y.prop))
          return o(y, g);
      }) : this.walk((y, g) => {
        if (y.type === "decl" && y.prop === t)
          return o(y, g);
      }) : (o = t, this.walk((y, g) => {
        if (y.type === "decl")
          return o(y, g);
      }));
    }
    walkRules(t, o) {
      return o ? t instanceof RegExp ? this.walk((y, g) => {
        if (y.type === "rule" && t.test(y.selector))
          return o(y, g);
      }) : this.walk((y, g) => {
        if (y.type === "rule" && y.selector === t)
          return o(y, g);
      }) : (o = t, this.walk((y, g) => {
        if (y.type === "rule")
          return o(y, g);
      }));
    }
  }
  return c.registerParse = (e) => {
    a = e;
  }, c.registerRule = (e) => {
    b = e;
  }, c.registerAtRule = (e) => {
    p = e;
  }, c.registerRoot = (e) => {
    d = e;
  }, lt = c, c.default = c, c.rebuild = (e) => {
    e.type === "atrule" ? Object.setPrototypeOf(e, p.prototype) : e.type === "rule" ? Object.setPrototypeOf(e, b.prototype) : e.type === "decl" ? Object.setPrototypeOf(e, x.prototype) : e.type === "comment" ? Object.setPrototypeOf(e, u.prototype) : e.type === "root" && Object.setPrototypeOf(e, d.prototype), e[l] = !0, e.nodes && e.nodes.forEach((t) => {
      c.rebuild(t);
    });
  }, lt;
}
var ft, Ru;
function Bt() {
  if (Ru) return ft;
  Ru = 1;
  let u = ve();
  class x extends u {
    constructor(f) {
      super(f), this.type = "atrule";
    }
    append(...f) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...f);
    }
    prepend(...f) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...f);
    }
  }
  return ft = x, x.default = x, u.registerAtRule(x), ft;
}
var dt, Pu;
function Ut() {
  if (Pu) return dt;
  Pu = 1;
  let u = ve(), x, m;
  class f extends u {
    constructor(p) {
      super({ type: "document", ...p }), this.nodes || (this.nodes = []);
    }
    toResult(p = {}) {
      return new x(new m(), this, p).stringify();
    }
  }
  return f.registerLazyResult = (l) => {
    x = l;
  }, f.registerProcessor = (l) => {
    m = l;
  }, dt = f, f.default = f, dt;
}
var ht, ku;
function Vr() {
  if (ku) return ht;
  ku = 1;
  let u = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return ht = { nanoid: (f = 21) => {
    let l = "", p = f | 0;
    for (; p--; )
      l += u[Math.random() * 64 | 0];
    return l;
  }, customAlphabet: (f, l = 21) => (p = l) => {
    let a = "", d = p | 0;
    for (; d--; )
      a += f[Math.random() * f.length | 0];
    return a;
  } }, ht;
}
var pt, Mu;
function sr() {
  if (Mu) return pt;
  Mu = 1;
  let { existsSync: u, readFileSync: x } = ie, { dirname: m, join: f } = ie, { SourceMapConsumer: l, SourceMapGenerator: p } = ie;
  function a(b) {
    return Buffer ? Buffer.from(b, "base64").toString() : window.atob(b);
  }
  class d {
    constructor(i, r) {
      if (r.map === !1) return;
      this.loadAnnotation(i), this.inline = this.startWith(this.annotation, "data:");
      let c = r.map ? r.map.prev : void 0, e = this.loadMap(r.from, c);
      !this.mapFile && r.from && (this.mapFile = r.from), this.mapFile && (this.root = m(this.mapFile)), e && (this.text = e);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new l(this.text)), this.consumerCache;
    }
    decodeInline(i) {
      let r = /^data:application\/json;charset=utf-?8;base64,/, c = /^data:application\/json;base64,/, e = /^data:application\/json;charset=utf-?8,/, t = /^data:application\/json,/, o = i.match(e) || i.match(t);
      if (o)
        return decodeURIComponent(i.substr(o[0].length));
      let y = i.match(r) || i.match(c);
      if (y)
        return a(i.substr(y[0].length));
      let g = i.match(/data:application\/json;([^,]+),/)[1];
      throw new Error("Unsupported source map encoding " + g);
    }
    getAnnotationURL(i) {
      return i.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(i) {
      return typeof i != "object" ? !1 : typeof i.mappings == "string" || typeof i._mappings == "string" || Array.isArray(i.sections);
    }
    loadAnnotation(i) {
      let r = i.match(/\/\*\s*# sourceMappingURL=/g);
      if (!r) return;
      let c = i.lastIndexOf(r.pop()), e = i.indexOf("*/", c);
      c > -1 && e > -1 && (this.annotation = this.getAnnotationURL(i.substring(c, e)));
    }
    loadFile(i) {
      if (this.root = m(i), u(i))
        return this.mapFile = i, x(i, "utf-8").toString().trim();
    }
    loadMap(i, r) {
      if (r === !1) return !1;
      if (r) {
        if (typeof r == "string")
          return r;
        if (typeof r == "function") {
          let c = r(i);
          if (c) {
            let e = this.loadFile(c);
            if (!e)
              throw new Error(
                "Unable to load previous source map: " + c.toString()
              );
            return e;
          }
        } else {
          if (r instanceof l)
            return p.fromSourceMap(r).toString();
          if (r instanceof p)
            return r.toString();
          if (this.isMap(r))
            return JSON.stringify(r);
          throw new Error(
            "Unsupported previous source map format: " + r.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let c = this.annotation;
          return i && (c = f(m(i), c)), this.loadFile(c);
        }
      }
    }
    startWith(i, r) {
      return i ? i.substr(0, r.length) === r : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return pt = d, d.default = d, pt;
}
var bt, Bu;
function We() {
  if (Bu) return bt;
  Bu = 1;
  let { nanoid: u } = /* @__PURE__ */ Vr(), { isAbsolute: x, resolve: m } = ie, { SourceMapConsumer: f, SourceMapGenerator: l } = ie, { fileURLToPath: p, pathToFileURL: a } = ie, d = kt(), b = sr(), i = ie, r = /* @__PURE__ */ Symbol("lineToIndexCache"), c = !!(f && l), e = !!(m && x);
  function t(y) {
    if (y[r]) return y[r];
    let g = y.css.split(`
`), n = new Array(g.length), h = 0;
    for (let v = 0, S = g.length; v < S; v++)
      n[v] = h, h += g[v].length + 1;
    return y[r] = n, n;
  }
  class o {
    get from() {
      return this.file || this.id;
    }
    constructor(g, n = {}) {
      if (g === null || typeof g > "u" || typeof g == "object" && !g.toString)
        throw new Error(`PostCSS received ${g} instead of CSS string`);
      if (this.css = g.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, n.document && (this.document = n.document.toString()), n.from && (!e || /^\w+:\/\//.test(n.from) || x(n.from) ? this.file = n.from : this.file = m(n.from)), e && c) {
        let h = new b(this.css, n);
        if (h.text) {
          this.map = h;
          let v = h.consumer().file;
          !this.file && v && (this.file = this.mapResolve(v));
        }
      }
      this.file || (this.id = "<input css " + u(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(g, n, h, v = {}) {
      let S, s, w, E, A;
      if (n && typeof n == "object") {
        let D = n, T = h;
        if (typeof D.offset == "number") {
          E = D.offset;
          let q = this.fromOffset(E);
          n = q.line, h = q.col;
        } else
          n = D.line, h = D.column, E = this.fromLineAndColumn(n, h);
        if (typeof T.offset == "number") {
          w = T.offset;
          let q = this.fromOffset(w);
          s = q.line, S = q.col;
        } else
          s = T.line, S = T.column, w = this.fromLineAndColumn(T.line, T.column);
      } else if (h)
        E = this.fromLineAndColumn(n, h);
      else {
        E = n;
        let D = this.fromOffset(E);
        n = D.line, h = D.col;
      }
      let L = this.origin(n, h, s, S);
      return L ? A = new d(
        g,
        L.endLine === void 0 ? L.line : { column: L.column, line: L.line },
        L.endLine === void 0 ? L.column : { column: L.endColumn, line: L.endLine },
        L.source,
        L.file,
        v.plugin
      ) : A = new d(
        g,
        s === void 0 ? n : { column: h, line: n },
        s === void 0 ? h : { column: S, line: s },
        this.css,
        this.file,
        v.plugin
      ), A.input = { column: h, endColumn: S, endLine: s, endOffset: w, line: n, offset: E, source: this.css }, this.file && (a && (A.input.url = a(this.file).toString()), A.input.file = this.file), A;
    }
    fromLineAndColumn(g, n) {
      return t(this)[g - 1] + n - 1;
    }
    fromOffset(g) {
      let n = t(this), h = n[n.length - 1], v = 0;
      if (g >= h)
        v = n.length - 1;
      else {
        let S = n.length - 2, s;
        for (; v < S; )
          if (s = v + (S - v >> 1), g < n[s])
            S = s - 1;
          else if (g >= n[s + 1])
            v = s + 1;
          else {
            v = s;
            break;
          }
      }
      return {
        col: g - n[v] + 1,
        line: v + 1
      };
    }
    mapResolve(g) {
      return /^\w+:\/\//.test(g) ? g : m(this.map.consumer().sourceRoot || this.map.root || ".", g);
    }
    origin(g, n, h, v) {
      if (!this.map) return !1;
      let S = this.map.consumer(), s = S.originalPositionFor({ column: n, line: g });
      if (!s.source) return !1;
      let w;
      typeof h == "number" && (w = S.originalPositionFor({ column: v, line: h }));
      let E;
      x(s.source) ? E = a(s.source) : E = new URL(
        s.source,
        this.map.consumer().sourceRoot || a(this.map.mapFile)
      );
      let A = {
        column: s.column,
        endColumn: w && w.column,
        endLine: w && w.line,
        line: s.line,
        url: E.toString()
      };
      if (E.protocol === "file:")
        if (p)
          A.file = p(E);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let L = S.sourceContentFor(s.source);
      return L && (A.source = L), A;
    }
    toJSON() {
      let g = {};
      for (let n of ["hasBOM", "css", "file", "id"])
        this[n] != null && (g[n] = this[n]);
      return this.map && (g.map = { ...this.map }, g.map.consumerCache && (g.map.consumerCache = void 0)), g;
    }
  }
  return bt = o, o.default = o, i && i.registerInput && i.registerInput(o), bt;
}
var mt, Uu;
function Ne() {
  if (Uu) return mt;
  Uu = 1;
  let u = ve(), x, m;
  class f extends u {
    constructor(p) {
      super(p), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(p, a, d) {
      let b = super.normalize(p);
      if (a) {
        if (d === "prepend")
          this.nodes.length > 1 ? a.raws.before = this.nodes[1].raws.before : delete a.raws.before;
        else if (this.first !== a)
          for (let i of b)
            i.raws.before = a.raws.before;
      }
      return b;
    }
    removeChild(p, a) {
      let d = this.index(p);
      return !a && d === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[d].raws.before), super.removeChild(p);
    }
    toResult(p = {}) {
      return new x(new m(), this, p).stringify();
    }
  }
  return f.registerLazyResult = (l) => {
    x = l;
  }, f.registerProcessor = (l) => {
    m = l;
  }, mt = f, f.default = f, u.registerRoot(f), mt;
}
var gt, ju;
function or() {
  if (ju) return gt;
  ju = 1;
  let u = {
    comma(x) {
      return u.split(x, [","], !0);
    },
    space(x) {
      let m = [" ", `
`, "	"];
      return u.split(x, m);
    },
    split(x, m, f) {
      let l = [], p = "", a = !1, d = 0, b = !1, i = "", r = !1;
      for (let c of x)
        r ? r = !1 : c === "\\" ? r = !0 : b ? c === i && (b = !1) : c === '"' || c === "'" ? (b = !0, i = c) : c === "(" ? d += 1 : c === ")" ? d > 0 && (d -= 1) : d === 0 && m.includes(c) && (a = !0), a ? (p !== "" && l.push(p.trim()), p = "", a = !1) : p += c;
      return (f || p !== "") && l.push(p.trim()), l;
    }
  };
  return gt = u, u.default = u, gt;
}
var yt, Hu;
function jt() {
  if (Hu) return yt;
  Hu = 1;
  let u = ve(), x = or();
  class m extends u {
    get selectors() {
      return x.comma(this.selector);
    }
    set selectors(l) {
      let p = this.selector ? this.selector.match(/,\s*/) : null, a = p ? p[0] : "," + this.raw("between", "beforeOpen");
      this.selector = l.join(a);
    }
    constructor(l) {
      super(l), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return yt = m, m.default = m, u.registerRule(m), yt;
}
var vt, Vu;
function Fr() {
  if (Vu) return vt;
  Vu = 1;
  let u = Bt(), x = ze(), m = Ge(), f = We(), l = sr(), p = Ne(), a = jt();
  function d(b, i) {
    if (Array.isArray(b)) return b.map((e) => d(e));
    let { inputs: r, ...c } = b;
    if (r) {
      i = [];
      for (let e of r) {
        let t = { ...e, __proto__: f.prototype };
        t.map && (t.map = {
          ...t.map,
          __proto__: l.prototype
        }), i.push(t);
      }
    }
    if (c.nodes && (c.nodes = b.nodes.map((e) => d(e, i))), c.source) {
      let { inputId: e, ...t } = c.source;
      c.source = t, e != null && (c.source.input = i[e]);
    }
    if (c.type === "root")
      return new p(c);
    if (c.type === "decl")
      return new m(c);
    if (c.type === "rule")
      return new a(c);
    if (c.type === "comment")
      return new x(c);
    if (c.type === "atrule")
      return new u(c);
    throw new Error("Unknown node type: " + b.type);
  }
  return vt = d, d.default = d, vt;
}
var xt, Fu;
function cr() {
  if (Fu) return xt;
  Fu = 1;
  let { dirname: u, relative: x, resolve: m, sep: f } = ie, { SourceMapConsumer: l, SourceMapGenerator: p } = ie, { pathToFileURL: a } = ie, d = We(), b = !!(l && p), i = !!(u && m && x && f);
  class r {
    constructor(e, t, o, y) {
      this.stringify = e, this.mapOpts = o.map || {}, this.root = t, this.opts = o, this.css = y, this.originalCSS = y, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let e;
      this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
      let t = `
`;
      this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
    }
    applyPrevMaps() {
      for (let e of this.previous()) {
        let t = this.toUrl(this.path(e.file)), o = e.root || u(e.file), y;
        this.mapOpts.sourcesContent === !1 ? (y = new l(e.text), y.sourcesContent && (y.sourcesContent = null)) : y = e.consumer(), this.map.applySourceMap(y, t, this.toUrl(this.path(o)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1)
        if (this.root) {
          let e;
          for (let t = this.root.nodes.length - 1; t >= 0; t--)
            e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
        } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
    }
    generate() {
      if (this.clearAnnotation(), i && b && this.isMap())
        return this.generateMap();
      {
        let e = "";
        return this.stringify(this.root, (t) => {
          e += t;
        }), [e];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let e = this.previous()[0].consumer();
        e.file = this.outputFile(), this.map = p.fromSourceMap(e, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new p({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new p({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let e = 1, t = 1, o = "<no source>", y = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, g, n;
      this.stringify(this.root, (h, v, S) => {
        if (this.css += h, v && S !== "end" && (y.generated.line = e, y.generated.column = t - 1, v.source && v.source.start ? (y.source = this.sourcePath(v), y.original.line = v.source.start.line, y.original.column = v.source.start.column - 1, this.map.addMapping(y)) : (y.source = o, y.original.line = 1, y.original.column = 0, this.map.addMapping(y))), n = h.match(/\n/g), n ? (e += n.length, g = h.lastIndexOf(`
`), t = h.length - g) : t += h.length, v && S !== "start") {
          let s = v.parent || { raws: {} };
          (!(v.type === "decl" || v.type === "atrule" && !v.nodes) || v !== s.last || s.raws.semicolon) && (v.source && v.source.end ? (y.source = this.sourcePath(v), y.original.line = v.source.end.line, y.original.column = v.source.end.column - 1, y.generated.line = e, y.generated.column = t - 2, this.map.addMapping(y)) : (y.source = o, y.original.line = 1, y.original.column = 0, y.generated.line = e, y.generated.column = t - 1, this.map.addMapping(y)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline < "u")
        return this.mapOpts.inline;
      let e = this.mapOpts.annotation;
      return typeof e < "u" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(e) {
      if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
      let t = this.memoizedPaths.get(e);
      if (t) return t;
      let o = this.opts.to ? u(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (o = u(m(o, this.mapOpts.annotation)));
      let y = x(o, e);
      return this.memoizedPaths.set(e, y), y;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((e) => {
            if (e.source && e.source.input.map) {
              let t = e.source.input.map;
              this.previousMaps.includes(t) || this.previousMaps.push(t);
            }
          });
        else {
          let e = new d(this.originalCSS, this.opts);
          e.map && this.previousMaps.push(e.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let e = {};
      if (this.root)
        this.root.walk((t) => {
          if (t.source) {
            let o = t.source.input.from;
            if (o && !e[o]) {
              e[o] = !0;
              let y = this.usesFileUrls ? this.toFileUrl(o) : this.toUrl(this.path(o));
              this.map.setSourceContent(y, t.source.input.css);
            }
          }
        });
      else if (this.css) {
        let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(t, this.css);
      }
    }
    sourcePath(e) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
    }
    toBase64(e) {
      return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
    }
    toFileUrl(e) {
      let t = this.memoizedFileURLs.get(e);
      if (t) return t;
      if (a) {
        let o = a(e).toString();
        return this.memoizedFileURLs.set(e, o), o;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(e) {
      let t = this.memoizedURLs.get(e);
      if (t) return t;
      f === "\\" && (e = e.replace(/\\/g, "/"));
      let o = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(e, o), o;
    }
  }
  return xt = r, xt;
}
var wt, zu;
function zr() {
  if (zu) return wt;
  zu = 1;
  const u = 39, x = 34, m = 92, f = 47, l = 10, p = 32, a = 12, d = 9, b = 13, i = 91, r = 93, c = 40, e = 41, t = 123, o = 125, y = 59, g = 42, n = 58, h = 64, v = /[\t\n\f\r "#'()/;[\\\]{}]/g, S = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, s = /.[\r\n"'(/\\]/, w = /[\da-f]/i;
  return wt = function(A, L = {}) {
    let D = A.css.valueOf(), T = L.ignoreErrors, q, I, R, N, U, j, z, W, Z, ne, Te = D.length, k = 0, K = [], pe = [];
    function Le() {
      return k;
    }
    function Ae(O) {
      throw A.error("Unclosed " + O, k);
    }
    function Ze() {
      return pe.length === 0 && k >= Te;
    }
    function Xe(O) {
      if (pe.length) return pe.pop();
      if (k >= Te) return;
      let _ = O ? O.ignoreUnclosed : !1;
      switch (q = D.charCodeAt(k), q) {
        case l:
        case p:
        case d:
        case b:
        case a: {
          N = k;
          do
            N += 1, q = D.charCodeAt(N);
          while (q === p || q === l || q === d || q === b || q === a);
          j = ["space", D.slice(k, N)], k = N - 1;
          break;
        }
        case i:
        case r:
        case t:
        case o:
        case n:
        case y:
        case e: {
          let C = String.fromCharCode(q);
          j = [C, C, k];
          break;
        }
        case c: {
          if (ne = K.length ? K.pop()[1] : "", Z = D.charCodeAt(k + 1), ne === "url" && Z !== u && Z !== x && Z !== p && Z !== l && Z !== d && Z !== a && Z !== b) {
            N = k;
            do {
              if (z = !1, N = D.indexOf(")", N + 1), N === -1)
                if (T || _) {
                  N = k;
                  break;
                } else
                  Ae("bracket");
              for (W = N; D.charCodeAt(W - 1) === m; )
                W -= 1, z = !z;
            } while (z);
            j = ["brackets", D.slice(k, N + 1), k, N], k = N;
          } else
            N = D.indexOf(")", k + 1), I = D.slice(k, N + 1), N === -1 || s.test(I) ? j = ["(", "(", k] : (j = ["brackets", I, k, N], k = N);
          break;
        }
        case u:
        case x: {
          U = q === u ? "'" : '"', N = k;
          do {
            if (z = !1, N = D.indexOf(U, N + 1), N === -1)
              if (T || _) {
                N = k + 1;
                break;
              } else
                Ae("string");
            for (W = N; D.charCodeAt(W - 1) === m; )
              W -= 1, z = !z;
          } while (z);
          j = ["string", D.slice(k, N + 1), k, N], k = N;
          break;
        }
        case h: {
          v.lastIndex = k + 1, v.test(D), v.lastIndex === 0 ? N = D.length - 1 : N = v.lastIndex - 2, j = ["at-word", D.slice(k, N + 1), k, N], k = N;
          break;
        }
        case m: {
          for (N = k, R = !0; D.charCodeAt(N + 1) === m; )
            N += 1, R = !R;
          if (q = D.charCodeAt(N + 1), R && q !== f && q !== p && q !== l && q !== d && q !== b && q !== a && (N += 1, w.test(D.charAt(N)))) {
            for (; w.test(D.charAt(N + 1)); )
              N += 1;
            D.charCodeAt(N + 1) === p && (N += 1);
          }
          j = ["word", D.slice(k, N + 1), k, N], k = N;
          break;
        }
        default: {
          q === f && D.charCodeAt(k + 1) === g ? (N = D.indexOf("*/", k + 2) + 1, N === 0 && (T || _ ? N = D.length : Ae("comment")), j = ["comment", D.slice(k, N + 1), k, N], k = N) : (S.lastIndex = k + 1, S.test(D), S.lastIndex === 0 ? N = D.length - 1 : N = S.lastIndex - 2, j = ["word", D.slice(k, N + 1), k, N], K.push(j), k = N);
          break;
        }
      }
      return k++, j;
    }
    function De(O) {
      pe.push(O);
    }
    return {
      back: De,
      endOfFile: Ze,
      nextToken: Xe,
      position: Le
    };
  }, wt;
}
var St, Gu;
function Gr() {
  if (Gu) return St;
  Gu = 1;
  let u = Bt(), x = ze(), m = Ge(), f = Ne(), l = jt(), p = zr();
  const a = {
    empty: !0,
    space: !0
  };
  function d(i) {
    for (let r = i.length - 1; r >= 0; r--) {
      let c = i[r], e = c[3] || c[2];
      if (e) return e;
    }
  }
  class b {
    constructor(r) {
      this.input = r, this.root = new f(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: r, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(r) {
      let c = new u();
      c.name = r[1].slice(1), c.name === "" && this.unnamedAtrule(c, r), this.init(c, r[2]);
      let e, t, o, y = !1, g = !1, n = [], h = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (r = this.tokenizer.nextToken(), e = r[0], e === "(" || e === "[" ? h.push(e === "(" ? ")" : "]") : e === "{" && h.length > 0 ? h.push("}") : e === h[h.length - 1] && h.pop(), h.length === 0)
          if (e === ";") {
            c.source.end = this.getPosition(r[2]), c.source.end.offset++, this.semicolon = !0;
            break;
          } else if (e === "{") {
            g = !0;
            break;
          } else if (e === "}") {
            if (n.length > 0) {
              for (o = n.length - 1, t = n[o]; t && t[0] === "space"; )
                t = n[--o];
              t && (c.source.end = this.getPosition(t[3] || t[2]), c.source.end.offset++);
            }
            this.end(r);
            break;
          } else
            n.push(r);
        else
          n.push(r);
        if (this.tokenizer.endOfFile()) {
          y = !0;
          break;
        }
      }
      c.raws.between = this.spacesAndCommentsFromEnd(n), n.length ? (c.raws.afterName = this.spacesAndCommentsFromStart(n), this.raw(c, "params", n), y && (r = n[n.length - 1], c.source.end = this.getPosition(r[3] || r[2]), c.source.end.offset++, this.spaces = c.raws.between, c.raws.between = "")) : (c.raws.afterName = "", c.params = ""), g && (c.nodes = [], this.current = c);
    }
    checkMissedSemicolon(r) {
      let c = this.colon(r);
      if (c === !1) return;
      let e = 0, t;
      for (let o = c - 1; o >= 0 && (t = r[o], !(t[0] !== "space" && (e += 1, e === 2))); o--)
        ;
      throw this.input.error(
        "Missed semicolon",
        t[0] === "word" ? t[3] + 1 : t[2]
      );
    }
    colon(r) {
      let c = 0, e, t, o;
      for (let [y, g] of r.entries()) {
        if (t = g, o = t[0], o === "(" && (c += 1), o === ")" && (c -= 1), c === 0 && o === ":")
          if (!e)
            this.doubleColon(t);
          else {
            if (e[0] === "word" && e[1] === "progid")
              continue;
            return y;
          }
        e = t;
      }
      return !1;
    }
    comment(r) {
      let c = new x();
      this.init(c, r[2]), c.source.end = this.getPosition(r[3] || r[2]), c.source.end.offset++;
      let e = r[1].slice(2, -2);
      if (/^\s*$/.test(e))
        c.text = "", c.raws.left = e, c.raws.right = "";
      else {
        let t = e.match(/^(\s*)([^]*\S)(\s*)$/);
        c.text = t[2], c.raws.left = t[1], c.raws.right = t[3];
      }
    }
    createTokenizer() {
      this.tokenizer = p(this.input);
    }
    decl(r, c) {
      let e = new m();
      this.init(e, r[0][2]);
      let t = r[r.length - 1];
      for (t[0] === ";" && (this.semicolon = !0, r.pop()), e.source.end = this.getPosition(
        t[3] || t[2] || d(r)
      ), e.source.end.offset++; r[0][0] !== "word"; )
        r.length === 1 && this.unknownWord(r), e.raws.before += r.shift()[1];
      for (e.source.start = this.getPosition(r[0][2]), e.prop = ""; r.length; ) {
        let h = r[0][0];
        if (h === ":" || h === "space" || h === "comment")
          break;
        e.prop += r.shift()[1];
      }
      e.raws.between = "";
      let o;
      for (; r.length; )
        if (o = r.shift(), o[0] === ":") {
          e.raws.between += o[1];
          break;
        } else
          o[0] === "word" && /\w/.test(o[1]) && this.unknownWord([o]), e.raws.between += o[1];
      (e.prop[0] === "_" || e.prop[0] === "*") && (e.raws.before += e.prop[0], e.prop = e.prop.slice(1));
      let y = [], g;
      for (; r.length && (g = r[0][0], !(g !== "space" && g !== "comment")); )
        y.push(r.shift());
      this.precheckMissedSemicolon(r);
      for (let h = r.length - 1; h >= 0; h--) {
        if (o = r[h], o[1].toLowerCase() === "!important") {
          e.important = !0;
          let v = this.stringFrom(r, h);
          v = this.spacesFromEnd(r) + v, v !== " !important" && (e.raws.important = v);
          break;
        } else if (o[1].toLowerCase() === "important") {
          let v = r.slice(0), S = "";
          for (let s = h; s > 0; s--) {
            let w = v[s][0];
            if (S.trim().startsWith("!") && w !== "space")
              break;
            S = v.pop()[1] + S;
          }
          S.trim().startsWith("!") && (e.important = !0, e.raws.important = S, r = v);
        }
        if (o[0] !== "space" && o[0] !== "comment")
          break;
      }
      r.some((h) => h[0] !== "space" && h[0] !== "comment") && (e.raws.between += y.map((h) => h[1]).join(""), y = []), this.raw(e, "value", y.concat(r), c), e.value.includes(":") && !c && this.checkMissedSemicolon(r);
    }
    doubleColon(r) {
      throw this.input.error(
        "Double colon",
        { offset: r[2] },
        { offset: r[2] + r[1].length }
      );
    }
    emptyRule(r) {
      let c = new l();
      this.init(c, r[2]), c.selector = "", c.raws.between = "", this.current = c;
    }
    end(r) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(r[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(r);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(r) {
      if (this.spaces += r[1], this.current.nodes) {
        let c = this.current.nodes[this.current.nodes.length - 1];
        c && c.type === "rule" && !c.raws.ownSemicolon && (c.raws.ownSemicolon = this.spaces, this.spaces = "", c.source.end = this.getPosition(r[2]), c.source.end.offset += c.raws.ownSemicolon.length);
      }
    }
    // Helpers
    getPosition(r) {
      let c = this.input.fromOffset(r);
      return {
        column: c.col,
        line: c.line,
        offset: r
      };
    }
    init(r, c) {
      this.current.push(r), r.source = {
        input: this.input,
        start: this.getPosition(c)
      }, r.raws.before = this.spaces, this.spaces = "", r.type !== "comment" && (this.semicolon = !1);
    }
    other(r) {
      let c = !1, e = null, t = !1, o = null, y = [], g = r[1].startsWith("--"), n = [], h = r;
      for (; h; ) {
        if (e = h[0], n.push(h), e === "(" || e === "[")
          o || (o = h), y.push(e === "(" ? ")" : "]");
        else if (g && t && e === "{")
          o || (o = h), y.push("}");
        else if (y.length === 0)
          if (e === ";")
            if (t) {
              this.decl(n, g);
              return;
            } else
              break;
          else if (e === "{") {
            this.rule(n);
            return;
          } else if (e === "}") {
            this.tokenizer.back(n.pop()), c = !0;
            break;
          } else e === ":" && (t = !0);
        else e === y[y.length - 1] && (y.pop(), y.length === 0 && (o = null));
        h = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (c = !0), y.length > 0 && this.unclosedBracket(o), c && t) {
        if (!g)
          for (; n.length && (h = n[n.length - 1][0], !(h !== "space" && h !== "comment")); )
            this.tokenizer.back(n.pop());
        this.decl(n, g);
      } else
        this.unknownWord(n);
    }
    parse() {
      let r;
      for (; !this.tokenizer.endOfFile(); )
        switch (r = this.tokenizer.nextToken(), r[0]) {
          case "space":
            this.spaces += r[1];
            break;
          case ";":
            this.freeSemicolon(r);
            break;
          case "}":
            this.end(r);
            break;
          case "comment":
            this.comment(r);
            break;
          case "at-word":
            this.atrule(r);
            break;
          case "{":
            this.emptyRule(r);
            break;
          default:
            this.other(r);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(r, c, e, t) {
      let o, y, g = e.length, n = "", h = !0, v, S;
      for (let s = 0; s < g; s += 1)
        o = e[s], y = o[0], y === "space" && s === g - 1 && !t ? h = !1 : y === "comment" ? (S = e[s - 1] ? e[s - 1][0] : "empty", v = e[s + 1] ? e[s + 1][0] : "empty", !a[S] && !a[v] ? n.slice(-1) === "," ? h = !1 : n += o[1] : h = !1) : n += o[1];
      if (!h) {
        let s = e.reduce((w, E) => w + E[1], "");
        r.raws[c] = { raw: s, value: n };
      }
      r[c] = n;
    }
    rule(r) {
      r.pop();
      let c = new l();
      this.init(c, r[0][2]), c.raws.between = this.spacesAndCommentsFromEnd(r), this.raw(c, "selector", r), this.current = c;
    }
    spacesAndCommentsFromEnd(r) {
      let c, e = "";
      for (; r.length && (c = r[r.length - 1][0], !(c !== "space" && c !== "comment")); )
        e = r.pop()[1] + e;
      return e;
    }
    // Errors
    spacesAndCommentsFromStart(r) {
      let c, e = "";
      for (; r.length && (c = r[0][0], !(c !== "space" && c !== "comment")); )
        e += r.shift()[1];
      return e;
    }
    spacesFromEnd(r) {
      let c, e = "";
      for (; r.length && (c = r[r.length - 1][0], c === "space"); )
        e = r.pop()[1] + e;
      return e;
    }
    stringFrom(r, c) {
      let e = "";
      for (let t = c; t < r.length; t++)
        e += r[t][1];
      return r.splice(c, r.length - c), e;
    }
    unclosedBlock() {
      let r = this.current.source.start;
      throw this.input.error("Unclosed block", r.line, r.column);
    }
    unclosedBracket(r) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: r[2] },
        { offset: r[2] + 1 }
      );
    }
    unexpectedClose(r) {
      throw this.input.error(
        "Unexpected }",
        { offset: r[2] },
        { offset: r[2] + 1 }
      );
    }
    unknownWord(r) {
      throw this.input.error(
        "Unknown word " + r[0][1],
        { offset: r[0][2] },
        { offset: r[0][2] + r[0][1].length }
      );
    }
    unnamedAtrule(r, c) {
      throw this.input.error(
        "At-rule without name",
        { offset: c[2] },
        { offset: c[2] + c[1].length }
      );
    }
  }
  return St = b, St;
}
var Et, Wu;
function Ht() {
  if (Wu) return Et;
  Wu = 1;
  let u = ve(), x = We(), m = Gr();
  function f(l, p) {
    let a = new x(l, p), d = new m(a);
    try {
      d.parse();
    } catch (b) {
      throw process.env.NODE_ENV !== "production" && b.name === "CssSyntaxError" && p && p.from && (/\.scss$/i.test(p.from) ? b.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(p.from) ? b.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(p.from) && (b.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), b;
    }
    return d.root;
  }
  return Et = f, f.default = f, u.registerParse(f), Et;
}
var Tt, Zu;
function lr() {
  if (Zu) return Tt;
  Zu = 1;
  class u {
    constructor(m, f = {}) {
      if (this.type = "warning", this.text = m, f.node && f.node.source) {
        let l = f.node.rangeBy(f);
        this.line = l.start.line, this.column = l.start.column, this.endLine = l.end.line, this.endColumn = l.end.column;
      }
      for (let l in f) this[l] = f[l];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return Tt = u, u.default = u, Tt;
}
var At, Xu;
function Vt() {
  if (Xu) return At;
  Xu = 1;
  let u = lr();
  class x {
    get content() {
      return this.css;
    }
    constructor(f, l, p) {
      this.processor = f, this.messages = [], this.root = l, this.opts = p, this.css = "", this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(f, l = {}) {
      l.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (l.plugin = this.lastPlugin.postcssPlugin);
      let p = new u(f, l);
      return this.messages.push(p), p;
    }
    warnings() {
      return this.messages.filter((f) => f.type === "warning");
    }
  }
  return At = x, x.default = x, At;
}
var qt, Ju;
function fr() {
  if (Ju) return qt;
  Ju = 1;
  let u = {};
  return qt = function(m) {
    u[m] || (u[m] = !0, typeof console < "u" && console.warn && console.warn(m));
  }, qt;
}
var Nt, Qu;
function dr() {
  if (Qu) return Nt;
  Qu = 1;
  let u = ve(), x = Ut(), m = cr(), f = Ht(), l = Vt(), p = Ne(), a = Ve(), { isClean: d, my: b } = Mt(), i = fr();
  const r = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, c = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, e = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, t = 0;
  function o(S) {
    return typeof S == "object" && typeof S.then == "function";
  }
  function y(S) {
    let s = !1, w = r[S.type];
    return S.type === "decl" ? s = S.prop.toLowerCase() : S.type === "atrule" && (s = S.name.toLowerCase()), s && S.append ? [
      w,
      w + "-" + s,
      t,
      w + "Exit",
      w + "Exit-" + s
    ] : s ? [w, w + "-" + s, w + "Exit", w + "Exit-" + s] : S.append ? [w, t, w + "Exit"] : [w, w + "Exit"];
  }
  function g(S) {
    let s;
    return S.type === "document" ? s = ["Document", t, "DocumentExit"] : S.type === "root" ? s = ["Root", t, "RootExit"] : s = y(S), {
      eventIndex: 0,
      events: s,
      iterator: 0,
      node: S,
      visitorIndex: 0,
      visitors: []
    };
  }
  function n(S) {
    return S[d] = !1, S.nodes && S.nodes.forEach((s) => n(s)), S;
  }
  let h = {};
  class v {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(s, w, E) {
      this.stringified = !1, this.processed = !1;
      let A;
      if (typeof w == "object" && w !== null && (w.type === "root" || w.type === "document"))
        A = n(w);
      else if (w instanceof v || w instanceof l)
        A = n(w.root), w.map && (typeof E.map > "u" && (E.map = {}), E.map.inline || (E.map.inline = !1), E.map.prev = w.map);
      else {
        let L = f;
        E.syntax && (L = E.syntax.parse), E.parser && (L = E.parser), L.parse && (L = L.parse);
        try {
          A = L(w, E);
        } catch (D) {
          this.processed = !0, this.error = D;
        }
        A && !A[b] && u.rebuild(A);
      }
      this.result = new l(s, A, E), this.helpers = { ...h, postcss: h, result: this.result }, this.plugins = this.processor.plugins.map((L) => typeof L == "object" && L.prepare ? { ...L, ...L.prepare(this.result) } : L);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(s) {
      return this.async().catch(s);
    }
    finally(s) {
      return this.async().then(s, s);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(s, w) {
      let E = this.result.lastPlugin;
      try {
        if (w && w.addToError(s), this.error = s, s.name === "CssSyntaxError" && !s.plugin)
          s.plugin = E.postcssPlugin, s.setMessage();
        else if (E.postcssVersion && process.env.NODE_ENV !== "production") {
          let A = E.postcssPlugin, L = E.postcssVersion, D = this.result.processor.version, T = L.split("."), q = D.split(".");
          (T[0] !== q[0] || parseInt(T[1]) > parseInt(q[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + D + ", but " + A + " uses " + L + ". Perhaps this is the source of the error below."
          );
        }
      } catch (A) {
        console && console.error && console.error(A);
      }
      return s;
    }
    prepareVisitors() {
      this.listeners = {};
      let s = (w, E, A) => {
        this.listeners[E] || (this.listeners[E] = []), this.listeners[E].push([w, A]);
      };
      for (let w of this.plugins)
        if (typeof w == "object")
          for (let E in w) {
            if (!c[E] && /^[A-Z]/.test(E))
              throw new Error(
                `Unknown event ${E} in ${w.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!e[E])
              if (typeof w[E] == "object")
                for (let A in w[E])
                  A === "*" ? s(w, E, w[E][A]) : s(
                    w,
                    E + "-" + A.toLowerCase(),
                    w[E][A]
                  );
              else typeof w[E] == "function" && s(w, E, w[E]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let s = 0; s < this.plugins.length; s++) {
        let w = this.plugins[s], E = this.runOnRoot(w);
        if (o(E))
          try {
            await E;
          } catch (A) {
            throw this.handleError(A);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let s = this.result.root;
        for (; !s[d]; ) {
          s[d] = !0;
          let w = [g(s)];
          for (; w.length > 0; ) {
            let E = this.visitTick(w);
            if (o(E))
              try {
                await E;
              } catch (A) {
                let L = w[w.length - 1].node;
                throw this.handleError(A, L);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [w, E] of this.listeners.OnceExit) {
            this.result.lastPlugin = w;
            try {
              if (s.type === "document") {
                let A = s.nodes.map(
                  (L) => E(L, this.helpers)
                );
                await Promise.all(A);
              } else
                await E(s, this.helpers);
            } catch (A) {
              throw this.handleError(A);
            }
          }
      }
      return this.processed = !0, this.stringify();
    }
    runOnRoot(s) {
      this.result.lastPlugin = s;
      try {
        if (typeof s == "object" && s.Once) {
          if (this.result.root.type === "document") {
            let w = this.result.root.nodes.map(
              (E) => s.Once(E, this.helpers)
            );
            return o(w[0]) ? Promise.all(w) : w;
          }
          return s.Once(this.result.root, this.helpers);
        } else if (typeof s == "function")
          return s(this.result.root, this.result);
      } catch (w) {
        throw this.handleError(w);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let s = this.result.opts, w = a;
      s.syntax && (w = s.syntax.stringify), s.stringifier && (w = s.stringifier), w.stringify && (w = w.stringify);
      let A = new m(w, this.result.root, this.result.opts).generate();
      return this.result.css = A[0], this.result.map = A[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let s of this.plugins) {
        let w = this.runOnRoot(s);
        if (o(w))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let s = this.result.root;
        for (; !s[d]; )
          s[d] = !0, this.walkSync(s);
        if (this.listeners.OnceExit)
          if (s.type === "document")
            for (let w of s.nodes)
              this.visitSync(this.listeners.OnceExit, w);
          else
            this.visitSync(this.listeners.OnceExit, s);
      }
      return this.result;
    }
    then(s, w) {
      return process.env.NODE_ENV !== "production" && ("from" in this.opts || i(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(s, w);
    }
    toString() {
      return this.css;
    }
    visitSync(s, w) {
      for (let [E, A] of s) {
        this.result.lastPlugin = E;
        let L;
        try {
          L = A(w, this.helpers);
        } catch (D) {
          throw this.handleError(D, w.proxyOf);
        }
        if (w.type !== "root" && w.type !== "document" && !w.parent)
          return !0;
        if (o(L))
          throw this.getAsyncError();
      }
    }
    visitTick(s) {
      let w = s[s.length - 1], { node: E, visitors: A } = w;
      if (E.type !== "root" && E.type !== "document" && !E.parent) {
        s.pop();
        return;
      }
      if (A.length > 0 && w.visitorIndex < A.length) {
        let [D, T] = A[w.visitorIndex];
        w.visitorIndex += 1, w.visitorIndex === A.length && (w.visitors = [], w.visitorIndex = 0), this.result.lastPlugin = D;
        try {
          return T(E.toProxy(), this.helpers);
        } catch (q) {
          throw this.handleError(q, E);
        }
      }
      if (w.iterator !== 0) {
        let D = w.iterator, T;
        for (; T = E.nodes[E.indexes[D]]; )
          if (E.indexes[D] += 1, !T[d]) {
            T[d] = !0, s.push(g(T));
            return;
          }
        w.iterator = 0, delete E.indexes[D];
      }
      let L = w.events;
      for (; w.eventIndex < L.length; ) {
        let D = L[w.eventIndex];
        if (w.eventIndex += 1, D === t) {
          E.nodes && E.nodes.length && (E[d] = !0, w.iterator = E.getIterator());
          return;
        } else if (this.listeners[D]) {
          w.visitors = this.listeners[D];
          return;
        }
      }
      s.pop();
    }
    walkSync(s) {
      s[d] = !0;
      let w = y(s);
      for (let E of w)
        if (E === t)
          s.nodes && s.each((A) => {
            A[d] || this.walkSync(A);
          });
        else {
          let A = this.listeners[E];
          if (A && this.visitSync(A, s.toProxy()))
            return;
        }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return v.registerPostcss = (S) => {
    h = S;
  }, Nt = v, v.default = v, p.registerLazyResult(v), x.registerLazyResult(v), Nt;
}
var Ot, Yu;
function Wr() {
  if (Yu) return Ot;
  Yu = 1;
  let u = cr(), x = Ht();
  const m = Vt();
  let f = Ve(), l = fr();
  class p {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let d, b = x;
      try {
        d = b(this._css, this._opts);
      } catch (i) {
        this.error = i;
      }
      if (this.error)
        throw this.error;
      return this._root = d, d;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(d, b, i) {
      b = b.toString(), this.stringified = !1, this._processor = d, this._css = b, this._opts = i, this._map = void 0;
      let r, c = f;
      this.result = new m(this._processor, r, this._opts), this.result.css = b;
      let e = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return e.root;
        }
      });
      let t = new u(c, r, this._opts, b);
      if (t.isMap()) {
        let [o, y] = t.generate();
        o && (this.result.css = o), y && (this.result.map = y);
      } else
        t.clearAnnotation(), this.result.css = t.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(d) {
      return this.async().catch(d);
    }
    finally(d) {
      return this.async().then(d, d);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(d, b) {
      return process.env.NODE_ENV !== "production" && ("from" in this._opts || l(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(d, b);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return Ot = p, p.default = p, Ot;
}
var Lt, Ku;
function Zr() {
  if (Ku) return Lt;
  Ku = 1;
  let u = Ut(), x = dr(), m = Wr(), f = Ne();
  class l {
    constructor(a = []) {
      this.version = "8.5.6", this.plugins = this.normalize(a);
    }
    normalize(a) {
      let d = [];
      for (let b of a)
        if (b.postcss === !0 ? b = b() : b.postcss && (b = b.postcss), typeof b == "object" && Array.isArray(b.plugins))
          d = d.concat(b.plugins);
        else if (typeof b == "object" && b.postcssPlugin)
          d.push(b);
        else if (typeof b == "function")
          d.push(b);
        else if (typeof b == "object" && (b.parse || b.stringify)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(b + " is not a PostCSS plugin");
      return d;
    }
    process(a, d = {}) {
      return !this.plugins.length && !d.parser && !d.stringifier && !d.syntax ? new m(this, a, d) : new x(this, a, d);
    }
    use(a) {
      return this.plugins = this.plugins.concat(this.normalize([a])), this;
    }
  }
  return Lt = l, l.default = l, f.registerProcessor(l), u.registerProcessor(l), Lt;
}
var Dt, $u;
function Xr() {
  if ($u) return Dt;
  $u = 1;
  let u = Bt(), x = ze(), m = ve(), f = kt(), l = Ge(), p = Ut(), a = Fr(), d = We(), b = dr(), i = or(), r = Fe(), c = Ht(), e = Zr(), t = Vt(), o = Ne(), y = jt(), g = Ve(), n = lr();
  function h(...v) {
    return v.length === 1 && Array.isArray(v[0]) && (v = v[0]), new e(v);
  }
  return h.plugin = function(S, s) {
    let w = !1;
    function E(...L) {
      console && console.warn && !w && (w = !0, console.warn(
        S + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
        S + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let D = s(...L);
      return D.postcssPlugin = S, D.postcssVersion = new e().version, D;
    }
    let A;
    return Object.defineProperty(E, "postcss", {
      get() {
        return A || (A = E()), A;
      }
    }), E.process = function(L, D, T) {
      return h([E(T)]).process(L, D);
    }, E;
  }, h.stringify = g, h.parse = c, h.fromJSON = a, h.list = i, h.comment = (v) => new x(v), h.atRule = (v) => new u(v), h.decl = (v) => new l(v), h.rule = (v) => new y(v), h.root = (v) => new o(v), h.document = (v) => new p(v), h.CssSyntaxError = f, h.Declaration = l, h.Container = m, h.Processor = e, h.Document = p, h.Comment = x, h.Warning = n, h.AtRule = u, h.Result = t, h.Input = d, h.Rule = y, h.Root = o, h.Node = r, b.registerPostcss(h), Dt = h, h.default = h, Dt;
}
var Ct, er;
function Jr() {
  if (er) return Ct;
  er = 1;
  const u = /* @__PURE__ */ _r(), x = Rr(), { isPlainObject: m } = Pr(), f = kr(), l = Br(), { parse: p } = Xr(), a = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ], d = ["script", "style"];
  function b(g, n) {
    g && Object.keys(g).forEach(function(h) {
      n(g[h], h);
    });
  }
  function i(g, n) {
    return {}.hasOwnProperty.call(g, n);
  }
  function r(g, n) {
    const h = [];
    return b(g, function(v) {
      n(v) && h.push(v);
    }), h;
  }
  function c(g) {
    for (const n in g)
      if (i(g, n))
        return !1;
    return !0;
  }
  function e(g) {
    return g.map(function(n) {
      if (!n.url)
        throw new Error("URL missing");
      return n.url + (n.w ? ` ${n.w}w` : "") + (n.h ? ` ${n.h}h` : "") + (n.d ? ` ${n.d}x` : "");
    }).join(", ");
  }
  Ct = o;
  const t = /^[^\0\t\n\f\r /<=>]+$/;
  function o(g, n, h) {
    if (g == null)
      return "";
    typeof g == "number" && (g = g.toString());
    let v = "", S = "";
    function s(O, _) {
      const C = this;
      this.tag = O, this.attribs = _ || {}, this.tagPosition = v.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
        if (U.length) {
          const M = U[U.length - 1];
          M.text += C.text;
        }
      }, this.updateParentNodeMediaChildren = function() {
        U.length && a.includes(this.tag) && U[U.length - 1].mediaChildren.push(this.tag);
      };
    }
    n = Object.assign({}, o.defaults, n), n.parser = Object.assign({}, y, n.parser);
    const w = function(O) {
      return n.allowedTags === !1 || (n.allowedTags || []).indexOf(O) > -1;
    };
    d.forEach(function(O) {
      w(O) && !n.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${O}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
    });
    const E = n.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option"
    ];
    let A, L;
    n.allowedAttributes && (A = {}, L = {}, b(n.allowedAttributes, function(O, _) {
      A[_] = [];
      const C = [];
      O.forEach(function(M) {
        typeof M == "string" && M.indexOf("*") >= 0 ? C.push(x(M).replace(/\\\*/g, ".*")) : A[_].push(M);
      }), C.length && (L[_] = new RegExp("^(" + C.join("|") + ")$"));
    }));
    const D = {}, T = {}, q = {};
    b(n.allowedClasses, function(O, _) {
      if (A && (i(A, _) || (A[_] = []), A[_].push("class")), D[_] = O, Array.isArray(O)) {
        const C = [];
        D[_] = [], q[_] = [], O.forEach(function(M) {
          typeof M == "string" && M.indexOf("*") >= 0 ? C.push(x(M).replace(/\\\*/g, ".*")) : M instanceof RegExp ? q[_].push(M) : D[_].push(M);
        }), C.length && (T[_] = new RegExp("^(" + C.join("|") + ")$"));
      }
    });
    const I = {};
    let R;
    b(n.transformTags, function(O, _) {
      let C;
      typeof O == "function" ? C = O : typeof O == "string" && (C = o.simpleTransform(O)), _ === "*" ? R = C : I[_] = C;
    });
    let N, U, j, z, W, Z, ne = !1;
    k();
    const Te = new u.Parser({
      onopentag: function(O, _) {
        if (n.onOpenTag && n.onOpenTag(O, _), n.enforceHtmlBoundary && O === "html" && k(), W) {
          Z++;
          return;
        }
        const C = new s(O, _);
        U.push(C);
        let M = !1;
        const X = !!C.text;
        let Q;
        if (i(I, O) && (Q = I[O](O, _), C.attribs = _ = Q.attribs, Q.text !== void 0 && (C.innerText = Q.text), O !== Q.tagName && (C.name = O = Q.tagName, z[N] = Q.tagName)), R && (Q = R(O, _), C.attribs = _ = Q.attribs, O !== Q.tagName && (C.name = O = Q.tagName, z[N] = Q.tagName)), (!w(O) || n.disallowedTagsMode === "recursiveEscape" && !c(j) || n.nestingLimit != null && N >= n.nestingLimit) && (M = !0, j[N] = !0, (n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") && E.indexOf(O) !== -1 && (W = !0, Z = 1)), N++, M) {
          if (n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") {
            if (C.innerText && !X) {
              const G = K(C.innerText);
              n.textFilter ? v += n.textFilter(G, O) : v += G, ne = !0;
            }
            return;
          }
          S = v, v = "";
        }
        v += "<" + O, O === "script" && (n.allowedScriptHostnames || n.allowedScriptDomains) && (C.innerText = ""), M && (n.disallowedTagsMode === "escape" || n.disallowedTagsMode === "recursiveEscape") && n.preserveEscapedAttributes ? b(_, function(G, H) {
          v += " " + H + '="' + K(G || "", !0) + '"';
        }) : (!A || i(A, O) || A["*"]) && b(_, function(G, H) {
          if (!t.test(H)) {
            delete C.attribs[H];
            return;
          }
          if (G === "" && !n.allowedEmptyAttributes.includes(H) && (n.nonBooleanAttributes.includes(H) || n.nonBooleanAttributes.includes("*"))) {
            delete C.attribs[H];
            return;
          }
          let Je = !1;
          if (!A || i(A, O) && A[O].indexOf(H) !== -1 || A["*"] && A["*"].indexOf(H) !== -1 || i(L, O) && L[O].test(H) || L["*"] && L["*"].test(H))
            Je = !0;
          else if (A && A[O]) {
            for (const V of A[O])
              if (m(V) && V.name && V.name === H) {
                Je = !0;
                let F = "";
                if (V.multiple === !0) {
                  const be = G.split(" ");
                  for (const se of be)
                    V.values.indexOf(se) !== -1 && (F === "" ? F = se : F += " " + se);
                } else V.values.indexOf(G) >= 0 && (F = G);
                G = F;
              }
          }
          if (Je) {
            if (n.allowedSchemesAppliedToAttributes.indexOf(H) !== -1 && pe(O, G)) {
              delete C.attribs[H];
              return;
            }
            if (O === "script" && H === "src") {
              let V = !0;
              try {
                const F = Le(G);
                if (n.allowedScriptHostnames || n.allowedScriptDomains) {
                  const be = (n.allowedScriptHostnames || []).find(function($) {
                    return $ === F.url.hostname;
                  }), se = (n.allowedScriptDomains || []).find(function($) {
                    return F.url.hostname === $ || F.url.hostname.endsWith(`.${$}`);
                  });
                  V = be || se;
                }
              } catch {
                V = !1;
              }
              if (!V) {
                delete C.attribs[H];
                return;
              }
            }
            if (O === "iframe" && H === "src") {
              let V = !0;
              try {
                const F = Le(G);
                if (F.isRelativeUrl)
                  V = i(n, "allowIframeRelativeUrls") ? n.allowIframeRelativeUrls : !n.allowedIframeHostnames && !n.allowedIframeDomains;
                else if (n.allowedIframeHostnames || n.allowedIframeDomains) {
                  const be = (n.allowedIframeHostnames || []).find(function($) {
                    return $ === F.url.hostname;
                  }), se = (n.allowedIframeDomains || []).find(function($) {
                    return F.url.hostname === $ || F.url.hostname.endsWith(`.${$}`);
                  });
                  V = be || se;
                }
              } catch {
                V = !1;
              }
              if (!V) {
                delete C.attribs[H];
                return;
              }
            }
            if (H === "srcset")
              try {
                let V = l(G);
                if (V.forEach(function(F) {
                  pe("srcset", F.url) && (F.evil = !0);
                }), V = r(V, function(F) {
                  return !F.evil;
                }), V.length)
                  G = e(r(V, function(F) {
                    return !F.evil;
                  })), C.attribs[H] = G;
                else {
                  delete C.attribs[H];
                  return;
                }
              } catch {
                delete C.attribs[H];
                return;
              }
            if (H === "class") {
              const V = D[O], F = D["*"], be = T[O], se = q[O], $ = q["*"], yr = T["*"], Gt = [
                be,
                yr
              ].concat(se, $).filter(function(vr) {
                return vr;
              });
              if (V && F ? G = De(G, f(V, F), Gt) : G = De(G, V || F, Gt), !G.length) {
                delete C.attribs[H];
                return;
              }
            }
            if (H === "style") {
              if (n.parseStyleAttributes)
                try {
                  const V = p(O + " {" + G + "}", { map: !1 }), F = Ae(V, n.allowedStyles);
                  if (G = Ze(F), G.length === 0) {
                    delete C.attribs[H];
                    return;
                  }
                } catch {
                  typeof window < "u" && console.warn('Failed to parse "' + O + " {" + G + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete C.attribs[H];
                  return;
                }
              else if (n.allowedStyles)
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
            }
            v += " " + H, G && G.length ? v += '="' + K(G, !0) + '"' : n.allowedEmptyAttributes.includes(H) && (v += '=""');
          } else
            delete C.attribs[H];
        }), n.selfClosing.indexOf(O) !== -1 ? v += " />" : (v += ">", C.innerText && !X && !n.textFilter && (v += K(C.innerText), ne = !0)), M && (v = S + K(v), S = ""), C.openingTagLength = v.length - C.tagPosition;
      },
      ontext: function(O) {
        if (W)
          return;
        const _ = U[U.length - 1];
        let C;
        if (_ && (C = _.tag, O = _.innerText !== void 0 ? _.innerText : O), n.disallowedTagsMode === "completelyDiscard" && !w(C))
          O = "";
        else if ((n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") && (C === "script" || C === "style"))
          v += O;
        else if (!ne) {
          const M = K(O, !1);
          n.textFilter ? v += n.textFilter(M, C) : v += M;
        }
        if (U.length) {
          const M = U[U.length - 1];
          M.text += O;
        }
      },
      onclosetag: function(O, _) {
        if (n.onCloseTag && n.onCloseTag(O, _), W)
          if (Z--, !Z)
            W = !1;
          else
            return;
        const C = U.pop();
        if (!C)
          return;
        if (C.tag !== O) {
          U.push(C);
          return;
        }
        W = n.enforceHtmlBoundary ? O === "html" : !1, N--;
        const M = j[N];
        if (M) {
          if (delete j[N], n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") {
            C.updateParentNodeText();
            return;
          }
          S = v, v = "";
        }
        if (z[N] && (O = z[N], delete z[N]), n.exclusiveFilter) {
          const X = n.exclusiveFilter(C);
          if (X === "excludeTag") {
            M && (v = S, S = ""), v = v.substring(0, C.tagPosition) + v.substring(C.tagPosition + C.openingTagLength);
            return;
          } else if (X) {
            v = v.substring(0, C.tagPosition);
            return;
          }
        }
        if (C.updateParentNodeMediaChildren(), C.updateParentNodeText(), // Already output />
        n.selfClosing.indexOf(O) !== -1 || // Escaped tag, closing tag is implied
        _ && !w(O) && ["escape", "recursiveEscape"].indexOf(n.disallowedTagsMode) >= 0) {
          M && (v = S, S = "");
          return;
        }
        v += "</" + O + ">", M && (v = S + K(v), S = ""), ne = !1;
      }
    }, n.parser);
    return Te.write(g), Te.end(), v;
    function k() {
      v = "", N = 0, U = [], j = {}, z = {}, W = !1, Z = 0;
    }
    function K(O, _) {
      return typeof O != "string" && (O = O + ""), n.parser.decodeEntities && (O = O.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), _ && (O = O.replace(/"/g, "&quot;"))), O = O.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), _ && (O = O.replace(/"/g, "&quot;")), O;
    }
    function pe(O, _) {
      for (_ = _.replace(/[\x00-\x20]+/g, ""); ; ) {
        const X = _.indexOf("<!--");
        if (X === -1)
          break;
        const Q = _.indexOf("-->", X + 4);
        if (Q === -1)
          break;
        _ = _.substring(0, X) + _.substring(Q + 3);
      }
      const C = _.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
      if (!C)
        return _.match(/^[/\\]{2}/) ? !n.allowProtocolRelative : !1;
      const M = C[1].toLowerCase();
      return i(n.allowedSchemesByTag, O) ? n.allowedSchemesByTag[O].indexOf(M) === -1 : !n.allowedSchemes || n.allowedSchemes.indexOf(M) === -1;
    }
    function Le(O) {
      if (O = O.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), O.startsWith("relative:"))
        throw new Error("relative: exploit attempt");
      let _ = "relative://relative-site";
      for (let X = 0; X < 100; X++)
        _ += `/${X}`;
      const C = new URL(O, _);
      return {
        isRelativeUrl: C && C.hostname === "relative-site" && C.protocol === "relative:",
        url: C
      };
    }
    function Ae(O, _) {
      if (!_)
        return O;
      const C = O.nodes[0];
      let M;
      return _[C.selector] && _["*"] ? M = f(
        _[C.selector],
        _["*"]
      ) : M = _[C.selector] || _["*"], M && (O.nodes[0].nodes = C.nodes.reduce(Xe(M), [])), O;
    }
    function Ze(O) {
      return O.nodes[0].nodes.reduce(function(_, C) {
        return _.push(
          `${C.prop}:${C.value}${C.important ? " !important" : ""}`
        ), _;
      }, []).join(";");
    }
    function Xe(O) {
      return function(_, C) {
        return i(O, C.prop) && O[C.prop].some(function(X) {
          return X.test(C.value);
        }) && _.push(C), _;
      };
    }
    function De(O, _, C) {
      return _ ? (O = O.split(/\s+/), O.filter(function(M) {
        return _.indexOf(M) !== -1 || C.some(function(X) {
          return X.test(M);
        });
      }).join(" ")) : O;
    }
  }
  const y = {
    decodeEntities: !0
  };
  return o.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
    allowProtocolRelative: !0,
    enforceHtmlBoundary: !1,
    parseStyleAttributes: !0,
    preserveEscapedAttributes: !1
  }, o.simpleTransform = function(g, n, h) {
    return h = h === void 0 ? !0 : h, n = n || {}, function(v, S) {
      let s;
      if (h)
        for (s in n)
          S[s] = n[s];
      else
        S = n;
      return {
        tagName: g,
        attribs: S
      };
    };
  }, Ct;
}
var Qr = /* @__PURE__ */ Jr();
const Yr = /* @__PURE__ */ wr(Qr), je = ({ value: u, as: x = "span", ...m }) => {
  const f = x, l = xr(() => u ? Yr(u) : "", [u]);
  return /* @__PURE__ */ P(f, { dangerouslySetInnerHTML: { __html: l }, ...m });
};
var we = function() {
  return we = Object.assign || function(u) {
    for (var x, m = 1, f = arguments.length; m < f; m++) {
      x = arguments[m];
      for (var l in x) Object.prototype.hasOwnProperty.call(x, l) && (u[l] = x[l]);
    }
    return u;
  }, we.apply(this, arguments);
}, Kr = "~", $r = "~~";
function Ft(u, x) {
  for (var m = {}, f = {}, l = u.split($r), p = !1, a = 0; l.length > a; a++) {
    for (var d = l[a].split(Kr), b = 0; b < d.length; b += 2) {
      var i = d[b], r = d[b + 1], c = "&" + i + ";";
      m[c] = r, p && (m["&" + i] = r), f[r] = c;
    }
    p = !0;
  }
  return x ? { entities: we(we({}, m), x.entities), characters: we(we({}, f), x.characters) } : { entities: m, characters: f };
}
var It = {
  xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
  html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g
}, Se = {};
Se.xml = Ft(`lt~<~gt~>~quot~"~apos~'~amp~&`);
Se.html4 = Ft(`apos~'~OElig~Œ~oelig~œ~Scaron~Š~scaron~š~Yuml~Ÿ~circ~ˆ~tilde~˜~ensp~ ~emsp~ ~thinsp~ ~zwnj~‌~zwj~‍~lrm~‎~rlm~‏~ndash~–~mdash~—~lsquo~‘~rsquo~’~sbquo~‚~ldquo~“~rdquo~”~bdquo~„~dagger~†~Dagger~‡~permil~‰~lsaquo~‹~rsaquo~›~euro~€~fnof~ƒ~Alpha~Α~Beta~Β~Gamma~Γ~Delta~Δ~Epsilon~Ε~Zeta~Ζ~Eta~Η~Theta~Θ~Iota~Ι~Kappa~Κ~Lambda~Λ~Mu~Μ~Nu~Ν~Xi~Ξ~Omicron~Ο~Pi~Π~Rho~Ρ~Sigma~Σ~Tau~Τ~Upsilon~Υ~Phi~Φ~Chi~Χ~Psi~Ψ~Omega~Ω~alpha~α~beta~β~gamma~γ~delta~δ~epsilon~ε~zeta~ζ~eta~η~theta~θ~iota~ι~kappa~κ~lambda~λ~mu~μ~nu~ν~xi~ξ~omicron~ο~pi~π~rho~ρ~sigmaf~ς~sigma~σ~tau~τ~upsilon~υ~phi~φ~chi~χ~psi~ψ~omega~ω~thetasym~ϑ~upsih~ϒ~piv~ϖ~bull~•~hellip~…~prime~′~Prime~″~oline~‾~frasl~⁄~weierp~℘~image~ℑ~real~ℜ~trade~™~alefsym~ℵ~larr~←~uarr~↑~rarr~→~darr~↓~harr~↔~crarr~↵~lArr~⇐~uArr~⇑~rArr~⇒~dArr~⇓~hArr~⇔~forall~∀~part~∂~exist~∃~empty~∅~nabla~∇~isin~∈~notin~∉~ni~∋~prod~∏~sum~∑~minus~−~lowast~∗~radic~√~prop~∝~infin~∞~ang~∠~and~∧~or~∨~cap~∩~cup~∪~int~∫~there4~∴~sim~∼~cong~≅~asymp~≈~ne~≠~equiv~≡~le~≤~ge~≥~sub~⊂~sup~⊃~nsub~⊄~sube~⊆~supe~⊇~oplus~⊕~otimes~⊗~perp~⊥~sdot~⋅~lceil~⌈~rceil~⌉~lfloor~⌊~rfloor~⌋~lang~〈~rang~〉~loz~◊~spades~♠~clubs~♣~hearts~♥~diams~♦~~nbsp~ ~iexcl~¡~cent~¢~pound~£~curren~¤~yen~¥~brvbar~¦~sect~§~uml~¨~copy~©~ordf~ª~laquo~«~not~¬~shy~­~reg~®~macr~¯~deg~°~plusmn~±~sup2~²~sup3~³~acute~´~micro~µ~para~¶~middot~·~cedil~¸~sup1~¹~ordm~º~raquo~»~frac14~¼~frac12~½~frac34~¾~iquest~¿~Agrave~À~Aacute~Á~Acirc~Â~Atilde~Ã~Auml~Ä~Aring~Å~AElig~Æ~Ccedil~Ç~Egrave~È~Eacute~É~Ecirc~Ê~Euml~Ë~Igrave~Ì~Iacute~Í~Icirc~Î~Iuml~Ï~ETH~Ð~Ntilde~Ñ~Ograve~Ò~Oacute~Ó~Ocirc~Ô~Otilde~Õ~Ouml~Ö~times~×~Oslash~Ø~Ugrave~Ù~Uacute~Ú~Ucirc~Û~Uuml~Ü~Yacute~Ý~THORN~Þ~szlig~ß~agrave~à~aacute~á~acirc~â~atilde~ã~auml~ä~aring~å~aelig~æ~ccedil~ç~egrave~è~eacute~é~ecirc~ê~euml~ë~igrave~ì~iacute~í~icirc~î~iuml~ï~eth~ð~ntilde~ñ~ograve~ò~oacute~ó~ocirc~ô~otilde~õ~ouml~ö~divide~÷~oslash~ø~ugrave~ù~uacute~ú~ucirc~û~uuml~ü~yacute~ý~thorn~þ~yuml~ÿ~quot~"~amp~&~lt~<~gt~>`);
Se.html5 = Ft('Abreve~Ă~Acy~А~Afr~𝔄~Amacr~Ā~And~⩓~Aogon~Ą~Aopf~𝔸~ApplyFunction~⁡~Ascr~𝒜~Assign~≔~Backslash~∖~Barv~⫧~Barwed~⌆~Bcy~Б~Because~∵~Bernoullis~ℬ~Bfr~𝔅~Bopf~𝔹~Breve~˘~Bscr~ℬ~Bumpeq~≎~CHcy~Ч~Cacute~Ć~Cap~⋒~CapitalDifferentialD~ⅅ~Cayleys~ℭ~Ccaron~Č~Ccirc~Ĉ~Cconint~∰~Cdot~Ċ~Cedilla~¸~CenterDot~·~Cfr~ℭ~CircleDot~⊙~CircleMinus~⊖~CirclePlus~⊕~CircleTimes~⊗~ClockwiseContourIntegral~∲~CloseCurlyDoubleQuote~”~CloseCurlyQuote~’~Colon~∷~Colone~⩴~Congruent~≡~Conint~∯~ContourIntegral~∮~Copf~ℂ~Coproduct~∐~CounterClockwiseContourIntegral~∳~Cross~⨯~Cscr~𝒞~Cup~⋓~CupCap~≍~DD~ⅅ~DDotrahd~⤑~DJcy~Ђ~DScy~Ѕ~DZcy~Џ~Darr~↡~Dashv~⫤~Dcaron~Ď~Dcy~Д~Del~∇~Dfr~𝔇~DiacriticalAcute~´~DiacriticalDot~˙~DiacriticalDoubleAcute~˝~DiacriticalGrave~`~DiacriticalTilde~˜~Diamond~⋄~DifferentialD~ⅆ~Dopf~𝔻~Dot~¨~DotDot~⃜~DotEqual~≐~DoubleContourIntegral~∯~DoubleDot~¨~DoubleDownArrow~⇓~DoubleLeftArrow~⇐~DoubleLeftRightArrow~⇔~DoubleLeftTee~⫤~DoubleLongLeftArrow~⟸~DoubleLongLeftRightArrow~⟺~DoubleLongRightArrow~⟹~DoubleRightArrow~⇒~DoubleRightTee~⊨~DoubleUpArrow~⇑~DoubleUpDownArrow~⇕~DoubleVerticalBar~∥~DownArrow~↓~DownArrowBar~⤓~DownArrowUpArrow~⇵~DownBreve~̑~DownLeftRightVector~⥐~DownLeftTeeVector~⥞~DownLeftVector~↽~DownLeftVectorBar~⥖~DownRightTeeVector~⥟~DownRightVector~⇁~DownRightVectorBar~⥗~DownTee~⊤~DownTeeArrow~↧~Downarrow~⇓~Dscr~𝒟~Dstrok~Đ~ENG~Ŋ~Ecaron~Ě~Ecy~Э~Edot~Ė~Efr~𝔈~Element~∈~Emacr~Ē~EmptySmallSquare~◻~EmptyVerySmallSquare~▫~Eogon~Ę~Eopf~𝔼~Equal~⩵~EqualTilde~≂~Equilibrium~⇌~Escr~ℰ~Esim~⩳~Exists~∃~ExponentialE~ⅇ~Fcy~Ф~Ffr~𝔉~FilledSmallSquare~◼~FilledVerySmallSquare~▪~Fopf~𝔽~ForAll~∀~Fouriertrf~ℱ~Fscr~ℱ~GJcy~Ѓ~Gammad~Ϝ~Gbreve~Ğ~Gcedil~Ģ~Gcirc~Ĝ~Gcy~Г~Gdot~Ġ~Gfr~𝔊~Gg~⋙~Gopf~𝔾~GreaterEqual~≥~GreaterEqualLess~⋛~GreaterFullEqual~≧~GreaterGreater~⪢~GreaterLess~≷~GreaterSlantEqual~⩾~GreaterTilde~≳~Gscr~𝒢~Gt~≫~HARDcy~Ъ~Hacek~ˇ~Hat~^~Hcirc~Ĥ~Hfr~ℌ~HilbertSpace~ℋ~Hopf~ℍ~HorizontalLine~─~Hscr~ℋ~Hstrok~Ħ~HumpDownHump~≎~HumpEqual~≏~IEcy~Е~IJlig~Ĳ~IOcy~Ё~Icy~И~Idot~İ~Ifr~ℑ~Im~ℑ~Imacr~Ī~ImaginaryI~ⅈ~Implies~⇒~Int~∬~Integral~∫~Intersection~⋂~InvisibleComma~⁣~InvisibleTimes~⁢~Iogon~Į~Iopf~𝕀~Iscr~ℐ~Itilde~Ĩ~Iukcy~І~Jcirc~Ĵ~Jcy~Й~Jfr~𝔍~Jopf~𝕁~Jscr~𝒥~Jsercy~Ј~Jukcy~Є~KHcy~Х~KJcy~Ќ~Kcedil~Ķ~Kcy~К~Kfr~𝔎~Kopf~𝕂~Kscr~𝒦~LJcy~Љ~Lacute~Ĺ~Lang~⟪~Laplacetrf~ℒ~Larr~↞~Lcaron~Ľ~Lcedil~Ļ~Lcy~Л~LeftAngleBracket~⟨~LeftArrow~←~LeftArrowBar~⇤~LeftArrowRightArrow~⇆~LeftCeiling~⌈~LeftDoubleBracket~⟦~LeftDownTeeVector~⥡~LeftDownVector~⇃~LeftDownVectorBar~⥙~LeftFloor~⌊~LeftRightArrow~↔~LeftRightVector~⥎~LeftTee~⊣~LeftTeeArrow~↤~LeftTeeVector~⥚~LeftTriangle~⊲~LeftTriangleBar~⧏~LeftTriangleEqual~⊴~LeftUpDownVector~⥑~LeftUpTeeVector~⥠~LeftUpVector~↿~LeftUpVectorBar~⥘~LeftVector~↼~LeftVectorBar~⥒~Leftarrow~⇐~Leftrightarrow~⇔~LessEqualGreater~⋚~LessFullEqual~≦~LessGreater~≶~LessLess~⪡~LessSlantEqual~⩽~LessTilde~≲~Lfr~𝔏~Ll~⋘~Lleftarrow~⇚~Lmidot~Ŀ~LongLeftArrow~⟵~LongLeftRightArrow~⟷~LongRightArrow~⟶~Longleftarrow~⟸~Longleftrightarrow~⟺~Longrightarrow~⟹~Lopf~𝕃~LowerLeftArrow~↙~LowerRightArrow~↘~Lscr~ℒ~Lsh~↰~Lstrok~Ł~Lt~≪~Map~⤅~Mcy~М~MediumSpace~ ~Mellintrf~ℳ~Mfr~𝔐~MinusPlus~∓~Mopf~𝕄~Mscr~ℳ~NJcy~Њ~Nacute~Ń~Ncaron~Ň~Ncedil~Ņ~Ncy~Н~NegativeMediumSpace~​~NegativeThickSpace~​~NegativeThinSpace~​~NegativeVeryThinSpace~​~NestedGreaterGreater~≫~NestedLessLess~≪~NewLine~\n~Nfr~𝔑~NoBreak~⁠~NonBreakingSpace~ ~Nopf~ℕ~Not~⫬~NotCongruent~≢~NotCupCap~≭~NotDoubleVerticalBar~∦~NotElement~∉~NotEqual~≠~NotEqualTilde~≂̸~NotExists~∄~NotGreater~≯~NotGreaterEqual~≱~NotGreaterFullEqual~≧̸~NotGreaterGreater~≫̸~NotGreaterLess~≹~NotGreaterSlantEqual~⩾̸~NotGreaterTilde~≵~NotHumpDownHump~≎̸~NotHumpEqual~≏̸~NotLeftTriangle~⋪~NotLeftTriangleBar~⧏̸~NotLeftTriangleEqual~⋬~NotLess~≮~NotLessEqual~≰~NotLessGreater~≸~NotLessLess~≪̸~NotLessSlantEqual~⩽̸~NotLessTilde~≴~NotNestedGreaterGreater~⪢̸~NotNestedLessLess~⪡̸~NotPrecedes~⊀~NotPrecedesEqual~⪯̸~NotPrecedesSlantEqual~⋠~NotReverseElement~∌~NotRightTriangle~⋫~NotRightTriangleBar~⧐̸~NotRightTriangleEqual~⋭~NotSquareSubset~⊏̸~NotSquareSubsetEqual~⋢~NotSquareSuperset~⊐̸~NotSquareSupersetEqual~⋣~NotSubset~⊂⃒~NotSubsetEqual~⊈~NotSucceeds~⊁~NotSucceedsEqual~⪰̸~NotSucceedsSlantEqual~⋡~NotSucceedsTilde~≿̸~NotSuperset~⊃⃒~NotSupersetEqual~⊉~NotTilde~≁~NotTildeEqual~≄~NotTildeFullEqual~≇~NotTildeTilde~≉~NotVerticalBar~∤~Nscr~𝒩~Ocy~О~Odblac~Ő~Ofr~𝔒~Omacr~Ō~Oopf~𝕆~OpenCurlyDoubleQuote~“~OpenCurlyQuote~‘~Or~⩔~Oscr~𝒪~Otimes~⨷~OverBar~‾~OverBrace~⏞~OverBracket~⎴~OverParenthesis~⏜~PartialD~∂~Pcy~П~Pfr~𝔓~PlusMinus~±~Poincareplane~ℌ~Popf~ℙ~Pr~⪻~Precedes~≺~PrecedesEqual~⪯~PrecedesSlantEqual~≼~PrecedesTilde~≾~Product~∏~Proportion~∷~Proportional~∝~Pscr~𝒫~Qfr~𝔔~Qopf~ℚ~Qscr~𝒬~RBarr~⤐~Racute~Ŕ~Rang~⟫~Rarr~↠~Rarrtl~⤖~Rcaron~Ř~Rcedil~Ŗ~Rcy~Р~Re~ℜ~ReverseElement~∋~ReverseEquilibrium~⇋~ReverseUpEquilibrium~⥯~Rfr~ℜ~RightAngleBracket~⟩~RightArrow~→~RightArrowBar~⇥~RightArrowLeftArrow~⇄~RightCeiling~⌉~RightDoubleBracket~⟧~RightDownTeeVector~⥝~RightDownVector~⇂~RightDownVectorBar~⥕~RightFloor~⌋~RightTee~⊢~RightTeeArrow~↦~RightTeeVector~⥛~RightTriangle~⊳~RightTriangleBar~⧐~RightTriangleEqual~⊵~RightUpDownVector~⥏~RightUpTeeVector~⥜~RightUpVector~↾~RightUpVectorBar~⥔~RightVector~⇀~RightVectorBar~⥓~Rightarrow~⇒~Ropf~ℝ~RoundImplies~⥰~Rrightarrow~⇛~Rscr~ℛ~Rsh~↱~RuleDelayed~⧴~SHCHcy~Щ~SHcy~Ш~SOFTcy~Ь~Sacute~Ś~Sc~⪼~Scedil~Ş~Scirc~Ŝ~Scy~С~Sfr~𝔖~ShortDownArrow~↓~ShortLeftArrow~←~ShortRightArrow~→~ShortUpArrow~↑~SmallCircle~∘~Sopf~𝕊~Sqrt~√~Square~□~SquareIntersection~⊓~SquareSubset~⊏~SquareSubsetEqual~⊑~SquareSuperset~⊐~SquareSupersetEqual~⊒~SquareUnion~⊔~Sscr~𝒮~Star~⋆~Sub~⋐~Subset~⋐~SubsetEqual~⊆~Succeeds~≻~SucceedsEqual~⪰~SucceedsSlantEqual~≽~SucceedsTilde~≿~SuchThat~∋~Sum~∑~Sup~⋑~Superset~⊃~SupersetEqual~⊇~Supset~⋑~TRADE~™~TSHcy~Ћ~TScy~Ц~Tab~	~Tcaron~Ť~Tcedil~Ţ~Tcy~Т~Tfr~𝔗~Therefore~∴~ThickSpace~  ~ThinSpace~ ~Tilde~∼~TildeEqual~≃~TildeFullEqual~≅~TildeTilde~≈~Topf~𝕋~TripleDot~⃛~Tscr~𝒯~Tstrok~Ŧ~Uarr~↟~Uarrocir~⥉~Ubrcy~Ў~Ubreve~Ŭ~Ucy~У~Udblac~Ű~Ufr~𝔘~Umacr~Ū~UnderBar~_~UnderBrace~⏟~UnderBracket~⎵~UnderParenthesis~⏝~Union~⋃~UnionPlus~⊎~Uogon~Ų~Uopf~𝕌~UpArrow~↑~UpArrowBar~⤒~UpArrowDownArrow~⇅~UpDownArrow~↕~UpEquilibrium~⥮~UpTee~⊥~UpTeeArrow~↥~Uparrow~⇑~Updownarrow~⇕~UpperLeftArrow~↖~UpperRightArrow~↗~Upsi~ϒ~Uring~Ů~Uscr~𝒰~Utilde~Ũ~VDash~⊫~Vbar~⫫~Vcy~В~Vdash~⊩~Vdashl~⫦~Vee~⋁~Verbar~‖~Vert~‖~VerticalBar~∣~VerticalLine~|~VerticalSeparator~❘~VerticalTilde~≀~VeryThinSpace~ ~Vfr~𝔙~Vopf~𝕍~Vscr~𝒱~Vvdash~⊪~Wcirc~Ŵ~Wedge~⋀~Wfr~𝔚~Wopf~𝕎~Wscr~𝒲~Xfr~𝔛~Xopf~𝕏~Xscr~𝒳~YAcy~Я~YIcy~Ї~YUcy~Ю~Ycirc~Ŷ~Ycy~Ы~Yfr~𝔜~Yopf~𝕐~Yscr~𝒴~ZHcy~Ж~Zacute~Ź~Zcaron~Ž~Zcy~З~Zdot~Ż~ZeroWidthSpace~​~Zfr~ℨ~Zopf~ℤ~Zscr~𝒵~abreve~ă~ac~∾~acE~∾̳~acd~∿~acy~а~af~⁡~afr~𝔞~aleph~ℵ~amacr~ā~amalg~⨿~andand~⩕~andd~⩜~andslope~⩘~andv~⩚~ange~⦤~angle~∠~angmsd~∡~angmsdaa~⦨~angmsdab~⦩~angmsdac~⦪~angmsdad~⦫~angmsdae~⦬~angmsdaf~⦭~angmsdag~⦮~angmsdah~⦯~angrt~∟~angrtvb~⊾~angrtvbd~⦝~angsph~∢~angst~Å~angzarr~⍼~aogon~ą~aopf~𝕒~ap~≈~apE~⩰~apacir~⩯~ape~≊~apid~≋~approx~≈~approxeq~≊~ascr~𝒶~ast~*~asympeq~≍~awconint~∳~awint~⨑~bNot~⫭~backcong~≌~backepsilon~϶~backprime~‵~backsim~∽~backsimeq~⋍~barvee~⊽~barwed~⌅~barwedge~⌅~bbrk~⎵~bbrktbrk~⎶~bcong~≌~bcy~б~becaus~∵~because~∵~bemptyv~⦰~bepsi~϶~bernou~ℬ~beth~ℶ~between~≬~bfr~𝔟~bigcap~⋂~bigcirc~◯~bigcup~⋃~bigodot~⨀~bigoplus~⨁~bigotimes~⨂~bigsqcup~⨆~bigstar~★~bigtriangledown~▽~bigtriangleup~△~biguplus~⨄~bigvee~⋁~bigwedge~⋀~bkarow~⤍~blacklozenge~⧫~blacksquare~▪~blacktriangle~▴~blacktriangledown~▾~blacktriangleleft~◂~blacktriangleright~▸~blank~␣~blk12~▒~blk14~░~blk34~▓~block~█~bne~=⃥~bnequiv~≡⃥~bnot~⌐~bopf~𝕓~bot~⊥~bottom~⊥~bowtie~⋈~boxDL~╗~boxDR~╔~boxDl~╖~boxDr~╓~boxH~═~boxHD~╦~boxHU~╩~boxHd~╤~boxHu~╧~boxUL~╝~boxUR~╚~boxUl~╜~boxUr~╙~boxV~║~boxVH~╬~boxVL~╣~boxVR~╠~boxVh~╫~boxVl~╢~boxVr~╟~boxbox~⧉~boxdL~╕~boxdR~╒~boxdl~┐~boxdr~┌~boxh~─~boxhD~╥~boxhU~╨~boxhd~┬~boxhu~┴~boxminus~⊟~boxplus~⊞~boxtimes~⊠~boxuL~╛~boxuR~╘~boxul~┘~boxur~└~boxv~│~boxvH~╪~boxvL~╡~boxvR~╞~boxvh~┼~boxvl~┤~boxvr~├~bprime~‵~breve~˘~bscr~𝒷~bsemi~⁏~bsim~∽~bsime~⋍~bsol~\\~bsolb~⧅~bsolhsub~⟈~bullet~•~bump~≎~bumpE~⪮~bumpe~≏~bumpeq~≏~cacute~ć~capand~⩄~capbrcup~⩉~capcap~⩋~capcup~⩇~capdot~⩀~caps~∩︀~caret~⁁~caron~ˇ~ccaps~⩍~ccaron~č~ccirc~ĉ~ccups~⩌~ccupssm~⩐~cdot~ċ~cemptyv~⦲~centerdot~·~cfr~𝔠~chcy~ч~check~✓~checkmark~✓~cir~○~cirE~⧃~circeq~≗~circlearrowleft~↺~circlearrowright~↻~circledR~®~circledS~Ⓢ~circledast~⊛~circledcirc~⊚~circleddash~⊝~cire~≗~cirfnint~⨐~cirmid~⫯~cirscir~⧂~clubsuit~♣~colon~:~colone~≔~coloneq~≔~comma~,~commat~@~comp~∁~compfn~∘~complement~∁~complexes~ℂ~congdot~⩭~conint~∮~copf~𝕔~coprod~∐~copysr~℗~cross~✗~cscr~𝒸~csub~⫏~csube~⫑~csup~⫐~csupe~⫒~ctdot~⋯~cudarrl~⤸~cudarrr~⤵~cuepr~⋞~cuesc~⋟~cularr~↶~cularrp~⤽~cupbrcap~⩈~cupcap~⩆~cupcup~⩊~cupdot~⊍~cupor~⩅~cups~∪︀~curarr~↷~curarrm~⤼~curlyeqprec~⋞~curlyeqsucc~⋟~curlyvee~⋎~curlywedge~⋏~curvearrowleft~↶~curvearrowright~↷~cuvee~⋎~cuwed~⋏~cwconint~∲~cwint~∱~cylcty~⌭~dHar~⥥~daleth~ℸ~dash~‐~dashv~⊣~dbkarow~⤏~dblac~˝~dcaron~ď~dcy~д~dd~ⅆ~ddagger~‡~ddarr~⇊~ddotseq~⩷~demptyv~⦱~dfisht~⥿~dfr~𝔡~dharl~⇃~dharr~⇂~diam~⋄~diamond~⋄~diamondsuit~♦~die~¨~digamma~ϝ~disin~⋲~div~÷~divideontimes~⋇~divonx~⋇~djcy~ђ~dlcorn~⌞~dlcrop~⌍~dollar~$~dopf~𝕕~dot~˙~doteq~≐~doteqdot~≑~dotminus~∸~dotplus~∔~dotsquare~⊡~doublebarwedge~⌆~downarrow~↓~downdownarrows~⇊~downharpoonleft~⇃~downharpoonright~⇂~drbkarow~⤐~drcorn~⌟~drcrop~⌌~dscr~𝒹~dscy~ѕ~dsol~⧶~dstrok~đ~dtdot~⋱~dtri~▿~dtrif~▾~duarr~⇵~duhar~⥯~dwangle~⦦~dzcy~џ~dzigrarr~⟿~eDDot~⩷~eDot~≑~easter~⩮~ecaron~ě~ecir~≖~ecolon~≕~ecy~э~edot~ė~ee~ⅇ~efDot~≒~efr~𝔢~eg~⪚~egs~⪖~egsdot~⪘~el~⪙~elinters~⏧~ell~ℓ~els~⪕~elsdot~⪗~emacr~ē~emptyset~∅~emptyv~∅~emsp13~ ~emsp14~ ~eng~ŋ~eogon~ę~eopf~𝕖~epar~⋕~eparsl~⧣~eplus~⩱~epsi~ε~epsiv~ϵ~eqcirc~≖~eqcolon~≕~eqsim~≂~eqslantgtr~⪖~eqslantless~⪕~equals~=~equest~≟~equivDD~⩸~eqvparsl~⧥~erDot~≓~erarr~⥱~escr~ℯ~esdot~≐~esim~≂~excl~!~expectation~ℰ~exponentiale~ⅇ~fallingdotseq~≒~fcy~ф~female~♀~ffilig~ﬃ~fflig~ﬀ~ffllig~ﬄ~ffr~𝔣~filig~ﬁ~fjlig~fj~flat~♭~fllig~ﬂ~fltns~▱~fopf~𝕗~fork~⋔~forkv~⫙~fpartint~⨍~frac13~⅓~frac15~⅕~frac16~⅙~frac18~⅛~frac23~⅔~frac25~⅖~frac35~⅗~frac38~⅜~frac45~⅘~frac56~⅚~frac58~⅝~frac78~⅞~frown~⌢~fscr~𝒻~gE~≧~gEl~⪌~gacute~ǵ~gammad~ϝ~gap~⪆~gbreve~ğ~gcirc~ĝ~gcy~г~gdot~ġ~gel~⋛~geq~≥~geqq~≧~geqslant~⩾~ges~⩾~gescc~⪩~gesdot~⪀~gesdoto~⪂~gesdotol~⪄~gesl~⋛︀~gesles~⪔~gfr~𝔤~gg~≫~ggg~⋙~gimel~ℷ~gjcy~ѓ~gl~≷~glE~⪒~gla~⪥~glj~⪤~gnE~≩~gnap~⪊~gnapprox~⪊~gne~⪈~gneq~⪈~gneqq~≩~gnsim~⋧~gopf~𝕘~grave~`~gscr~ℊ~gsim~≳~gsime~⪎~gsiml~⪐~gtcc~⪧~gtcir~⩺~gtdot~⋗~gtlPar~⦕~gtquest~⩼~gtrapprox~⪆~gtrarr~⥸~gtrdot~⋗~gtreqless~⋛~gtreqqless~⪌~gtrless~≷~gtrsim~≳~gvertneqq~≩︀~gvnE~≩︀~hairsp~ ~half~½~hamilt~ℋ~hardcy~ъ~harrcir~⥈~harrw~↭~hbar~ℏ~hcirc~ĥ~heartsuit~♥~hercon~⊹~hfr~𝔥~hksearow~⤥~hkswarow~⤦~hoarr~⇿~homtht~∻~hookleftarrow~↩~hookrightarrow~↪~hopf~𝕙~horbar~―~hscr~𝒽~hslash~ℏ~hstrok~ħ~hybull~⁃~hyphen~‐~ic~⁣~icy~и~iecy~е~iff~⇔~ifr~𝔦~ii~ⅈ~iiiint~⨌~iiint~∭~iinfin~⧜~iiota~℩~ijlig~ĳ~imacr~ī~imagline~ℐ~imagpart~ℑ~imath~ı~imof~⊷~imped~Ƶ~in~∈~incare~℅~infintie~⧝~inodot~ı~intcal~⊺~integers~ℤ~intercal~⊺~intlarhk~⨗~intprod~⨼~iocy~ё~iogon~į~iopf~𝕚~iprod~⨼~iscr~𝒾~isinE~⋹~isindot~⋵~isins~⋴~isinsv~⋳~isinv~∈~it~⁢~itilde~ĩ~iukcy~і~jcirc~ĵ~jcy~й~jfr~𝔧~jmath~ȷ~jopf~𝕛~jscr~𝒿~jsercy~ј~jukcy~є~kappav~ϰ~kcedil~ķ~kcy~к~kfr~𝔨~kgreen~ĸ~khcy~х~kjcy~ќ~kopf~𝕜~kscr~𝓀~lAarr~⇚~lAtail~⤛~lBarr~⤎~lE~≦~lEg~⪋~lHar~⥢~lacute~ĺ~laemptyv~⦴~lagran~ℒ~langd~⦑~langle~⟨~lap~⪅~larrb~⇤~larrbfs~⤟~larrfs~⤝~larrhk~↩~larrlp~↫~larrpl~⤹~larrsim~⥳~larrtl~↢~lat~⪫~latail~⤙~late~⪭~lates~⪭︀~lbarr~⤌~lbbrk~❲~lbrace~{~lbrack~[~lbrke~⦋~lbrksld~⦏~lbrkslu~⦍~lcaron~ľ~lcedil~ļ~lcub~{~lcy~л~ldca~⤶~ldquor~„~ldrdhar~⥧~ldrushar~⥋~ldsh~↲~leftarrow~←~leftarrowtail~↢~leftharpoondown~↽~leftharpoonup~↼~leftleftarrows~⇇~leftrightarrow~↔~leftrightarrows~⇆~leftrightharpoons~⇋~leftrightsquigarrow~↭~leftthreetimes~⋋~leg~⋚~leq~≤~leqq~≦~leqslant~⩽~les~⩽~lescc~⪨~lesdot~⩿~lesdoto~⪁~lesdotor~⪃~lesg~⋚︀~lesges~⪓~lessapprox~⪅~lessdot~⋖~lesseqgtr~⋚~lesseqqgtr~⪋~lessgtr~≶~lesssim~≲~lfisht~⥼~lfr~𝔩~lg~≶~lgE~⪑~lhard~↽~lharu~↼~lharul~⥪~lhblk~▄~ljcy~љ~ll~≪~llarr~⇇~llcorner~⌞~llhard~⥫~lltri~◺~lmidot~ŀ~lmoust~⎰~lmoustache~⎰~lnE~≨~lnap~⪉~lnapprox~⪉~lne~⪇~lneq~⪇~lneqq~≨~lnsim~⋦~loang~⟬~loarr~⇽~lobrk~⟦~longleftarrow~⟵~longleftrightarrow~⟷~longmapsto~⟼~longrightarrow~⟶~looparrowleft~↫~looparrowright~↬~lopar~⦅~lopf~𝕝~loplus~⨭~lotimes~⨴~lowbar~_~lozenge~◊~lozf~⧫~lpar~(~lparlt~⦓~lrarr~⇆~lrcorner~⌟~lrhar~⇋~lrhard~⥭~lrtri~⊿~lscr~𝓁~lsh~↰~lsim~≲~lsime~⪍~lsimg~⪏~lsqb~[~lsquor~‚~lstrok~ł~ltcc~⪦~ltcir~⩹~ltdot~⋖~lthree~⋋~ltimes~⋉~ltlarr~⥶~ltquest~⩻~ltrPar~⦖~ltri~◃~ltrie~⊴~ltrif~◂~lurdshar~⥊~luruhar~⥦~lvertneqq~≨︀~lvnE~≨︀~mDDot~∺~male~♂~malt~✠~maltese~✠~map~↦~mapsto~↦~mapstodown~↧~mapstoleft~↤~mapstoup~↥~marker~▮~mcomma~⨩~mcy~м~measuredangle~∡~mfr~𝔪~mho~℧~mid~∣~midast~*~midcir~⫰~minusb~⊟~minusd~∸~minusdu~⨪~mlcp~⫛~mldr~…~mnplus~∓~models~⊧~mopf~𝕞~mp~∓~mscr~𝓂~mstpos~∾~multimap~⊸~mumap~⊸~nGg~⋙̸~nGt~≫⃒~nGtv~≫̸~nLeftarrow~⇍~nLeftrightarrow~⇎~nLl~⋘̸~nLt~≪⃒~nLtv~≪̸~nRightarrow~⇏~nVDash~⊯~nVdash~⊮~nacute~ń~nang~∠⃒~nap~≉~napE~⩰̸~napid~≋̸~napos~ŉ~napprox~≉~natur~♮~natural~♮~naturals~ℕ~nbump~≎̸~nbumpe~≏̸~ncap~⩃~ncaron~ň~ncedil~ņ~ncong~≇~ncongdot~⩭̸~ncup~⩂~ncy~н~neArr~⇗~nearhk~⤤~nearr~↗~nearrow~↗~nedot~≐̸~nequiv~≢~nesear~⤨~nesim~≂̸~nexist~∄~nexists~∄~nfr~𝔫~ngE~≧̸~nge~≱~ngeq~≱~ngeqq~≧̸~ngeqslant~⩾̸~nges~⩾̸~ngsim~≵~ngt~≯~ngtr~≯~nhArr~⇎~nharr~↮~nhpar~⫲~nis~⋼~nisd~⋺~niv~∋~njcy~њ~nlArr~⇍~nlE~≦̸~nlarr~↚~nldr~‥~nle~≰~nleftarrow~↚~nleftrightarrow~↮~nleq~≰~nleqq~≦̸~nleqslant~⩽̸~nles~⩽̸~nless~≮~nlsim~≴~nlt~≮~nltri~⋪~nltrie~⋬~nmid~∤~nopf~𝕟~notinE~⋹̸~notindot~⋵̸~notinva~∉~notinvb~⋷~notinvc~⋶~notni~∌~notniva~∌~notnivb~⋾~notnivc~⋽~npar~∦~nparallel~∦~nparsl~⫽⃥~npart~∂̸~npolint~⨔~npr~⊀~nprcue~⋠~npre~⪯̸~nprec~⊀~npreceq~⪯̸~nrArr~⇏~nrarr~↛~nrarrc~⤳̸~nrarrw~↝̸~nrightarrow~↛~nrtri~⋫~nrtrie~⋭~nsc~⊁~nsccue~⋡~nsce~⪰̸~nscr~𝓃~nshortmid~∤~nshortparallel~∦~nsim~≁~nsime~≄~nsimeq~≄~nsmid~∤~nspar~∦~nsqsube~⋢~nsqsupe~⋣~nsubE~⫅̸~nsube~⊈~nsubset~⊂⃒~nsubseteq~⊈~nsubseteqq~⫅̸~nsucc~⊁~nsucceq~⪰̸~nsup~⊅~nsupE~⫆̸~nsupe~⊉~nsupset~⊃⃒~nsupseteq~⊉~nsupseteqq~⫆̸~ntgl~≹~ntlg~≸~ntriangleleft~⋪~ntrianglelefteq~⋬~ntriangleright~⋫~ntrianglerighteq~⋭~num~#~numero~№~numsp~ ~nvDash~⊭~nvHarr~⤄~nvap~≍⃒~nvdash~⊬~nvge~≥⃒~nvgt~>⃒~nvinfin~⧞~nvlArr~⤂~nvle~≤⃒~nvlt~<⃒~nvltrie~⊴⃒~nvrArr~⤃~nvrtrie~⊵⃒~nvsim~∼⃒~nwArr~⇖~nwarhk~⤣~nwarr~↖~nwarrow~↖~nwnear~⤧~oS~Ⓢ~oast~⊛~ocir~⊚~ocy~о~odash~⊝~odblac~ő~odiv~⨸~odot~⊙~odsold~⦼~ofcir~⦿~ofr~𝔬~ogon~˛~ogt~⧁~ohbar~⦵~ohm~Ω~oint~∮~olarr~↺~olcir~⦾~olcross~⦻~olt~⧀~omacr~ō~omid~⦶~ominus~⊖~oopf~𝕠~opar~⦷~operp~⦹~orarr~↻~ord~⩝~order~ℴ~orderof~ℴ~origof~⊶~oror~⩖~orslope~⩗~orv~⩛~oscr~ℴ~osol~⊘~otimesas~⨶~ovbar~⌽~par~∥~parallel~∥~parsim~⫳~parsl~⫽~pcy~п~percnt~%~period~.~pertenk~‱~pfr~𝔭~phiv~ϕ~phmmat~ℳ~phone~☎~pitchfork~⋔~planck~ℏ~planckh~ℎ~plankv~ℏ~plus~+~plusacir~⨣~plusb~⊞~pluscir~⨢~plusdo~∔~plusdu~⨥~pluse~⩲~plussim~⨦~plustwo~⨧~pm~±~pointint~⨕~popf~𝕡~pr~≺~prE~⪳~prap~⪷~prcue~≼~pre~⪯~prec~≺~precapprox~⪷~preccurlyeq~≼~preceq~⪯~precnapprox~⪹~precneqq~⪵~precnsim~⋨~precsim~≾~primes~ℙ~prnE~⪵~prnap~⪹~prnsim~⋨~profalar~⌮~profline~⌒~profsurf~⌓~propto~∝~prsim~≾~prurel~⊰~pscr~𝓅~puncsp~ ~qfr~𝔮~qint~⨌~qopf~𝕢~qprime~⁗~qscr~𝓆~quaternions~ℍ~quatint~⨖~quest~?~questeq~≟~rAarr~⇛~rAtail~⤜~rBarr~⤏~rHar~⥤~race~∽̱~racute~ŕ~raemptyv~⦳~rangd~⦒~range~⦥~rangle~⟩~rarrap~⥵~rarrb~⇥~rarrbfs~⤠~rarrc~⤳~rarrfs~⤞~rarrhk~↪~rarrlp~↬~rarrpl~⥅~rarrsim~⥴~rarrtl~↣~rarrw~↝~ratail~⤚~ratio~∶~rationals~ℚ~rbarr~⤍~rbbrk~❳~rbrace~}~rbrack~]~rbrke~⦌~rbrksld~⦎~rbrkslu~⦐~rcaron~ř~rcedil~ŗ~rcub~}~rcy~р~rdca~⤷~rdldhar~⥩~rdquor~”~rdsh~↳~realine~ℛ~realpart~ℜ~reals~ℝ~rect~▭~rfisht~⥽~rfr~𝔯~rhard~⇁~rharu~⇀~rharul~⥬~rhov~ϱ~rightarrow~→~rightarrowtail~↣~rightharpoondown~⇁~rightharpoonup~⇀~rightleftarrows~⇄~rightleftharpoons~⇌~rightrightarrows~⇉~rightsquigarrow~↝~rightthreetimes~⋌~ring~˚~risingdotseq~≓~rlarr~⇄~rlhar~⇌~rmoust~⎱~rmoustache~⎱~rnmid~⫮~roang~⟭~roarr~⇾~robrk~⟧~ropar~⦆~ropf~𝕣~roplus~⨮~rotimes~⨵~rpar~)~rpargt~⦔~rppolint~⨒~rrarr~⇉~rscr~𝓇~rsh~↱~rsqb~]~rsquor~’~rthree~⋌~rtimes~⋊~rtri~▹~rtrie~⊵~rtrif~▸~rtriltri~⧎~ruluhar~⥨~rx~℞~sacute~ś~sc~≻~scE~⪴~scap~⪸~sccue~≽~sce~⪰~scedil~ş~scirc~ŝ~scnE~⪶~scnap~⪺~scnsim~⋩~scpolint~⨓~scsim~≿~scy~с~sdotb~⊡~sdote~⩦~seArr~⇘~searhk~⤥~searr~↘~searrow~↘~semi~;~seswar~⤩~setminus~∖~setmn~∖~sext~✶~sfr~𝔰~sfrown~⌢~sharp~♯~shchcy~щ~shcy~ш~shortmid~∣~shortparallel~∥~sigmav~ς~simdot~⩪~sime~≃~simeq~≃~simg~⪞~simgE~⪠~siml~⪝~simlE~⪟~simne~≆~simplus~⨤~simrarr~⥲~slarr~←~smallsetminus~∖~smashp~⨳~smeparsl~⧤~smid~∣~smile~⌣~smt~⪪~smte~⪬~smtes~⪬︀~softcy~ь~sol~/~solb~⧄~solbar~⌿~sopf~𝕤~spadesuit~♠~spar~∥~sqcap~⊓~sqcaps~⊓︀~sqcup~⊔~sqcups~⊔︀~sqsub~⊏~sqsube~⊑~sqsubset~⊏~sqsubseteq~⊑~sqsup~⊐~sqsupe~⊒~sqsupset~⊐~sqsupseteq~⊒~squ~□~square~□~squarf~▪~squf~▪~srarr~→~sscr~𝓈~ssetmn~∖~ssmile~⌣~sstarf~⋆~star~☆~starf~★~straightepsilon~ϵ~straightphi~ϕ~strns~¯~subE~⫅~subdot~⪽~subedot~⫃~submult~⫁~subnE~⫋~subne~⊊~subplus~⪿~subrarr~⥹~subset~⊂~subseteq~⊆~subseteqq~⫅~subsetneq~⊊~subsetneqq~⫋~subsim~⫇~subsub~⫕~subsup~⫓~succ~≻~succapprox~⪸~succcurlyeq~≽~succeq~⪰~succnapprox~⪺~succneqq~⪶~succnsim~⋩~succsim~≿~sung~♪~supE~⫆~supdot~⪾~supdsub~⫘~supedot~⫄~suphsol~⟉~suphsub~⫗~suplarr~⥻~supmult~⫂~supnE~⫌~supne~⊋~supplus~⫀~supset~⊃~supseteq~⊇~supseteqq~⫆~supsetneq~⊋~supsetneqq~⫌~supsim~⫈~supsub~⫔~supsup~⫖~swArr~⇙~swarhk~⤦~swarr~↙~swarrow~↙~swnwar~⤪~target~⌖~tbrk~⎴~tcaron~ť~tcedil~ţ~tcy~т~tdot~⃛~telrec~⌕~tfr~𝔱~therefore~∴~thetav~ϑ~thickapprox~≈~thicksim~∼~thkap~≈~thksim~∼~timesb~⊠~timesbar~⨱~timesd~⨰~tint~∭~toea~⤨~top~⊤~topbot~⌶~topcir~⫱~topf~𝕥~topfork~⫚~tosa~⤩~tprime~‴~triangle~▵~triangledown~▿~triangleleft~◃~trianglelefteq~⊴~triangleq~≜~triangleright~▹~trianglerighteq~⊵~tridot~◬~trie~≜~triminus~⨺~triplus~⨹~trisb~⧍~tritime~⨻~trpezium~⏢~tscr~𝓉~tscy~ц~tshcy~ћ~tstrok~ŧ~twixt~≬~twoheadleftarrow~↞~twoheadrightarrow~↠~uHar~⥣~ubrcy~ў~ubreve~ŭ~ucy~у~udarr~⇅~udblac~ű~udhar~⥮~ufisht~⥾~ufr~𝔲~uharl~↿~uharr~↾~uhblk~▀~ulcorn~⌜~ulcorner~⌜~ulcrop~⌏~ultri~◸~umacr~ū~uogon~ų~uopf~𝕦~uparrow~↑~updownarrow~↕~upharpoonleft~↿~upharpoonright~↾~uplus~⊎~upsi~υ~upuparrows~⇈~urcorn~⌝~urcorner~⌝~urcrop~⌎~uring~ů~urtri~◹~uscr~𝓊~utdot~⋰~utilde~ũ~utri~▵~utrif~▴~uuarr~⇈~uwangle~⦧~vArr~⇕~vBar~⫨~vBarv~⫩~vDash~⊨~vangrt~⦜~varepsilon~ϵ~varkappa~ϰ~varnothing~∅~varphi~ϕ~varpi~ϖ~varpropto~∝~varr~↕~varrho~ϱ~varsigma~ς~varsubsetneq~⊊︀~varsubsetneqq~⫋︀~varsupsetneq~⊋︀~varsupsetneqq~⫌︀~vartheta~ϑ~vartriangleleft~⊲~vartriangleright~⊳~vcy~в~vdash~⊢~vee~∨~veebar~⊻~veeeq~≚~vellip~⋮~verbar~|~vert~|~vfr~𝔳~vltri~⊲~vnsub~⊂⃒~vnsup~⊃⃒~vopf~𝕧~vprop~∝~vrtri~⊳~vscr~𝓋~vsubnE~⫋︀~vsubne~⊊︀~vsupnE~⫌︀~vsupne~⊋︀~vzigzag~⦚~wcirc~ŵ~wedbar~⩟~wedge~∧~wedgeq~≙~wfr~𝔴~wopf~𝕨~wp~℘~wr~≀~wreath~≀~wscr~𝓌~xcap~⋂~xcirc~◯~xcup~⋃~xdtri~▽~xfr~𝔵~xhArr~⟺~xharr~⟷~xlArr~⟸~xlarr~⟵~xmap~⟼~xnis~⋻~xodot~⨀~xopf~𝕩~xoplus~⨁~xotime~⨂~xrArr~⟹~xrarr~⟶~xscr~𝓍~xsqcup~⨆~xuplus~⨄~xutri~△~xvee~⋁~xwedge~⋀~yacy~я~ycirc~ŷ~ycy~ы~yfr~𝔶~yicy~ї~yopf~𝕪~yscr~𝓎~yucy~ю~zacute~ź~zcaron~ž~zcy~з~zdot~ż~zeetrf~ℨ~zfr~𝔷~zhcy~ж~zigrarr~⇝~zopf~𝕫~zscr~𝓏~~AMP~&~COPY~©~GT~>~LT~<~QUOT~"~REG~®', Se.html4);
var ei = {
  0: 65533,
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, ti = String.fromCodePoint || function(u) {
  return String.fromCharCode(Math.floor((u - 65536) / 1024) + 55296, (u - 65536) % 1024 + 56320);
}, Ee = function() {
  return Ee = Object.assign || function(u) {
    for (var x, m = 1, f = arguments.length; m < f; m++) {
      x = arguments[m];
      for (var l in x) Object.prototype.hasOwnProperty.call(x, l) && (u[l] = x[l]);
    }
    return u;
  }, Ee.apply(this, arguments);
}, ui = Ee(Ee({}, Se), { all: Se.html5 }), ri = {
  scope: "body",
  level: "all"
}, _t = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g, Rt = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g, tr = {
  xml: {
    strict: _t,
    attribute: Rt,
    body: It.xml
  },
  html4: {
    strict: _t,
    attribute: Rt,
    body: It.html4
  },
  html5: {
    strict: _t,
    attribute: Rt,
    body: It.html5
  }
}, ii = Ee(Ee({}, tr), { all: tr.html5 }), hr = String.fromCharCode, ni = hr(65533);
function ai(u, x, m, f) {
  var l = u, p = u[u.length - 1];
  if (m && p === "=")
    l = u;
  else if (f && p !== ";")
    l = u;
  else {
    var a = x[u];
    if (a)
      l = a;
    else if (u[0] === "&" && u[1] === "#") {
      var d = u[2], b = d == "x" || d == "X" ? parseInt(u.substr(3), 16) : parseInt(u.substr(2));
      l = b >= 1114111 ? ni : b > 65535 ? ti(b) : hr(ei[b] || b);
    }
  }
  return l;
}
function He(u, x) {
  var m = ri, f = m.level, l = f === void 0 ? "all" : f, p = m.scope, a = p === void 0 ? l === "xml" ? "strict" : "body" : p;
  if (!u)
    return "";
  var d = ii[l][a], b = ui[l].entities, i = a === "attribute", r = a === "strict";
  return u.replace(d, function(c) {
    return ai(c, b, i, r);
  });
}
const pr = ({ cents: u, locale: x, showCents: m = !1 }) => new Intl.NumberFormat(x, {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: m ? 2 : 0,
  maximumFractionDigits: m ? 2 : 0
}).format(u / 100), Ri = ({
  project: u,
  locale: x = document.documentElement.lang || "de",
  href: m,
  onClick: f,
  className: l,
  showDescription: p,
  openInTab: a,
  bottomContent: d,
  children: b,
  showCarrierName: i
}) => {
  const r = pr({ cents: u.open_amount_in_cents, locale: x }), c = new Intl.NumberFormat(x).format(u.donations_count), e = x === "de" ? "fehlen noch" : "still needed", t = x === "de" ? "Spenden" : "donations", o = m || u.links.find((h) => h.rel === "platform")?.href, y = u.profile_picture?.links.find((h) => h.rel === "fill_410x214")?.href, g = u.carrier?.picture?.links.find((h) => h.rel === "fill_100x100")?.href, n = (h) => {
    f?.(h, u);
  };
  return /* @__PURE__ */ J(
    "a",
    {
      title: u.title ? He(u.title) : "",
      onClick: n,
      className: `donatable-teaser ${l ?? ""} ${p ? "donatable-teaser--with-description" : ""} ${d ? "donatable-teaser--with-bottom-content" : ""}`,
      href: o,
      target: a ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        b,
        /* @__PURE__ */ P(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${y})` },
            title: u.title ? He(u.title) : ""
          }
        ),
        /* @__PURE__ */ P(je, { as: "h2", className: "donatable-teaser--title", value: u.title }),
        p && /* @__PURE__ */ P(je, { className: "donatable-teaser--description", as: "div", value: u.description }),
        /* @__PURE__ */ J("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ J("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ J("div", { children: [
              u.city && /* @__PURE__ */ J(Wt, { children: [
                /* @__PURE__ */ P("span", { children: u.city }),
                ",",
                " "
              ] }),
              u.country
            ] }),
            /* @__PURE__ */ P("div", { children: i ? /* @__PURE__ */ P("span", { children: u.carrier?.name }) : /* @__PURE__ */ J(Wt, { children: [
              /* @__PURE__ */ P("span", { children: c }),
              " ",
              t
            ] }) }),
            /* @__PURE__ */ J("div", { children: [
              /* @__PURE__ */ P("span", { children: r }),
              " ",
              e
            ] })
          ] }),
          /* @__PURE__ */ P("img", { src: g, alt: u.carrier?.name, className: "donatable-teaser--carrier-logo" })
        ] }),
        /* @__PURE__ */ P("div", { className: "donatable-teaser--progress", children: /* @__PURE__ */ P("div", { className: "donatable-teaser--progress-bar", style: { width: `${u.progress_percentage}%` } }) }),
        d
      ]
    }
  );
}, si = (u, x) => x === 1 ? u === "de" ? "Spende" : "donation" : u === "de" ? "Spenden" : "donations", Pi = ({
  fundraisingEvent: u,
  locale: x = document.documentElement.lang || "de",
  href: m,
  onClick: f,
  openInTab: l,
  children: p
}) => {
  const a = m || u.links.find((e) => e.rel === "platform")?.href, d = u.profile_picture?.links.find(
    (e) => e.rel === "fill_410x214"
  )?.href, b = pr({ cents: u.donated_amount_in_cents, locale: x }), i = u.contact?.picture?.links.find((e) => e.rel === "fill_100x100")?.href, r = (e) => {
    f?.(e, u);
  }, c = si(x, u.donations_count);
  return /* @__PURE__ */ J(
    "a",
    {
      title: u.title ? He(u.title) : "",
      onClick: r,
      className: "donatable-teaser",
      href: a,
      target: l ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        p,
        /* @__PURE__ */ P(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${d})` },
            title: u.title ? He(u.title) : ""
          }
        ),
        /* @__PURE__ */ P(je, { as: "h2", className: "donatable-teaser--title", value: u.title }),
        /* @__PURE__ */ J("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ J("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ P("div", { children: /* @__PURE__ */ P(je, { as: "span", value: u.contact?.name }) }),
            /* @__PURE__ */ J("div", { children: [
              /* @__PURE__ */ P("span", { children: u.donations_count }),
              " ",
              c
            ] }),
            /* @__PURE__ */ J("div", { children: [
              /* @__PURE__ */ P("span", { children: b }),
              " ",
              x === "de" ? "gesammelt" : "collected"
            ] })
          ] }),
          /* @__PURE__ */ P(
            "img",
            {
              style: { borderRadius: "50%", border: "1px solid #cccccc" },
              src: i,
              alt: u.contact?.name ?? "",
              className: "donatable-teaser--carrier-logo"
            }
          )
        ] })
      ]
    }
  );
}, oi = ({
  icon: u,
  content: x,
  className: m = "",
  boxShadow: f,
  buttonClassName: l = "",
  ...p
}) => {
  const a = u;
  return /* @__PURE__ */ J(
    "a",
    {
      ...p,
      className: `share-button--full ${f ? "share-button--box-shadowed" : ""} ${l} ${m}`,
      children: [
        /* @__PURE__ */ P("div", { className: "share-button--full-icon-wrapper", children: /* @__PURE__ */ P(a, { className: "share-button--icon" }) }),
        /* @__PURE__ */ P("span", { className: "share-button--text", children: x })
      ]
    }
  );
}, ci = ({
  icon: u,
  content: x,
  className: m = "",
  buttonClassName: f = "",
  boxShadow: l,
  ...p
}) => {
  const a = u;
  return /* @__PURE__ */ J("a", { ...p, className: `share-button--minimal ${f} ${m}`, children: [
    /* @__PURE__ */ P(a, { className: "share-button--icon" }),
    /* @__PURE__ */ P("span", { className: "share-button--text", children: x })
  ] });
}, li = ({ icon: u, className: x = "", boxShadow: m, buttonClassName: f = "", ...l }) => {
  const p = u;
  return /* @__PURE__ */ P(
    "a",
    {
      ...l,
      className: `share-button--round ${m ? "share-button--box-shadowed" : ""} ${f} ${x}`,
      children: /* @__PURE__ */ P(p, {})
    }
  );
}, fi = ({
  icon: u,
  className: x = "",
  buttonClassName: m = "",
  boxShadow: f,
  ...l
}) => {
  const p = u;
  return /* @__PURE__ */ P("a", { ...l, className: `share-button--square ${m} ${x}`, children: /* @__PURE__ */ P(p, {}) });
}, di = ({
  icon: u,
  content: x,
  className: m = "",
  boxShadow: f,
  buttonClassName: l = "",
  ...p
}) => {
  const a = u;
  return /* @__PURE__ */ J("div", { className: `share-button--round-with-label ${m}`, children: [
    /* @__PURE__ */ P(
      "a",
      {
        ...p,
        className: `share-button--round ${f ? "share-button--box-shadowed" : ""} ${l}`,
        children: /* @__PURE__ */ P(a, {})
      }
    ),
    x
  ] });
}, hi = {
  full: oi,
  minimal: ci,
  round: li,
  square: fi,
  roundWithLabel: di
}, xe = ({
  action: u,
  ariaLabel: x,
  buttonLabel: m,
  className: f,
  icon: l
}) => (a) => {
  const d = hi[a.shape], b = (i) => {
    i.preventDefault(), a.beforeOnClick?.(i), u(a);
  };
  return /* @__PURE__ */ P(
    d,
    {
      "aria-label": x,
      boxShadow: a.boxShadow,
      className: a.className || "",
      buttonClassName: f,
      href: "#",
      onClick: b,
      role: "button",
      title: a.title || "",
      label: m || x,
      icon: l,
      content: a.content
    }
  );
}, pi = ({ size: u = "60%" }) => /* @__PURE__ */ P(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ P(
      "path",
      {
        fill: "currentColor",
        d: "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
      }
    )
  }
), bi = ({ size: u = "60%" }) => /* @__PURE__ */ P(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264 512",
    children: /* @__PURE__ */ P(
      "path",
      {
        fill: "currentColor",
        d: "M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
      }
    )
  }
), mi = ({ size: u = "60%" }) => /* @__PURE__ */ P(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ P(
      "path",
      {
        fill: "currentColor",
        d: "M224 32C15.9 32-77.5 278 84.6 400.6V480l75.7-42c142.2 39.8 285.4-59.9 285.4-198.7C445.8 124.8 346.5 32 224 32zm23.4 278.1L190 250.5 79.6 311.6l121.1-128.5 57.4 59.6 110.4-61.1-121.1 128.5z"
      }
    )
  }
), gi = ({ size: u = "60%" }) => /* @__PURE__ */ P(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ P(
      "path",
      {
        fill: "currentColor",
        d: "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
      }
    )
  }
), yi = ({ size: u = "60%" }) => /* @__PURE__ */ P(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ P(
      "path",
      {
        fill: "currentColor",
        d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
      }
    )
  }
), vi = ({ size: u = "60%" }) => /* @__PURE__ */ P(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700",
    children: /* @__PURE__ */ J("g", { children: [
      /* @__PURE__ */ P(
        "path",
        {
          fill: "currentColor",
          d: `M337.5,448c-5.7,0-11.4-1.7-16.4-5.2c-5.6-3.9-10.8-8.5-15.5-13.5l-19.3-20.6c-48.9-52.1-46.2-134.3,5.9-183.2l95-89.1
		c52.1-48.9,134.3-46.2,183.2,5.9c48.9,52.1,46.2,134.3-5.9,183.2l-31.8,29.8c-11.5,10.8-29.6,10.2-40.4-1.3
		c-10.8-11.5-10.2-29.6,1.3-40.4l31.8-29.8c29.2-27.3,30.7-73.3,3.3-102.5c-27.3-29.2-73.3-30.7-102.5-3.3l-95,89.1
		c-29.2,27.3-30.7,73.3-3.3,102.5l19.3,20.6c2,2.2,4.3,4.1,6.7,5.9c12.9,9.1,16,26.9,6.9,39.8C355.3,443.8,346.5,448,337.5,448z`
        }
      ),
      /* @__PURE__ */ P(
        "path",
        {
          fill: "currentColor",
          d: `M245.8,617.8c-34.6,0-69.1-13.7-94.6-40.9c-48.9-52.1-46.2-134.3,5.9-183.2l31.8-29.8c11.5-10.8,29.6-10.2,40.4,1.3
		c10.8,11.5,10.2,29.6-1.3,40.4l-31.8,29.8c-29.2,27.3-30.7,73.3-3.3,102.5c27.3,29.2,73.3,30.7,102.5,3.3l95-89.1
		c29.2-27.3,30.7-73.3,3.3-102.5L374.4,329c-2-2.2-4.3-4.1-6.7-5.9c-12.9-9.1-16-26.9-6.9-39.8c9.1-12.9,26.9-16,39.8-6.9
		c5.6,3.9,10.8,8.5,15.5,13.5l19.3,20.6c48.9,52.1,46.2,134.3-5.9,183.2l-95,89.1C309.5,606.3,277.6,617.8,245.8,617.8z`
        }
      )
    ] })
  }
), xi = ({ size: u = "60%" }) => /* @__PURE__ */ J(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.486 40.912",
    children: [
      /* @__PURE__ */ P(
        "path",
        {
          fill: "currentColor",
          d: "M95.09,109.768c.137-.971.242-1.947.417-2.911.991-5.459,4.855-9.173,10.381-9.364,6.654-.229,13.327-.241,19.98,0a10.692,10.692,0,0,1,10.558,10.687q.3,9.583,0,19.182a10.691,10.691,0,0,1-10.558,10.687c-6.653.24-13.328.246-19.98,0-6.016-.226-10.174-4.69-10.576-10.715-.035-.521-.147-1.038-.223-1.557Zm20.749,24.713c3.045,0,6.092.091,9.133-.021,4.767-.177,7.7-3.022,7.811-7.785q.207-8.9,0-17.812c-.111-4.762-3.046-7.673-7.811-7.775q-9.072-.192-18.151,0c-4.729.1-7.67,2.952-7.8,7.661q-.245,9.014,0,18.039c.128,4.709,3.069,7.5,7.8,7.671C109.823,134.572,112.832,134.482,115.839,134.482Zm0,0",
          transform: "translate(-95.09 -97.317)"
        }
      ),
      /* @__PURE__ */ P(
        "path",
        {
          fill: "currentColor",
          d: "M184.564,174a10.572,10.572,0,1,0,10.572,10.571A10.572,10.572,0,0,0,184.564,174Zm0,17.5a6.932,6.932,0,1,1,6.932-6.932A6.932,6.932,0,0,1,184.564,191.5Zm0,0",
          transform: "translate(-163.821 -164.111)"
        }
      ),
      /* @__PURE__ */ P(
        "path",
        {
          fill: "currentColor",
          d: "M328.315,153.258a2.515,2.515,0,1,1-2.515-2.515A2.515,2.515,0,0,1,328.315,153.258Zm0,0",
          transform: "translate(-293.868 -143.855)"
        }
      )
    ]
  }
);
function wi(u) {
  return u.toLowerCase().startsWith("utm_");
}
const Si = (u) => new URLSearchParams(Object.entries(u).filter(([m, f]) => f !== void 0)), zt = (u, x = {}) => {
  if (!u) return u;
  const m = u.startsWith("http") ? u : `https://${u}`, f = new URL(m);
  return f.searchParams.forEach((p, a, d) => {
    wi(a) && d.delete(a);
  }), Si(x).forEach((p, a) => f.searchParams.set(a, p)), f.toString();
}, Oe = (u, x = {}, m = "") => {
  const f = zt(u, x);
  return encodeURIComponent(m + f);
}, br = (u) => window.open(u, "sharer", "toolbar=no,width=1042,height=436"), mr = (u) => {
  const x = document.createElement("textarea");
  x.value = u, document.body.appendChild(x), x.select();
  const m = document.execCommand("copy");
  if (document.body.removeChild(x), !m) {
    const l = (document.documentElement.lang || "de") === "de" ? "Sorry, dein Browser unterstützt diese Funktion nicht." : "Sorry, your Browser doesn't support this feature.";
    alert(l);
  }
  return m;
}, gr = () => /(android|iphone|ipad|mobile)/i.test(navigator.userAgent), Ei = ({
  shareUrl: u,
  subject: x = null,
  teaser: m = "",
  utmParams: f
}) => {
  const l = encodeURIComponent(x || m), p = Oe(u, f, `${m} `);
  return window.open(`mailto:?subject=${l}&body=${p}`, "_self");
}, ki = xe({
  action: Ei,
  ariaLabel: "Email",
  className: "share-button--email",
  icon: pi
}), Ti = ({ shareUrl: u, utmParams: x }) => br(`https://www.facebook.com/sharer/sharer.php?u=${Oe(u, x)}`), Mi = xe({
  action: Ti,
  ariaLabel: "Facebook",
  className: "share-button--facebook",
  icon: bi
}), Ai = ({
  facebookAppId: u,
  shareUrl: x,
  utmParams: m
}) => {
  const f = gr(), l = Oe(x, m);
  return f ? window.open(`fb-messenger://share?link=${l}&app_id=${u}`) : br(
    `http://www.facebook.com/dialog/send?app_id=${u}&link=${l}&redirect_uri=${encodeURIComponent(x)}`
  );
}, Bi = xe({
  action: Ai,
  ariaLabel: "Facebook Messenger",
  buttonLabel: "Messenger",
  className: "share-button--facebook-messenger",
  icon: mi
}), qi = ({ shareUrl: u, teaser: x = "", utmParams: m }) => window.open(
  `https://telegram.me/share/url?url=${Oe(u, m)}&text=${encodeURIComponent(x)}`
), Ui = xe({
  action: qi,
  ariaLabel: "Telegram",
  className: "share-button--telegram",
  icon: gi
}), Ni = ({ shareUrl: u, utmParams: x }) => window.open(
  `https://${gr() ? "api" : "web"}.whatsapp.com/send?text=${Oe(u, x)}`
), ji = xe({
  action: Ni,
  ariaLabel: "WhatsApp",
  className: "share-button--whatsapp",
  icon: yi
}), Oi = ({ shareUrl: u, utmParams: x }) => {
  mr(zt(u, x));
}, Hi = xe({
  action: Oi,
  ariaLabel: "ShareLink",
  buttonLabel: "Link",
  className: "share-button--share-link",
  icon: vi
}), Li = ({ shareUrl: u, utmParams: x }) => {
  mr(zt(u, x));
}, Vi = xe({
  action: Li,
  ariaLabel: "Instagram",
  className: "share-button--instagram",
  icon: xi
}), Fi = (u, x) => u.replace(
  /\w\w/g,
  (m) => ("0" + Math.min(255, Math.max(0, parseInt(m, 16) + x)).toString(16)).substr(-2)
);
export {
  ki as EmailButton,
  Mi as FacebookButton,
  Bi as FacebookMessengerButton,
  Pi as FundraisingEventTeaser,
  Vi as InstagramButton,
  Hi as LinkButton,
  Ri as ProjectTeaser,
  Ui as TelegramButton,
  ji as WhatsappButton,
  Fi as changeBrightness,
  mr as copyToClipboard,
  Ei as emailShareAction,
  Oe as encodeShareURL,
  Ai as facebookMessengerShareAction,
  Ti as facebookShareAction,
  pr as formatAmount,
  zt as getShareURL,
  Li as instagramAction,
  gr as isMobileOrTablet,
  Oi as linkAction,
  br as openPopup,
  qi as telegramShareAction,
  Si as toSearchParams,
  Ni as whatsappShareAction
};
